/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from './graphql-schema-types';

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * Physical address type representation.
   * Contains the following fields:
   * * country
   * * city
   * * state
   * * streetName
   * * streetNumber
   * * additionalInfo
   * * zipCode
   */
  Address: { input: any; output: any; }
  /** BonusCode to be applied in the checkout */
  BonusCode: { input: string; output: string; }
  /** A phone number country code representation. Must match: `^\+[1-9]\d{0,2}$` */
  CountryCode: { input: string; output: string; }
  /** A customer id which matches the following regular expression: `^[A-Z]{2}-\d{3}-\d{3}-\d{3}$` */
  CustomerId: { input: string; output: string; }
  /** An RFC-3339 compliant Full Date Scalar */
  Date: { input: string; output: string; }
  /** A slightly refined version of RFC-3339 compliant DateTime Scalar */
  DateTime: { input: string; output: string; }
  /** DrawnNumbersGroup used to group drawn numbers of a lottery by name (for example GREENBALL, DOUBLE_DRAW */
  DrawnNumbersGroup: { input: string; output: string; }
  /** An e-mail address which matches the following regular expression: `^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~.-]+@([a-zA-Z0-9-]+\.)+[a-zA-Z0-9-]{2,}$` */
  EMailAddress: { input: string; output: string; }
  /** Idempotency key used for deduplication of requests */
  IdempotencyKey: { input: string; output: string; }
  /** ISO 8601 compliant Instant scalar */
  Instant: { input: string; output: string; }
  /** A locale with at least a language code (ISO 639-1). */
  LanguageTag: { input: string; output: string; }
  /** A country as defined in ISO-3166-1-alpha2 (e.g. US) or a country subdivision as defined in ISO 3166-2 (e.g. US-NJ). */
  LicensedTerritory: { input: string; output: string; }
  /** 24-hour clock time value string in the format `hh:mm:ss` or `hh:mm:ss.sss`. */
  LocalTime: { input: string; output: string; }
  /** A 64-bit signed integer */
  Long: { input: number; output: number; }
  /** A name. Must match the regular expression `^[\p{Ll}\p{Lu}][\p{Ll}\p{Lu}'.\- ]{0,38}[\p{Ll}\p{Lu}.]$`. */
  Name: { input: string; output: string; }
  /** The national number part of a phone number. Must match: `^[1-9]\d{4,13}$` */
  NationalNumber: { input: string; output: string; }
  /** OrderId used to identify an order (buy play slip) of a player */
  OrderId: { input: string; output: string; }
  /** ProductId used to identify a particular play slip */
  ProductId: { input: string; output: string; }
  /** human readable subscription code to identify a subscription */
  SubscriptionCode: { input: string; output: string; }
  /** A universally unique identifier compliant UUID Scalar */
  UUID: { input: string; output: string; }
  /** A valid URL. */
  Url: { input: string; output: string; }
};

/** Account of the owner */
export type AccountPayload = {
  __typename?: 'AccountPayload';
  balance: Money;
  id: Scalars['ID']['output'];
  limits: Limits;
  ownerId: Scalars['String']['output'];
};

export type AcknowledgeTacPayload = {
  __typename?: 'AcknowledgeTACPayload';
  timestamp: Scalars['Instant']['output'];
};

export type ActivePlaySlip = PlaySlip & {
  __typename?: 'ActivePlaySlip';
  firstDrawDate: Scalars['DateTime']['output'];
  hasWinnings: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  lastDrawDate: Scalars['DateTime']['output'];
  licensedTerritory: Scalars['String']['output'];
  lotteryId: LotteryId;
  nextDrawDate: Scalars['DateTime']['output'];
  numberOfDraws: Scalars['Int']['output'];
  numberOfPlays: Scalars['Int']['output'];
  orderId: Scalars['String']['output'];
  orderedAt: Scalars['DateTime']['output'];
  remainingDraws: Scalars['Int']['output'];
  selectedAddOns: Array<Scalars['String']['output']>;
  serialNumber: Scalars['String']['output'];
  status: PlaySlipStatus;
  /** @deprecated Please check for (optional) subscriptionInfo instead */
  subscription: Scalars['Boolean']['output'];
  subscriptionInfo?: Maybe<SubscriptionInfo>;
  totalWinAmount: Money;
};

export type ActivePlaySlipOrder = PlaySlipOrder & {
  __typename?: 'ActivePlaySlipOrder';
  firstDrawDate: Scalars['DateTime']['output'];
  hasWinnings: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  lastDrawDate: Scalars['DateTime']['output'];
  licensedTerritory: Scalars['String']['output'];
  lotteryId: LotteryId;
  nextDrawDate: Scalars['DateTime']['output'];
  numberOfDraws: Scalars['Int']['output'];
  numberOfExtraHitPlays: Scalars['Int']['output'];
  numberOfPlays: Scalars['Int']['output'];
  orderId: Scalars['String']['output'];
  orderedAt: Scalars['DateTime']['output'];
  remainingDraws: Scalars['Int']['output'];
  replayable: Scalars['Boolean']['output'];
  selectedAddOns: Array<Scalars['String']['output']>;
  serialNumber: Scalars['String']['output'];
  status: PlaySlipOrderStatus;
  subscriptionInfo?: Maybe<SubscriptionInfo>;
  totalWinAmount: Money;
};

export type AddFundsConfigPayload = {
  __typename?: 'AddFundsConfigPayload';
  fees: AddFundsFees;
  limits: AddFundsLimits;
  payment: AddFundsPayment;
  pricePoints: Array<PricePoint>;
  productId?: Maybe<Scalars['String']['output']>;
  withCustomAmount: Scalars['Boolean']['output'];
};

export type AddFundsFees = {
  __typename?: 'AddFundsFees';
  dynamicFee: Scalars['Int']['output'];
  staticFee: Money;
};

export type AddFundsInput = {
  amount: MoneyInput;
  productId: Scalars['String']['input'];
};

export type AddFundsLimits = {
  __typename?: 'AddFundsLimits';
  maxPayInAmount: Money;
  minPayInAmount: Money;
};

export type AddFundsMutationInput = {
  amount: MoneyInput;
  idempotencyKey: Scalars['String']['input'];
  licensedTerritory: Scalars['String']['input'];
  locationData: LocationDataInput;
  paymentData: PaymentDataInput;
  productId?: InputMaybe<Scalars['String']['input']>;
};

export type AddFundsPayment = {
  __typename?: 'AddFundsPayment';
  initial: Array<InitialPaymentInstrument>;
  paymentId: Scalars['String']['output'];
  stored: Array<StoredPaymentInstrument>;
};

export enum AddFundsState {
  Failed = 'FAILED',
  Finished = 'FINISHED',
  Processing = 'PROCESSING'
}

export type AddFundsStatusPayload = {
  __typename?: 'AddFundsStatusPayload';
  id: Scalars['String']['output'];
  isFirstPurchase: Scalars['Boolean']['output'];
  status: AddFundsState;
};

export type AddInstrumentPaymentDataInput = {
  accountId: Scalars['String']['input'];
  provider: Scalars['String']['input'];
  providerData: Array<PaymentDataEntryInput>;
  specificType?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type AddOn = {
  __typename?: 'AddOn';
  /** Must a value for this add-on be selected? */
  mandatory: Scalars['Boolean']['output'];
  /** If this add-on has an additional price, the name must match the name of a price */
  name: Scalars['String']['output'];
  /** Selectable options for this add-on. For example the bet types of the Pick3 lottery */
  options: Array<Scalars['String']['output']>;
  /** Is this add-on configurable per play? */
  perPlay: Scalars['Boolean']['output'];
};

export type AddOnInput = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type AddOnOutput = {
  __typename?: 'AddOnOutput';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type AddOnSummary = {
  __typename?: 'AddOnSummary';
  name: Scalars['String']['output'];
  price: MoneySummary;
};

export type AddOnWithValue = {
  __typename?: 'AddOnWithValue';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type AddPayOutAccountInput = {
  idempotencyKey: Scalars['String']['input'];
  licensedTerritory: Scalars['String']['input'];
  providerSpecificData: Array<ProviderSpecificDataEntryInput>;
  type: PayOutAccountType;
};

export type AddPayOutAccountPayload = {
  __typename?: 'AddPayOutAccountPayload';
  id: Scalars['String']['output'];
};

export type AddPaymentInstrumentInput = {
  licensedTerritory: Scalars['String']['input'];
  paymentData: AddInstrumentPaymentDataInput;
};

export type AddPaymentInstrumentPayload = {
  __typename?: 'AddPaymentInstrumentPayload';
  /** false if an existing instrument was updated, true if a new one was created */
  created: Scalars['Boolean']['output'];
  success: Scalars['Boolean']['output'];
};

export type AeropayConfirmMfaInput = {
  licensedTerritory: Scalars['String']['input'];
  mfaCode: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type AeropayConfirmMfaPayload = {
  __typename?: 'AeropayConfirmMfaPayload';
  preferredPayOutAccountId?: Maybe<Scalars['String']['output']>;
};

export type AeropayExistingUser = AeropayRegisterUserPayload & {
  __typename?: 'AeropayExistingUser';
  displayMessage: Scalars['String']['output'];
  /** The email address that Aeropay has associated with the user, masked for privacy. */
  email: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type AeropayNewUser = AeropayRegisterUserPayload & {
  __typename?: 'AeropayNewUser';
  aggregatorToken: Scalars['String']['output'];
  consumerId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type AeropayRegisterUserInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  licensedTerritory: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type AeropayRegisterUserPayload = {
  userId: Scalars['String']['output'];
};

export type AeropayReturningUser = AeropayRegisterUserPayload & {
  __typename?: 'AeropayReturningUser';
  /** The email address that Aeropay has associated with the user, masked for privacy. */
  preferredPayOutAccountId?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type AlwaysActivePrizeTierCategoryRequirements = PrizeTierCategoryRequirements & {
  __typename?: 'AlwaysActivePrizeTierCategoryRequirements';
  type: PrizeTierCategoryRequirementsPayloadType;
};

export type AnnouncementQueryResponse = {
  __typename?: 'AnnouncementQueryResponse';
  active: Scalars['Boolean']['output'];
  changeDate: Scalars['Instant']['output'];
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  licensedTerritories: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type ApplePayMerchantValidationInput = {
  licensedTerritory: Scalars['String']['input'];
};

export type ApplePayMerchantValidationPayload = {
  __typename?: 'ApplePayMerchantValidationPayload';
  /** Base64 encoded Apple Pay payment session object */
  encodedPaymentSession: Scalars['String']['output'];
};

export enum BadgeType {
  Fire = 'Fire',
  New = 'New',
  Pie = 'Pie',
  PriceTag = 'PriceTag',
  Star = 'Star',
  Text = 'Text'
}

export type BankPayOutInput = {
  accountNumber: Scalars['String']['input'];
  amount: MoneyInput;
  idempotencyKey: Scalars['String']['input'];
  licensedTerritory: Scalars['String']['input'];
  routingNumber: Scalars['String']['input'];
};

export type BasePlayMultipleLines = PlayMultipleLines & {
  __typename?: 'BasePlayMultipleLines';
  /** A list of addons with values of the play slip for the respective draw */
  addOnValues: Array<AddOnOutput>;
  /** A list of all available addons for this draw's lottery */
  addOns: Array<AddOnOutput>;
  /** The list of fields with matches (if evaluated) */
  fields: Array<FieldWithMatches>;
  /** The serial number of the play slip */
  serialNumber: Scalars['String']['output'];
  /** The status of the play slip */
  state: PlaySlipStatus;
  /** The monetary or free ticket winnings (if evaluated) */
  winnings: WinningMultipleLines;
};

export type BonusCodeInfoPayload = {
  __typename?: 'BonusCodeInfoPayload';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  /** The date when the promotion expires */
  endDate: Scalars['Instant']['output'];
  title: Scalars['String']['output'];
  /** The type of promotion */
  type: BonusTypeEnum;
  /** Description of the discount that is applied when using the bonus code */
  value: BonusValuePayload;
};

export type BonusCodeRemovalPayload = {
  __typename?: 'BonusCodeRemovalPayload';
  bonusCode: Scalars['String']['output'];
};

export type BonusCodeValidationInput = {
  /** Will be converted to uppercase and dashes will be removed */
  bonusCode: Scalars['String']['input'];
  licensedTerritory: Scalars['String']['input'];
  /** The play slip's lottery ID */
  lotteryId: Scalars['String']['input'];
  /** The price breakdown for play slips */
  priceBreakdown: PlaySlipPriceBreakdownInput;
};

export enum BonusTypeEnum {
  Discount = 'DISCOUNT',
  FreePlay = 'FREE_PLAY'
}

export type BonusValidationResult = {
  __typename?: 'BonusValidationResult';
  /** The discount to apply to the order's charges */
  discount: Money;
  /** True if all conditions could be fulfilled by player actions, e.g. adding more plays */
  fulfillable: Scalars['Boolean']['output'];
  /** True if all conditions are fulfilled */
  fulfilled: Scalars['Boolean']['output'];
  info: BonusCodeInfoPayload;
  /** The minimum purchase amount for the bonus to be valid (or null if no such condition exists) */
  minTotalCharge?: Maybe<Money>;
  /**
   *
   *         A list of error codes to translate. The most important issue will be returned as the first element of the list.
   *
   *         Possible values:
   *           - validation.bonusconditions.customerstatus.new: The promotion only applies to new customers
   *           - validation.bonusconditions.customerstatus.returning: The promotion only applies to returning customers
   *           - validation.bonusconditions.customerstatus.listed: The promotion only applies to a specific set of customer ids
   *           - validation.bonusconditions.lotteries: If the current lottery is not in the list of allowed lotteries for this promotion
   *           - validation.bonusconditions.maxplays: If the play slip contains more than the maximum number of plays allowed for this promotion
   *           - validation.bonusconditions.minplays: If the play slip contains less than the maximum number of plays allowed for this promotion
   *           - validation.bonusconditions.mintotalcharge: If the play slip's gross total price is lower than allowed for this promotion
   *           - validation.bonusconditions.loginrequired: If the user is not logged in but the promotion requires them to be
   *           - validation.bonusconditions.licensedterritory: If the promotion is only valid in another licensed territory
   *           - validation.bonusconditions.scratchcardgames: If the current scratchcard game is not in the list of allowed scratchcard games for this promotion
   *
   */
  unfulfilledConditions: Array<Scalars['String']['output']>;
};

export enum BonusValueEnum {
  Absolute = 'ABSOLUTE',
  Percentage = 'PERCENTAGE'
}

export type BonusValuePayload = {
  __typename?: 'BonusValuePayload';
  amount: Scalars['Long']['output'];
  maxMonetaryValue?: Maybe<Money>;
  type: BonusValueEnum;
};

export type ByAddOnSelected = PrizeTierCategoryRequirements & {
  __typename?: 'ByAddOnSelected';
  addOnName: Scalars['String']['output'];
  /** @deprecated Please use addOnName */
  addonName?: Maybe<Scalars['String']['output']>;
  type: PrizeTierCategoryRequirementsPayloadType;
};

export type ByMultiplierDeselected = PrizeTierCategoryRequirements & {
  __typename?: 'ByMultiplierDeselected';
  addOnName: Scalars['String']['output'];
  type: PrizeTierCategoryRequirementsPayloadType;
};

export type ByMultiplierSelected = PrizeTierCategoryRequirements & {
  __typename?: 'ByMultiplierSelected';
  addOnName: Scalars['String']['output'];
  group: Scalars['DrawnNumbersGroup']['output'];
  /** @deprecated Legacy prefixed name, use 'reference' instead */
  numberReference: Scalars['String']['output'];
  reference: Scalars['String']['output'];
  type: PrizeTierCategoryRequirementsPayloadType;
  value: Scalars['Int']['output'];
};

export type ByMultiplierValueMatched = PrizeTierCategoryRequirements & {
  __typename?: 'ByMultiplierValueMatched';
  addOnName: Scalars['String']['output'];
  type: PrizeTierCategoryRequirementsPayloadType;
  value: Scalars['Int']['output'];
};

export type CampaignBadgePayload = {
  __typename?: 'CampaignBadgePayload';
  bonusCode?: Maybe<Scalars['String']['output']>;
  infoHeadline?: Maybe<Scalars['String']['output']>;
  infoText?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: BadgeType;
};

export type CampaignHeroHighlightBadgePayload = {
  __typename?: 'CampaignHeroHighlightBadgePayload';
  bonusCode?: Maybe<Scalars['String']['output']>;
  color: Scalars['String']['output'];
  infoHeadline?: Maybe<Scalars['String']['output']>;
  infoText?: Maybe<Scalars['String']['output']>;
  placement: HeroHighlightStyle;
  subtitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type CampaignHeroHighlightPayload = {
  __typename?: 'CampaignHeroHighlightPayload';
  badge: CampaignHeroHighlightBadgePayload;
  pattern: HeroHighlightPattern;
};

export type CampaignPayload = CampaignBadgePayload | CampaignHeroHighlightPayload;

export enum CancelReasonType {
  AccountBalanceChanged = 'ACCOUNT_BALANCE_CHANGED',
  InstrumentAlreadyInUse = 'INSTRUMENT_ALREADY_IN_USE',
  PaymentFailed = 'PAYMENT_FAILED',
  ProductPurchaseFailed = 'PRODUCT_PURCHASE_FAILED',
  ProductUnavailable = 'PRODUCT_UNAVAILABLE'
}

export type CancelledOrder = Order & {
  __typename?: 'CancelledOrder';
  bonus?: Maybe<OrderBonus>;
  cancelReasonType: CancelReasonType;
  firstPayIn: Scalars['Boolean']['output'];
  orderId: Scalars['OrderId']['output'];
  playSlip: PlaySlipPayload;
  reference: Scalars['String']['output'];
  status: OrderStatus;
};

export type ChangePlayerDataInput = {
  locale: Scalars['LanguageTag']['input'];
};

export type ChangePlayerDataPayload = {
  __typename?: 'ChangePlayerDataPayload';
  locale: Scalars['LanguageTag']['output'];
};

/** The new configuration of the player. */
export type ChangeTwoFactorConfigurationPayload = {
  __typename?: 'ChangeTwoFactorConfigurationPayload';
  channels: Array<TwoFactorAuthenticationChannelSettingPayload>;
};

export type ChannelPayload = {
  __typename?: 'ChannelPayload';
  channel: NotificationChannel;
  selected: Scalars['Boolean']['output'];
};

export type Charge = FixedCharge | MultiplyingCharge;

export type ChargeForAddOn = {
  __typename?: 'ChargeForAddOn';
  baseCharge: Money;
  fee: Money;
  name: Scalars['String']['output'];
  total: Money;
};

export type ChargeForAddOnInput = {
  baseCharge: MoneyInput;
  fee: MoneyInput;
  name: Scalars['String']['input'];
  total: MoneyInput;
};

export type ChargeForPlay = {
  __typename?: 'ChargeForPlay';
  addOns: Array<ChargeForAddOn>;
  baseCharge: Money;
  extraInfo?: Maybe<Scalars['String']['output']>;
  fee: Money;
  name: Scalars['String']['output'];
};

export type ChargeForPlayInput = {
  addOns: Array<ChargeForAddOnInput>;
  baseCharge: MoneyInput;
  extraInfo?: InputMaybe<Scalars['String']['input']>;
  fee: MoneyInput;
  name: Scalars['String']['input'];
  total: MoneyInput;
};

export type CheckRoutingNumberPayload = {
  __typename?: 'CheckRoutingNumberPayload';
  bankName?: Maybe<Scalars['String']['output']>;
  isKnown: Scalars['Boolean']['output'];
  routingNumber: Scalars['String']['output'];
};

export enum CheckoutNotification {
  /** Player is located in a neighbour state */
  NeighbourState = 'NEIGHBOUR_STATE'
}

export type CheckoutPayload = {
  __typename?: 'CheckoutPayload';
  accountBalance: Money;
  bonusCode?: Maybe<Scalars['String']['output']>;
  /** The expiration timestamp of the applied bonus code, if any */
  bonusCodeExpires?: Maybe<Scalars['DateTime']['output']>;
  /** Discount applied via bonus codes */
  discount?: Maybe<Money>;
  locationCheckExpires?: Maybe<Scalars['DateTime']['output']>;
  notification?: Maybe<CheckoutNotification>;
  payment?: Maybe<Payment>;
  product?: Maybe<Product>;
  restrictions?: Maybe<Restrictions>;
  state: CheckoutState;
  /** The total price, including sales tax, with the discount applied */
  totalPriceAfterDiscount?: Maybe<Money>;
};

export enum CheckoutState {
  /** Order is ready to be checked out */
  Ok = 'OK',
  /** The requested product is not (yet) known to the checkout */
  Pending = 'PENDING',
  /** Player is not allowed to perform checkout because of state or geo restrictions */
  Restricted = 'RESTRICTED'
}

/** Optional data to close a player. */
export type ClosePlayerInput = {
  licensedTerritory: Scalars['LicensedTerritory']['input'];
  /**
   * The reason why the player wants to close his account.
   * | The length must be between 1 and 2000 characters: `^.{1,2000}$`
   *
   */
  reason?: InputMaybe<Scalars['String']['input']>;
};

/** Result of a 'closePlayer' mutation. If the request went successfully, the new player status will be `Closed`. */
export type ClosePlayerPayload = {
  __typename?: 'ClosePlayerPayload';
  /** The new status of the player. */
  status: Status;
};

export type ClosedPlaySlip = PlaySlip & {
  __typename?: 'ClosedPlaySlip';
  firstDrawDate: Scalars['DateTime']['output'];
  hasWinnings: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  lastDrawDate: Scalars['DateTime']['output'];
  licensedTerritory: Scalars['String']['output'];
  lotteryId: LotteryId;
  nextDrawDate: Scalars['DateTime']['output'];
  numberOfDraws: Scalars['Int']['output'];
  numberOfPlays: Scalars['Int']['output'];
  orderId: Scalars['String']['output'];
  orderedAt: Scalars['DateTime']['output'];
  selectedAddOns: Array<Scalars['String']['output']>;
  serialNumber: Scalars['String']['output'];
  status: PlaySlipStatus;
  /** @deprecated Please check for (optional) subscriptionInfo instead */
  subscription: Scalars['Boolean']['output'];
  subscriptionInfo?: Maybe<SubscriptionInfo>;
  totalWinAmount: Money;
};

export type ClosedPlaySlipOrder = PlaySlipOrder & {
  __typename?: 'ClosedPlaySlipOrder';
  firstDrawDate: Scalars['DateTime']['output'];
  hasWinnings: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  lastDrawDate: Scalars['DateTime']['output'];
  licensedTerritory: Scalars['String']['output'];
  lotteryId: LotteryId;
  nextDrawDate: Scalars['DateTime']['output'];
  numberOfDraws: Scalars['Int']['output'];
  numberOfExtraHitPlays: Scalars['Int']['output'];
  numberOfPlays: Scalars['Int']['output'];
  orderId: Scalars['String']['output'];
  orderedAt: Scalars['DateTime']['output'];
  replayable: Scalars['Boolean']['output'];
  selectedAddOns: Array<Scalars['String']['output']>;
  serialNumber: Scalars['String']['output'];
  status: PlaySlipOrderStatus;
  subscriptionInfo?: Maybe<SubscriptionInfo>;
  totalWinAmount: Money;
};

export type CreatedOrder = Order & {
  __typename?: 'CreatedOrder';
  bonus?: Maybe<OrderBonus>;
  firstPayIn: Scalars['Boolean']['output'];
  orderId: Scalars['OrderId']['output'];
  playSlip: PlaySlipPayload;
  reference: Scalars['String']['output'];
  status: OrderStatus;
};

export type DateLottery = PrizeTierRequirements & {
  __typename?: 'DateLottery';
  dateRequirement: DateRequirement;
  type: PrizeTierRequirementsPayloadType;
};

export type DateRequirement = {
  __typename?: 'DateRequirement';
  ignoreFields: Array<Scalars['String']['output']>;
};

export enum DayOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type DeactivateStoredPaymentInstrumentInput = {
  isPayOutInstrument: Scalars['Boolean']['input'];
  paymentInstrumentId: Scalars['String']['input'];
};

export type DefaultTeasersPayload = {
  __typename?: 'DefaultTeasersPayload';
  id: Scalars['String']['output'];
  productType: KnownProductType;
  teasers: Array<TeaserPayload>;
};

export type DrawDate = {
  __typename?: 'DrawDate';
  date?: Maybe<Scalars['Date']['output']>;
  dayOfWeek?: Maybe<DayOfWeek>;
  defaultJackpotValue?: Maybe<Money>;
  time: ZonedTime;
};

export type DrawHistoryByDayPayload = {
  __typename?: 'DrawHistoryByDayPayload';
  /** Number of days */
  count: Scalars['Long']['output'];
  days: Array<DrawsByDayPayload>;
  /** IANA time zone database name of the TZ used to calculate start and end of day. Main TZ of the licensed territory */
  timeZone: Scalars['String']['output'];
};

export type DrawHistoryPayload = {
  __typename?: 'DrawHistoryPayload';
  draws: Array<FinishedDrawPayload>;
  total: Scalars['Int']['output'];
};

export enum DrawInterval {
  Daily = 'DAILY',
  Hourly = 'HOURLY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export enum DrawLabel {
  Afternoon = 'AFTERNOON',
  Evening = 'EVENING',
  Friday = 'FRIDAY',
  Midday = 'MIDDAY',
  Monday = 'MONDAY',
  Morning = 'MORNING',
  Night = 'NIGHT',
  None = 'NONE',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type DrawNavigationPayload = {
  __typename?: 'DrawNavigationPayload';
  /** The IDs of the draws following the given draw ID, sorted ascending by draw date */
  followingDraws: Array<Scalars['String']['output']>;
  /** The IDs of the draws preceding the given draw ID, sorted descending by draw date */
  previousDraws: Array<Scalars['String']['output']>;
};

export type DrawPayload = {
  __typename?: 'DrawPayload';
  /** Latest time when play slips can be ordered for this draw. */
  closingDate: Scalars['DateTime']['output'];
  /** Minimum jackpot according to the lottery rules. */
  defaultJackpotValue: Money;
  drawDate: Scalars['DateTime']['output'];
  drawnNumbers: Array<DrawnNumbersPayload>;
  hasMultipleDrawsOnDay: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  /** Jackpots for main and additional lotteries. Will only contain the default jackpot for the main lottery when the current jackpot is not entered yet */
  jackpots: Array<Jackpot>;
  label: DrawLabel;
  lotteryConfig: LotteryPayload;
  /** Id of the main lottery. */
  lotteryId: LotteryId;
  prizeCategories: Array<PrizeCategory>;
  state: DrawState;
};

export type DrawResultsFilterInput = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  lotteries?: InputMaybe<Array<LotteryId>>;
};

export enum DrawState {
  Cancelled = 'CANCELLED',
  Evaluated = 'EVALUATED',
  NumbersEntered = 'NUMBERS_ENTERED',
  Open = 'OPEN',
  OpenForReevaluation = 'OPEN_FOR_REEVALUATION',
  Planned = 'PLANNED',
  PrizesEntered = 'PRIZES_ENTERED'
}

export type DrawnNumbersMultipleLines = {
  __typename?: 'DrawnNumbersMultipleLines';
  numbers: Array<Numbers>;
};

export type DrawnNumbersPayload = {
  __typename?: 'DrawnNumbersPayload';
  group: Scalars['DrawnNumbersGroup']['output'];
  /**
   * @deprecated
   *         lotteryId was meant as a grouping but always contained the main lottery.
   *         It is now deprecated and will be removed in the future.
   *
   */
  lotteryId: LotteryId;
  numbers: Array<Numbers>;
  /** For lotteries like GlücksSpirale or ElGordo where the numbers are drawn per rank */
  rank?: Maybe<Scalars['String']['output']>;
  /** For spiel77 / super6 which only have one single number */
  singleNumber: Scalars['Boolean']['output'];
};

export type DrawsByDayPayload = {
  __typename?: 'DrawsByDayPayload';
  /** ISO local date in the form yyyy-MM-dd, local to the 'timeZone' */
  date: Scalars['Date']['output'];
  draws: Array<ReformattedDrawPayload>;
};

export type ExceededLimit = {
  __typename?: 'ExceededLimit';
  available: Money;
  period: LimitPeriod;
  type: LimitType;
  value: Money;
};

export type ExploreElement = {
  __typename?: 'ExploreElement';
  id: Scalars['String']['output'];
};

export type ExtraPlayMultipleLines = PlayMultipleLines & {
  __typename?: 'ExtraPlayMultipleLines';
  /** A list of addons with values of the play slip for the respective draw */
  addOnValues: Array<AddOnOutput>;
  /** A list of all available addons for this draw's lottery */
  addOns: Array<AddOnOutput>;
  /** The list of fields with matches (if evaluated) */
  fields: Array<FieldWithMatches>;
  /** All plays generated for the selected extra hit (powerball 26, mega millions 24) */
  plays: Array<BasePlayMultipleLines>;
  /** Only here for backwards compatibility */
  serialNumber: Scalars['String']['output'];
  /** Only here for backwards compatibility */
  state: PlaySlipStatus;
  /** The monetary or free ticket winnings (if evaluated) */
  winnings: WinningMultipleLines;
};

export type Fee = FixedFee | MultiplyingFee;

export type FieldInput = {
  name: Scalars['String']['input'];
  selected: Array<Scalars['Int']['input']>;
};

export type FieldOutput = LotteryNumbersSortableByName & {
  __typename?: 'FieldOutput';
  name: Scalars['String']['output'];
  selected: Array<Scalars['Int']['output']>;
};

export type FieldWithMatches = {
  __typename?: 'FieldWithMatches';
  name: Scalars['String']['output'];
  numbers: Array<NumberWithMatch>;
  selected: Array<Scalars['Int']['output']>;
};

export type FinishedDrawPayload = {
  __typename?: 'FinishedDrawPayload';
  addOns: Array<Scalars['String']['output']>;
  drawDate: Scalars['DateTime']['output'];
  drawnNumbers: Array<DrawnNumbersPayload>;
  hasMultipleDrawsOnDay: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  label: DrawLabel;
  lotteryConfig: LotteryPayload;
  /** ID of the main lottery. */
  lotteryId: LotteryId;
  prizeCategories: Array<PrizeCategory>;
};

export type FixedCharge = {
  __typename?: 'FixedCharge';
  id: Scalars['String']['output'];
  perPlay: Scalars['Boolean']['output'];
  type: PriceType;
  value: Money;
};

export type FixedFee = {
  __typename?: 'FixedFee';
  id: Scalars['String']['output'];
  perPlay: Scalars['Boolean']['output'];
  type: PriceType;
  value: Money;
};

export type FreeTicket = PrizePayload & {
  __typename?: 'FreeTicket';
  numberOfFreePlays: Scalars['Int']['output'];
  prize?: Maybe<Money>;
  tier: Scalars['String']['output'];
  tierInfo: PrizeTier;
  type: PrizeTierType;
  winners: Scalars['Int']['output'];
};

export type FreeToPlayTeaserPayload = {
  __typename?: 'FreeToPlayTeaserPayload';
  id: Scalars['String']['output'];
};

export enum GameId {
  MassachusettsKeno = 'MassachusettsKeno',
  OhioKeno = 'OhioKeno',
  OregonKeno = 'OregonKeno'
}

export enum GeoCheckStatus {
  IpHostingFacilityDetected = 'IP_HOSTING_FACILITY_DETECTED',
  LocationConfidenceTooLow = 'LOCATION_CONFIDENCE_TOO_LOW',
  LocationConsentTimedOut = 'LOCATION_CONSENT_TIMED_OUT',
  LocationInterceptorDetected = 'LOCATION_INTERCEPTOR_DETECTED',
  LocationIpRoutingIssue = 'LOCATION_IP_ROUTING_ISSUE',
  LocationLocationFail = 'LOCATION_LOCATION_FAIL',
  LocationPrivateBrowsingDetected = 'LOCATION_PRIVATE_BROWSING_DETECTED',
  LocationProfilingEventIssue = 'LOCATION_PROFILING_EVENT_ISSUE',
  LocationSpoofingDetected = 'LOCATION_SPOOFING_DETECTED',
  LocationUnauthorized = 'LOCATION_UNAUTHORIZED',
  LocationWrongIp = 'LOCATION_WRONG_IP',
  NeighbourState = 'NEIGHBOUR_STATE',
  NotInCountry = 'NOT_IN_COUNTRY',
  NotInState = 'NOT_IN_STATE',
  Ok = 'OK',
  ProfileRejected = 'PROFILE_REJECTED',
  ServiceError = 'SERVICE_ERROR',
  ServiceUnavailable = 'SERVICE_UNAVAILABLE',
  VpnOrProxy = 'VPN_OR_PROXY'
}

export type GroupedPlays = {
  __typename?: 'GroupedPlays';
  addOns: Array<AddOnSummary>;
  betType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  plays: Scalars['Int']['output'];
  price: MoneySummary;
  virtualPlays?: Maybe<Scalars['Int']['output']>;
  wagerAmount?: Maybe<Money>;
};

export enum HeroHighlightPattern {
  Fire = 'Fire',
  Lightning = 'Lightning',
  Money = 'Money',
  Star = 'Star'
}

export enum HeroHighlightStyle {
  BottomM = 'BottomM',
  BottomXl = 'BottomXL',
  TopM = 'TopM',
  TopXl = 'TopXL'
}

export type HighFrequencyAddOn = {
  __typename?: 'HighFrequencyAddOn';
  /** Price of the add-on without fee, minus discount */
  charge: Money;
  name: Scalars['String']['output'];
};

export type HighFrequencyPriceBreakdown = {
  __typename?: 'HighFrequencyPriceBreakdown';
  addOns: Array<HighFrequencyAddOn>;
  /** Sum of all charges */
  chargeTotal: Money;
  /** Multi draw discount */
  discountPercentage: Scalars['Int']['output'];
  /** Sum of all convenience fees */
  feeTotal: Money;
  /** Total price including sales tax */
  grossTotal: Money;
  /** Total price without sales tax */
  netTotal: Money;
  numberOfDraws: Scalars['Int']['output'];
  numberOfSpots: Scalars['Int']['output'];
  /** Sales tax for markets where it is calculated separately */
  salesTax: Money;
  wager: Money;
  /** @deprecated Use `wager` instead */
  wagerCharge: Money;
};

export type HighFrequencyProduct = {
  __typename?: 'HighFrequencyProduct';
  expiresAt: Scalars['DateTime']['output'];
  gameId: GameId;
  name: Scalars['String']['output'];
  price: Money;
  priceBreakdown: HighFrequencyPriceBreakdown;
};

export type HighFrequencyReplayPlaySlipInput = {
  licensedTerritory: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
};

export type HighFrequencyRevealDrawParticipationInput = {
  drawId: Scalars['String']['input'];
  licensedTerritory: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
};

export type HighFrequencyRevealOrderInput = {
  licensedTerritory: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
};

export type HighFrequencyTeaserPayload = {
  __typename?: 'HighFrequencyTeaserPayload';
  campaign?: Maybe<CampaignPayload>;
  id: Scalars['String']['output'];
  jackpotSize: Money;
  jackpotType: JackpotType;
  operating: Scalars['Boolean']['output'];
  operatingHours: OperatingHoursRange;
};

export type HighFrequency_AddOn = {
  __typename?: 'HighFrequency_AddOn';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type HighFrequency_AddOnConfig = {
  __typename?: 'HighFrequency_AddOnConfig';
  fee: HighFrequency_Price;
  mandatory: Scalars['Boolean']['output'];
  maximumMultiplier?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  options: Array<Scalars['String']['output']>;
  price: HighFrequency_Price;
  restrictions: Array<HighFrequency_AddOnRestriction>;
  type: HighFrequency_AddOnType;
};

export type HighFrequency_AddOnInput = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type HighFrequency_AddOnRestriction = {
  type: HighFrequency_AddOnRestrictionType;
};

export enum HighFrequency_AddOnRestrictionType {
  ExcludeSelectedNumbers = 'EXCLUDE_SELECTED_NUMBERS'
}

export type HighFrequency_AddOnRestriction_ExcludeSelectedNumbers = HighFrequency_AddOnRestriction & {
  __typename?: 'HighFrequency_AddOnRestriction_ExcludeSelectedNumbers';
  numbers: Scalars['String']['output'];
  selected: Array<Scalars['Int']['output']>;
  type: HighFrequency_AddOnRestrictionType;
};

export enum HighFrequency_AddOnType {
  Boolean = 'BOOLEAN',
  Option = 'OPTION'
}

export type HighFrequency_AllowedNumber = {
  __typename?: 'HighFrequency_AllowedNumber';
  recommended: Scalars['Boolean']['output'];
  value: Scalars['Int']['output'];
};

export type HighFrequency_AllowedNumberOfDraws = {
  __typename?: 'HighFrequency_AllowedNumberOfDraws';
  numbers: Array<HighFrequency_AllowedNumberOfDrawsGroup>;
};

export type HighFrequency_AllowedNumberOfDrawsGroup = {
  __typename?: 'HighFrequency_AllowedNumberOfDrawsGroup';
  discount: Scalars['Int']['output'];
  values: Array<HighFrequency_AllowedNumber>;
};

export type HighFrequency_BusinessHours = {
  __typename?: 'HighFrequency_BusinessHours';
  week: Array<HighFrequency_WeekDay>;
};

export type HighFrequency_Draw = {
  __typename?: 'HighFrequency_Draw';
  id: Scalars['String']['output'];
  number: Scalars['Int']['output'];
  orderId: Scalars['String']['output'];
  participationId: Scalars['String']['output'];
  results: Array<HighFrequency_DrawResults>;
  status: HighFrequency_DrawStatus;
  winnings?: Maybe<HighFrequency_Winnings>;
};

export type HighFrequency_DrawParticipationPayload = {
  __typename?: 'HighFrequency_DrawParticipationPayload';
  addOns: Array<HighFrequency_AddOn>;
  draw: HighFrequency_Draw;
  gameId: HighFrequency_GameId;
  numbers: Array<HighFrequency_Numbers>;
  orderId: Scalars['String']['output'];
  orderedIn: Scalars['String']['output'];
};

export type HighFrequency_DrawParticipationPayloadError = TypedGraphQlError & {
  __typename?: 'HighFrequency_DrawParticipationPayloadError';
  message: Scalars['String']['output'];
};

export type HighFrequency_DrawParticipationPayloadErrors = {
  __typename?: 'HighFrequency_DrawParticipationPayloadErrors';
  errors: Array<HighFrequency_DrawParticipationPayloadError>;
};

export type HighFrequency_DrawParticipationPayload_Or_HighFrequency_DrawParticipationPayloadErrors = HighFrequency_DrawParticipationPayload | HighFrequency_DrawParticipationPayloadErrors;

export type HighFrequency_DrawParticipationRevealPayload = {
  __typename?: 'HighFrequency_DrawParticipationRevealPayload';
  addOns: Array<HighFrequency_AddOn>;
  draw: HighFrequency_Draw;
  gameId: HighFrequency_GameId;
  nextDraw?: Maybe<HighFrequency_NextDraw>;
  numbers: Array<HighFrequency_Numbers>;
  orderId: Scalars['String']['output'];
  orderedIn: Scalars['String']['output'];
};

export type HighFrequency_DrawParticipationRevealPayload_Or_HighFrequency_RevealErrors = HighFrequency_DrawParticipationRevealPayload | HighFrequency_RevealErrors;

export type HighFrequency_DrawResults = {
  __typename?: 'HighFrequency_DrawResults';
  name: Scalars['String']['output'];
  values: Array<HighFrequency_Number>;
};

export type HighFrequency_DrawStatus = {
  status: HighFrequency_DrawStatusEnum;
};

export enum HighFrequency_DrawStatusEnum {
  NotOperating = 'NOT_OPERATING',
  Pending = 'PENDING',
  Ready = 'READY',
  Revealed = 'REVEALED'
}

export type HighFrequency_DrawStatusGeneral = HighFrequency_DrawStatus & {
  __typename?: 'HighFrequency_DrawStatusGeneral';
  status: HighFrequency_DrawStatusEnum;
};

export type HighFrequency_DrawStatusNotOperating = HighFrequency_DrawStatus & {
  __typename?: 'HighFrequency_DrawStatusNotOperating';
  resumesAt: Scalars['DateTime']['output'];
  status: HighFrequency_DrawStatusEnum;
};

export type HighFrequency_DrawStatusPending = HighFrequency_DrawStatus & {
  __typename?: 'HighFrequency_DrawStatusPending';
  drawsAt: Scalars['DateTime']['output'];
  status: HighFrequency_DrawStatusEnum;
};

export type HighFrequency_DrawStatusReady = HighFrequency_DrawStatus & {
  __typename?: 'HighFrequency_DrawStatusReady';
  status: HighFrequency_DrawStatusEnum;
};

export type HighFrequency_FieldInput = {
  name: Scalars['String']['input'];
  selected: Array<Scalars['Int']['input']>;
};

export type HighFrequency_FixedPrice = {
  __typename?: 'HighFrequency_FixedPrice';
  amount: Money;
};

export type HighFrequency_FixedPrizeTier = HighFrequency_PrizeTier & {
  __typename?: 'HighFrequency_FixedPrizeTier';
  amount: Money;
  matchCount: Scalars['Int']['output'];
  multipliedBy?: Maybe<Scalars['String']['output']>;
  tier: Scalars['String']['output'];
};

export type HighFrequency_GameConfig = {
  __typename?: 'HighFrequency_GameConfig';
  addOns: Array<HighFrequency_AddOnConfig>;
  allowedNumberOfDraws: HighFrequency_AllowedNumberOfDraws;
  businessHours?: Maybe<HighFrequency_BusinessHours>;
  disclaimerAccepted: Scalars['Boolean']['output'];
  gameId: HighFrequency_GameId;
  gameName: Scalars['String']['output'];
  jackpot: HighFrequency_JackpotConfig;
  licensedTerritory: Scalars['String']['output'];
  maxPlaySlipPrice?: Maybe<Money>;
  numbers: Array<HighFrequency_NumbersConfig>;
  operatingHours: HighFrequency_OperatingTimes;
  prizeTierCategories: Array<HighFrequency_PrizeTierCategory>;
  status: HighFrequency_GameConfigStatus;
  timeZone: Scalars['String']['output'];
  version: Scalars['String']['output'];
  wagers: Array<HighFrequency_WagersConfig>;
};

export enum HighFrequency_GameConfigStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type HighFrequency_GameConfig_Or_HighFrequency_GamesErrors = HighFrequency_GameConfig | HighFrequency_GamesErrors;

export type HighFrequency_GameConfigs = {
  __typename?: 'HighFrequency_GameConfigs';
  configs: Array<HighFrequency_GameConfig>;
};

export type HighFrequency_GameConfigs_Or_HighFrequency_GamesErrors = HighFrequency_GameConfigs | HighFrequency_GamesErrors;

export enum HighFrequency_GameId {
  MassachusettsKeno = 'MassachusettsKeno',
  OhioKeno = 'OhioKeno',
  OregonKeno = 'OregonKeno'
}

export type HighFrequency_GamesError = HighFrequency_GamesError_GameNotFoundError | HighFrequency_GamesError_UnexpectedError | HighFrequency_GamesError_UnknownLicensedTerritory;

export type HighFrequency_GamesError_GameNotFoundError = TypedGraphQlError & {
  __typename?: 'HighFrequency_GamesError_GameNotFoundError';
  message: Scalars['String']['output'];
};

export type HighFrequency_GamesError_UnexpectedError = TypedGraphQlError & {
  __typename?: 'HighFrequency_GamesError_UnexpectedError';
  message: Scalars['String']['output'];
};

export type HighFrequency_GamesError_UnknownLicensedTerritory = TypedGraphQlError & {
  __typename?: 'HighFrequency_GamesError_UnknownLicensedTerritory';
  message: Scalars['String']['output'];
};

export type HighFrequency_GamesErrors = {
  __typename?: 'HighFrequency_GamesErrors';
  errors: Array<HighFrequency_GamesError>;
};

export type HighFrequency_JackpotConfig = {
  __typename?: 'HighFrequency_JackpotConfig';
  type: HighFrequency_JackpotType;
  value: Money;
};

export type HighFrequency_JackpotPrizeTier = HighFrequency_PrizeTier & {
  __typename?: 'HighFrequency_JackpotPrizeTier';
  matchCount: Scalars['Int']['output'];
  tier: Scalars['String']['output'];
};

export enum HighFrequency_JackpotType {
  Dynamic = 'DYNAMIC',
  Fixed = 'FIXED'
}

export type HighFrequency_MultiplyingPrice = {
  __typename?: 'HighFrequency_MultiplyingPrice';
  multiplier: Scalars['Int']['output'];
};

export type HighFrequency_NextDraw = {
  __typename?: 'HighFrequency_NextDraw';
  id: Scalars['String']['output'];
  number: Scalars['Int']['output'];
  orderId: Scalars['String']['output'];
  participationId: Scalars['String']['output'];
  status: HighFrequency_DrawStatus;
};

export type HighFrequency_Number = {
  __typename?: 'HighFrequency_Number';
  matching?: Maybe<Scalars['Boolean']['output']>;
  value: Scalars['Int']['output'];
};

export type HighFrequency_Numbers = {
  __typename?: 'HighFrequency_Numbers';
  name: Scalars['String']['output'];
  values: Array<HighFrequency_Number>;
};

export type HighFrequency_NumbersConfig = {
  __typename?: 'HighFrequency_NumbersConfig';
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  selectableMax: Scalars['Int']['output'];
  selectableMin: Scalars['Int']['output'];
};

export type HighFrequency_OperatingTimes = {
  __typename?: 'HighFrequency_OperatingTimes';
  end: Scalars['LocalTime']['output'];
  start: Scalars['LocalTime']['output'];
};

export type HighFrequency_Order = {
  __typename?: 'HighFrequency_Order';
  addOns: Array<HighFrequency_AddOn>;
  gameId: HighFrequency_GameId;
  hasWinnings: Scalars['Boolean']['output'];
  orderId: Scalars['String']['output'];
  readyDraws: Scalars['Int']['output'];
  replayable: Scalars['Boolean']['output'];
  revealedDraws: Scalars['Int']['output'];
  spots: Scalars['Int']['output'];
  status: HighFrequency_OrderStatus;
  totalDraws: Scalars['Int']['output'];
  wager: Money;
};

export type HighFrequency_OrderDetailsError = HighFrequency_OrderDetailsError_InvalidLicensedTerritory | HighFrequency_OrderDetailsError_NotFound | HighFrequency_OrderDetailsError_UnexpectedError;

export type HighFrequency_OrderDetailsError_InvalidLicensedTerritory = TypedGraphQlError & {
  __typename?: 'HighFrequency_OrderDetailsError_InvalidLicensedTerritory';
  message: Scalars['String']['output'];
};

export type HighFrequency_OrderDetailsError_NotFound = TypedGraphQlError & {
  __typename?: 'HighFrequency_OrderDetailsError_NotFound';
  message: Scalars['String']['output'];
};

export type HighFrequency_OrderDetailsError_UnexpectedError = TypedGraphQlError & {
  __typename?: 'HighFrequency_OrderDetailsError_UnexpectedError';
  message: Scalars['String']['output'];
};

export type HighFrequency_OrderDetailsErrors = {
  __typename?: 'HighFrequency_OrderDetailsErrors';
  errors: Array<HighFrequency_OrderDetailsError>;
};

export type HighFrequency_OrderDetailsPayload = {
  __typename?: 'HighFrequency_OrderDetailsPayload';
  addOns: Array<HighFrequency_AddOn>;
  draws: Array<HighFrequency_Draw>;
  gameId: HighFrequency_GameId;
  nextDraw?: Maybe<HighFrequency_NextDraw>;
  numberOfDraws: Scalars['Int']['output'];
  numberOfSpots: Scalars['Int']['output'];
  numbers: Array<HighFrequency_Numbers>;
  orderId: Scalars['String']['output'];
  orderedIn: Scalars['String']['output'];
  price: Money;
  replayable: Scalars['Boolean']['output'];
  status: HighFrequency_OrderStatus;
  ticketScans?: Maybe<HighFrequency_TicketScans>;
  totalWinnings?: Maybe<HighFrequency_Winnings>;
  wager: Money;
};

export type HighFrequency_OrderDetailsPayload_Or_HighFrequency_OrderDetailsErrors = HighFrequency_OrderDetailsErrors | HighFrequency_OrderDetailsPayload;

export type HighFrequency_OrderDetailsPayload_Or_HighFrequency_RevealErrors = HighFrequency_OrderDetailsPayload | HighFrequency_RevealErrors;

export enum HighFrequency_OrderStatus {
  Cancelled = 'CANCELLED',
  Finished = 'FINISHED',
  Ordered = 'ORDERED',
  Printed = 'PRINTED'
}

export type HighFrequency_OrdersError = HighFrequency_OrdersError_UnexpectedError;

export type HighFrequency_OrdersError_UnexpectedError = TypedGraphQlError & {
  __typename?: 'HighFrequency_OrdersError_UnexpectedError';
  message: Scalars['String']['output'];
};

export type HighFrequency_OrdersErrors = {
  __typename?: 'HighFrequency_OrdersErrors';
  errors: Array<HighFrequency_OrdersError>;
};

export type HighFrequency_OrdersFilterInput = {
  highFrequencyGames?: InputMaybe<Array<HighFrequency_GameId>>;
  status: Array<HighFrequency_OrderStatus>;
};

export type HighFrequency_OrdersPayload = {
  __typename?: 'HighFrequency_OrdersPayload';
  count: Scalars['Long']['output'];
  highFrequencyOrders: Array<HighFrequency_Order>;
};

export type HighFrequency_OrdersPayload_Or_HighFrequency_OrdersErrors = HighFrequency_OrdersErrors | HighFrequency_OrdersPayload;

export type HighFrequency_PlaySlipInput = {
  addOns: Array<HighFrequency_AddOnInput>;
  bonusCode?: InputMaybe<Scalars['String']['input']>;
  configVersion: Scalars['String']['input'];
  disclaimerAccepted: Scalars['Boolean']['input'];
  gameId: HighFrequency_GameId;
  licensedTerritory: Scalars['String']['input'];
  numberOfDraws: Scalars['Int']['input'];
  selectedNumbers: Array<HighFrequency_FieldInput>;
  wagerName: Scalars['String']['input'];
};

export type HighFrequency_PlaySlipStored = {
  __typename?: 'HighFrequency_PlaySlipStored';
  id: Scalars['String']['output'];
};

export type HighFrequency_PlaySlipStoredError = HighFrequency_PlaySlipStoredError_DisclaimerNotAccepted | HighFrequency_PlaySlipStoredError_InvalidPlaySlip | HighFrequency_PlaySlipStoredError_MaxPlaySlipPriceExceeded | HighFrequency_PlaySlipStoredError_PlayerCannotPlay | HighFrequency_PlaySlipStoredError_PlayerRestricted | HighFrequency_PlaySlipStoredError_UnexpectedError;

export type HighFrequency_PlaySlipStoredError_DisclaimerNotAccepted = TypedGraphQlError & {
  __typename?: 'HighFrequency_PlaySlipStoredError_DisclaimerNotAccepted';
  message: Scalars['String']['output'];
};

export type HighFrequency_PlaySlipStoredError_InvalidPlaySlip = TypedGraphQlError & {
  __typename?: 'HighFrequency_PlaySlipStoredError_InvalidPlaySlip';
  message: Scalars['String']['output'];
};

export type HighFrequency_PlaySlipStoredError_MaxPlaySlipPriceExceeded = TypedGraphQlError & {
  __typename?: 'HighFrequency_PlaySlipStoredError_MaxPlaySlipPriceExceeded';
  chargeTotal: Money;
  maxPlaySlipPrice: Money;
  message: Scalars['String']['output'];
};

export type HighFrequency_PlaySlipStoredError_PlayerCannotPlay = TypedGraphQlError & {
  __typename?: 'HighFrequency_PlaySlipStoredError_PlayerCannotPlay';
  message: Scalars['String']['output'];
};

export type HighFrequency_PlaySlipStoredError_PlayerRestricted = TypedGraphQlError & {
  __typename?: 'HighFrequency_PlaySlipStoredError_PlayerRestricted';
  accountBalance: Money;
  grossTotal: Money;
  message: Scalars['String']['output'];
  restrictions: Restrictions;
};

export type HighFrequency_PlaySlipStoredError_UnexpectedError = TypedGraphQlError & {
  __typename?: 'HighFrequency_PlaySlipStoredError_UnexpectedError';
  message: Scalars['String']['output'];
};

export type HighFrequency_PlaySlipStoredErrors = {
  __typename?: 'HighFrequency_PlaySlipStoredErrors';
  errors: Array<HighFrequency_PlaySlipStoredError>;
};

export type HighFrequency_PlaySlipStored_Or_HighFrequency_PlaySlipStoredErrors = HighFrequency_PlaySlipStored | HighFrequency_PlaySlipStoredErrors;

export type HighFrequency_PlaySlipStored_Or_HighFrequency_ReplayErrors = HighFrequency_PlaySlipStored | HighFrequency_ReplayErrors;

export type HighFrequency_Price = HighFrequency_FixedPrice | HighFrequency_MultiplyingPrice;

export type HighFrequency_PrizeTier = {
  matchCount: Scalars['Int']['output'];
  tier: Scalars['String']['output'];
};

export type HighFrequency_PrizeTierCategory = {
  __typename?: 'HighFrequency_PrizeTierCategory';
  name: Scalars['String']['output'];
  prizeTiersByNumberOfSpots: Array<HighFrequency_PrizeTiersForSpots>;
};

export type HighFrequency_PrizeTiersForSpots = {
  __typename?: 'HighFrequency_PrizeTiersForSpots';
  overallOdds: Scalars['Float']['output'];
  prizeTiers: Array<HighFrequency_PrizeTier>;
  spots: Scalars['Int']['output'];
};

export type HighFrequency_ReplayError = {
  message: Scalars['String']['output'];
};

export type HighFrequency_ReplayError_GameNotActiveError = HighFrequency_ReplayError & TypedGraphQlError & {
  __typename?: 'HighFrequency_ReplayError_GameNotActiveError';
  message: Scalars['String']['output'];
};

export type HighFrequency_ReplayError_InvalidLicensedTerritoryError = HighFrequency_ReplayError & TypedGraphQlError & {
  __typename?: 'HighFrequency_ReplayError_InvalidLicensedTerritoryError';
  isoCode: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type HighFrequency_ReplayError_InvalidOrderIdError = HighFrequency_ReplayError & TypedGraphQlError & {
  __typename?: 'HighFrequency_ReplayError_InvalidOrderIdError';
  message: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
};

export type HighFrequency_ReplayError_NotReplayableError = HighFrequency_ReplayError & TypedGraphQlError & {
  __typename?: 'HighFrequency_ReplayError_NotReplayableError';
  message: Scalars['String']['output'];
};

export type HighFrequency_ReplayError_PlaySlipNotFoundError = HighFrequency_ReplayError & TypedGraphQlError & {
  __typename?: 'HighFrequency_ReplayError_PlaySlipNotFoundError';
  message: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
};

export type HighFrequency_ReplayError_PlayerCannotPlayError = HighFrequency_ReplayError & TypedGraphQlError & {
  __typename?: 'HighFrequency_ReplayError_PlayerCannotPlayError';
  message: Scalars['String']['output'];
};

export type HighFrequency_ReplayError_UnexpectedError = HighFrequency_ReplayError & TypedGraphQlError & {
  __typename?: 'HighFrequency_ReplayError_UnexpectedError';
  message: Scalars['String']['output'];
};

export type HighFrequency_ReplayErrors = {
  __typename?: 'HighFrequency_ReplayErrors';
  errors: Array<HighFrequency_ReplayError>;
};

export type HighFrequency_ResultsAndWinnersDraw = {
  __typename?: 'HighFrequency_ResultsAndWinnersDraw';
  drawNumber: Scalars['Int']['output'];
  results: Array<HighFrequency_DrawResults>;
};

export type HighFrequency_ResultsAndWinnersError = TypedGraphQlError & {
  __typename?: 'HighFrequency_ResultsAndWinnersError';
  message: Scalars['String']['output'];
};

export type HighFrequency_ResultsAndWinnersErrors = {
  __typename?: 'HighFrequency_ResultsAndWinnersErrors';
  errors: Array<HighFrequency_ResultsAndWinnersError>;
};

export type HighFrequency_ResultsAndWinnersInput = {
  drawNumber?: InputMaybe<Scalars['Int']['input']>;
  gameId: HighFrequency_GameId;
  licensedTerritory: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type HighFrequency_ResultsAndWinnersPayload = {
  __typename?: 'HighFrequency_ResultsAndWinnersPayload';
  draws: Array<HighFrequency_ResultsAndWinnersDraw>;
  gameConfig?: Maybe<HighFrequency_GameConfig>;
  winnersCount: Scalars['Int']['output'];
};

export type HighFrequency_ResultsAndWinnersPayload_Or_HighFrequency_ResultsAndWinnersErrors = HighFrequency_ResultsAndWinnersErrors | HighFrequency_ResultsAndWinnersPayload;

export type HighFrequency_RevealError = TypedGraphQlError & {
  __typename?: 'HighFrequency_RevealError';
  message: Scalars['String']['output'];
};

export type HighFrequency_RevealErrors = {
  __typename?: 'HighFrequency_RevealErrors';
  errors: Array<HighFrequency_RevealError>;
};

export type HighFrequency_TicketScanPayload = {
  __typename?: 'HighFrequency_TicketScanPayload';
  blurHash: Scalars['String']['output'];
  height: Scalars['Int']['output'];
  url: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export type HighFrequency_TicketScans = {
  __typename?: 'HighFrequency_TicketScans';
  back: HighFrequency_TicketScanPayload;
  expirationDate: Scalars['DateTime']['output'];
  front: HighFrequency_TicketScanPayload;
};

export type HighFrequency_WagersConfig = {
  __typename?: 'HighFrequency_WagersConfig';
  fee: HighFrequency_FixedPrice;
  multiplier: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  price: HighFrequency_FixedPrice;
};

export type HighFrequency_WatchDrawError = TypedGraphQlError & {
  __typename?: 'HighFrequency_WatchDrawError';
  message: Scalars['String']['output'];
};

export type HighFrequency_WatchDrawErrors = {
  __typename?: 'HighFrequency_WatchDrawErrors';
  errors: Array<HighFrequency_WatchDrawError>;
};

export type HighFrequency_WatchDrawPayload = {
  __typename?: 'HighFrequency_WatchDrawPayload';
  id: Scalars['String']['output'];
  nextDraw: HighFrequency_WatchNextDraw;
  number: Scalars['Int']['output'];
  results: Array<HighFrequency_DrawResults>;
  status: HighFrequency_DrawStatus;
};

export type HighFrequency_WatchDrawPayload_Or_HighFrequency_WatchDrawErrors = HighFrequency_WatchDrawErrors | HighFrequency_WatchDrawPayload;

export type HighFrequency_WatchNextDraw = {
  __typename?: 'HighFrequency_WatchNextDraw';
  id: Scalars['String']['output'];
  number: Scalars['Int']['output'];
  status: HighFrequency_DrawStatus;
};

export type HighFrequency_WeekDay = {
  __typename?: 'HighFrequency_WeekDay';
  end: Scalars['LocalTime']['output'];
  start: Scalars['LocalTime']['output'];
  weekDay: DayOfWeek;
};

export type HighFrequency_Winnings = {
  __typename?: 'HighFrequency_Winnings';
  amount: Money;
  isBigWin: Scalars['Boolean']['output'];
  pariMutuel: Scalars['Boolean']['output'];
};

export type HypeValidationsPayload = {
  __typename?: 'HypeValidationsPayload';
  massBonusCodesPattern: Scalars['String']['output'];
};

export type ImagePropertiesPayload = {
  __typename?: 'ImagePropertiesPayload';
  blurHash: Scalars['String']['output'];
  height: Scalars['Int']['output'];
  width: Scalars['Int']['output'];
};

export type ImagesPayload = {
  __typename?: 'ImagesPayload';
  back: Scalars['String']['output'];
  backCreationDate: Scalars['DateTime']['output'];
  backImageProperties: ImagePropertiesPayload;
  linkExpiresAt: Scalars['DateTime']['output'];
  scratched: Scalars['String']['output'];
  scratchedCreationDate: Scalars['DateTime']['output'];
  scratchedImageProperties: ImagePropertiesPayload;
  unscratched: Scalars['String']['output'];
  unscratchedCreationDate: Scalars['DateTime']['output'];
  unscratchedImageProperties: ImagePropertiesPayload;
};

export type InitialPayOutAccount = {
  __typename?: 'InitialPayOutAccount';
  id: Scalars['String']['output'];
  /** Token used to register a new payout instrument with the provider API */
  token: PaymentToken;
  type: PayOutAccountType;
};

export type InitialPaymentInstrument = {
  __typename?: 'InitialPaymentInstrument';
  /** Unique id for which to register the payment instrument (PXP). */
  accountId: Scalars['String']['output'];
  /** Either CardDeposit or Redirect */
  integrationType: Scalars['String']['output'];
  /** Supported payment methods. For example credit card: ['VISA', 'Mastercard'] */
  methods: Array<Scalars['String']['output']>;
  /** Name of the payment provider */
  provider: Scalars['String']['output'];
  /** In case type == CreditCard this is where to post the Card data to */
  providerUri?: Maybe<Scalars['String']['output']>;
  /** Token used to register a new payment instrument with the provider API */
  token: PaymentToken;
  /** For example CreditCard, PayPal etc. */
  type: Scalars['String']['output'];
  /** For type == Venmo this will contain the venmo-specific profileId */
  venmoProfileId?: Maybe<Scalars['String']['output']>;
};

export type InitialPaymentInstrumentsInput = {
  licensedTerritory: Scalars['String']['input'];
  userAgent?: InputMaybe<Scalars['String']['input']>;
};

export type InitialPaymentInstrumentsPayload = {
  __typename?: 'InitialPaymentInstrumentsPayload';
  /** Unique id for which to register the payment instrument (PXP). */
  accountId: Scalars['String']['output'];
  /** EProtectEndpoint for Worldpay */
  eProtectEndpoint?: Maybe<Scalars['String']['output']>;
  /** Either CardDeposit or Redirect */
  integrationType: Scalars['String']['output'];
  /** Supported payment methods. For example credit card: ['VISA', 'Mastercard'] */
  methods: Array<Scalars['String']['output']>;
  /** Name of the payment provider */
  provider: Scalars['String']['output'];
  /** In case type == CreditCard this is where to post the Card data to */
  providerUri?: Maybe<Scalars['String']['output']>;
  /** Token used to register a new payment instrument with the provider API */
  token: PaymentToken;
  /** For example CreditCard, PayPal etc. */
  type: Scalars['String']['output'];
  /** For type == Venmo this will contain the venmo-specific profileId */
  venmoProfileId?: Maybe<Scalars['String']['output']>;
};

export type Jackpot = {
  __typename?: 'Jackpot';
  lotteryId: LotteryId;
  value: Money;
};

export type JackpotDefinition = {
  __typename?: 'JackpotDefinition';
  lotteryId: LotteryId;
};

export enum JackpotType {
  Dynamic = 'DYNAMIC',
  Fixed = 'FIXED'
}

export enum KnownProductType {
  HighFrequencyGame = 'HIGH_FREQUENCY_GAME',
  Lottery = 'LOTTERY',
  Scratchcard = 'SCRATCHCARD'
}

export type Limit = {
  period: LimitPeriod;
  type: LimitType;
};

export type LimitInput = {
  period: LimitPeriod;
  value: MoneyInput;
};

export enum LimitPeriod {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK'
}

export enum LimitType {
  Deposit = 'DEPOSIT',
  Spending = 'SPENDING'
}

export type Limits = {
  __typename?: 'Limits';
  deposit: Array<Limit>;
  maxDeposit: Array<Limit>;
  maxSpending: Array<Limit>;
  spending: Array<Limit>;
};

export type LimitsInput = {
  limits: Array<LimitInput>;
};

export type LocationDataInput = {
  html5SessionId?: InputMaybe<Scalars['String']['input']>;
  profilingSessionId: Scalars['String']['input'];
  submitterIPAddress?: InputMaybe<Scalars['String']['input']>;
};

export enum LotteryId {
  ArizonaFantasy5 = 'ArizonaFantasy5',
  ArizonaPick3 = 'ArizonaPick3',
  ArizonaThePick = 'ArizonaThePick',
  ArkansasCash3 = 'ArkansasCash3',
  ArkansasCash4 = 'ArkansasCash4',
  ArkansasLotto = 'ArkansasLotto',
  ArkansasNaturalStateJackpot = 'ArkansasNaturalStateJackpot',
  Cash4Life = 'Cash4Life',
  Cash5 = 'Cash5',
  ColoradoCash5 = 'ColoradoCash5',
  ColoradoLotto = 'ColoradoLotto',
  ColoradoPick3 = 'ColoradoPick3',
  FloridaLotto = 'FloridaLotto',
  FloridaPick2 = 'FloridaPick2',
  FloridaPick3 = 'FloridaPick3',
  FloridaPick4 = 'FloridaPick4',
  FloridaPick5 = 'FloridaPick5',
  LottoAmerica = 'LottoAmerica',
  LottoTexas = 'LottoTexas',
  LuckyForLife = 'LuckyForLife',
  MassachusettsMassCash = 'MassachusettsMassCash',
  MassachusettsMegabucks = 'MassachusettsMegabucks',
  MassachusettsTheNumbersGame = 'MassachusettsTheNumbersGame',
  MegaMillions = 'MegaMillions',
  MillionaireForLife = 'MillionaireForLife',
  MinnesotaGopher5 = 'MinnesotaGopher5',
  MinnesotaNorth5 = 'MinnesotaNorth5',
  MinnesotaPick3 = 'MinnesotaPick3',
  NebraskaMyDay = 'NebraskaMyDay',
  NebraskaPick3 = 'NebraskaPick3',
  NebraskaPick4 = 'NebraskaPick4',
  NebraskaPick5 = 'NebraskaPick5',
  NewYorkLotto = 'NewYorkLotto',
  NewYorkNumbers = 'NewYorkNumbers',
  NewYorkPick10 = 'NewYorkPick10',
  NewYorkTake5 = 'NewYorkTake5',
  NewYorkWin4 = 'NewYorkWin4',
  OhioClassicLotto = 'OhioClassicLotto',
  OhioPick3 = 'OhioPick3',
  OhioPick4 = 'OhioPick4',
  OhioPick5 = 'OhioPick5',
  OhioRollingCash5 = 'OhioRollingCash5',
  OregonLuckyLines = 'OregonLuckyLines',
  OregonMegabucks = 'OregonMegabucks',
  OregonPick4 = 'OregonPick4',
  Pick3 = 'Pick3',
  Pick4 = 'Pick4',
  Pick6 = 'Pick6',
  PowerBall = 'PowerBall',
  PuertoRicoLotoCash = 'PuertoRicoLotoCash',
  PuertoRicoPega2 = 'PuertoRicoPega2',
  PuertoRicoPega3 = 'PuertoRicoPega3',
  PuertoRicoPega4 = 'PuertoRicoPega4',
  TexasAllOrNothing = 'TexasAllOrNothing',
  TexasCashFive = 'TexasCashFive',
  TexasDaily4 = 'TexasDaily4',
  TexasPick3 = 'TexasPick3',
  TexasTwoStep = 'TexasTwoStep',
  TristateGimme5 = 'TristateGimme5',
  TristateMegabucks = 'TristateMegabucks',
  TristatePick3 = 'TristatePick3',
  TristatePick4 = 'TristatePick4'
}

export type LotteryNumbersSortableByName = {
  name: Scalars['String']['output'];
};

export type LotteryPayload = {
  __typename?: 'LotteryPayload';
  active: Scalars['Boolean']['output'];
  /** @deprecated Use currentConfig */
  config: Array<VersionedConfig>;
  currentConfig: VersionedConfig;
  id: LotteryId;
  licensedTerritory: Scalars['String']['output'];
  priceList: PriceListPayload;
  properties: Array<LotteryProperty>;
  /** IANA time zone database id */
  timeZone: Scalars['String']['output'];
};

export type LotteryProduct = {
  __typename?: 'LotteryProduct';
  /** @deprecated Use `productName` - which contains the actual name instead of a key - instead */
  name: Scalars['String']['output'];
  numberOfDraws: Scalars['Int']['output'];
  numberOfPlays: Scalars['Int']['output'];
  playSlipId: Scalars['String']['output'];
  price: Money;
  priceBreakdown: PriceBreakdown;
  productName: Scalars['String']['output'];
  subscription: Scalars['Boolean']['output'];
  subscriptionOptions?: Maybe<SubscriptionOptions>;
};

export enum LotteryProperty {
  Additional = 'ADDITIONAL',
  FixedJackpot = 'FIXED_JACKPOT',
  PayoutOption = 'PAYOUT_OPTION'
}

export type LotteryResultsMultipleLines = {
  __typename?: 'LotteryResultsMultipleLines';
  /** The total amount of plays (for pagination purposes) */
  countOfPlays: Scalars['Int']['output'];
  /** Drawn numbers for the lottery 'name', will be 'null' until numbers are saved at the draw */
  drawnNumbers?: Maybe<DrawnNumbersMultipleLines>;
  /** Name of the DrawnNumbersGroup, either 'DEFAULT or 'DOUBLE_PLAY', 'GREENBALL' etc. */
  group: Scalars['String']['output'];
  /**
   *
   *             Returns a paginated list of plays for the play slip order.
   *             Valid values for the limit are 1 to 50.
   *             Valid values for offset are at least 0.
   *             The default values are 0 for offset and 10 for limit.
   *
   *             To load only plays for a specific draw date and number group, provide the 'drawDateOfPlay' and 'groupOfPlays' parameters.
   *
   */
  plays: Array<PlayMultipleLines>;
};


export type LotteryResultsMultipleLinesPlaysArgs = {
  drawDateOfPlays?: InputMaybe<Scalars['DateTime']['input']>;
  groupOfPlays?: InputMaybe<Scalars['DrawnNumbersGroup']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type LotterySpecificPrizeTierCategoryRequirements = PrizeTierCategoryRequirements & {
  __typename?: 'LotterySpecificPrizeTierCategoryRequirements';
  type: PrizeTierCategoryRequirementsPayloadType;
};

export type LotterySpecificPrizeTierRequirements = PrizeTierRequirements & {
  __typename?: 'LotterySpecificPrizeTierRequirements';
  type: PrizeTierRequirementsPayloadType;
};

export type LotteryTeaserPayload = {
  __typename?: 'LotteryTeaserPayload';
  campaign?: Maybe<CampaignPayload>;
  closingDate: Scalars['DateTime']['output'];
  comingSoon: Scalars['Boolean']['output'];
  drawDate: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  jackpotSize: Money;
  jackpotType: JackpotType;
  lotteryType: LotteryType;
  quickPick?: Maybe<QuickPickConfiguration>;
};

export enum LotteryType {
  DateLottery = 'DATE_LOTTERY',
  NumberLottery = 'NUMBER_LOTTERY',
  PickLottery = 'PICK_LOTTERY'
}

export type LoudlyVerifyEmailError = LoudlyVerifyEmailError_EmailExists | LoudlyVerifyEmailError_InvalidPlayerStatus | LoudlyVerifyEmailError_TokenExpired | LoudlyVerifyEmailError_UnknownToken;

export type LoudlyVerifyEmailError_EmailExists = TypedGraphQlError & {
  __typename?: 'LoudlyVerifyEmailError_EmailExists';
  message: Scalars['String']['output'];
};

export type LoudlyVerifyEmailError_InvalidPlayerStatus = TypedGraphQlError & {
  __typename?: 'LoudlyVerifyEmailError_InvalidPlayerStatus';
  message: Scalars['String']['output'];
};

export type LoudlyVerifyEmailError_TokenExpired = TypedGraphQlError & {
  __typename?: 'LoudlyVerifyEmailError_TokenExpired';
  message: Scalars['String']['output'];
};

export type LoudlyVerifyEmailError_UnknownToken = TypedGraphQlError & {
  __typename?: 'LoudlyVerifyEmailError_UnknownToken';
  message: Scalars['String']['output'];
};

export type LoudlyVerifyEmailErrors = {
  __typename?: 'LoudlyVerifyEmailErrors';
  errors: Array<LoudlyVerifyEmailError>;
};

export type LoudlyVerifyEmailInput = {
  token: Scalars['String']['input'];
};

export type LoudlyVerifyEmailPayload = {
  __typename?: 'LoudlyVerifyEmailPayload';
  success: Scalars['Boolean']['output'];
};

export type LoudlyVerifyEmailPayload_Or_LoudlyVerifyEmailErrors = LoudlyVerifyEmailErrors | LoudlyVerifyEmailPayload;

export type LuckyLines = PrizeTierRequirements & {
  __typename?: 'LuckyLines';
  matchingLines: Array<Scalars['Int']['output']>;
  type: PrizeTierRequirementsPayloadType;
};

export enum MarketingChannel {
  Email = 'EMAIL',
  PushNotification = 'PUSH_NOTIFICATION',
  Sms = 'SMS'
}

export type MarketingChannelPreferenceMutationInput = {
  activated: Scalars['Boolean']['input'];
  channel: MarketingChannel;
};

export type MarketingChannelPreferencesPayload = {
  __typename?: 'MarketingChannelPreferencesPayload';
  activated: Scalars['Boolean']['output'];
  channel: MarketingChannel;
  verified: Scalars['Boolean']['output'];
};

export type MarketingPreferencesPayload = {
  __typename?: 'MarketingPreferencesPayload';
  channels: Array<MarketingChannelPreferencesPayload>;
};

export type MaxLimit = Limit & {
  __typename?: 'MaxLimit';
  period: LimitPeriod;
  type: LimitType;
  value: Money;
};

export type Money = {
  __typename?: 'Money';
  currency: Scalars['String']['output'];
  value: Scalars['Long']['output'];
};

export type MoneyBackInput = {
  code: Scalars['String']['input'];
};

export type MoneyBackPayload = {
  __typename?: 'MoneyBackPayload';
  code: Scalars['String']['output'];
  id: Scalars['String']['output'];
  price: Money;
  productId: Scalars['String']['output'];
  status: MoneyBackStatus;
};

export enum MoneyBackStatus {
  Created = 'CREATED',
  Expired = 'EXPIRED',
  Redeemed = 'REDEEMED'
}

export type MoneyInput = {
  currency: Scalars['String']['input'];
  value: Scalars['Long']['input'];
};

export type MoneySummary = {
  __typename?: 'MoneySummary';
  perUnit: Money;
  sum: Money;
};

export type MultiplyingCharge = {
  __typename?: 'MultiplyingCharge';
  id: Scalars['String']['output'];
  multiplier: Scalars['Int']['output'];
  perPlay: Scalars['Boolean']['output'];
  type: PriceType;
};

export type MultiplyingFee = {
  __typename?: 'MultiplyingFee';
  id: Scalars['String']['output'];
  multiplier: Scalars['Int']['output'];
  perPlay: Scalars['Boolean']['output'];
  type: PriceType;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Store acknowledgement of terms and conditions. */
  acknowledgeTermsAndConditions: AcknowledgeTacPayload;
  /**
   *
   * Adds funds to the player's account.
   * Possible errors:
   * - internal.error In case of a server error.
   * - authentication.noauthheader If the player is not logged in.
   * - validation.addfunds.fundinglimitexceeded If none of the price points is lower or equal to the player's funding limit.
   * - validation.addfunds.amounttoohigh Amount > maximum allowed add funds limit
   * - validation.addfunds.amounttoolow Amount < minimum allowed add funds limit
   * - validation.addfunds.amountnopricepoint The given amount is not included in the price points
   * - validation.addfunds.invalidpaymentid The given payment ID has an invalid format or the payment can not be found
   * - validation.addfunds.alreadyprocessed The funding process for the given payment ID is already started
   * - validation.addfunds.invalidpaymentprovider The given payment provider does not support funding
   * - validation.addfunds.invalidpaymenttype The given payment type is invalid
   * - validation.addfunds.invalidpaymentmethod The given payment method is invalid
   * - validation.addfunds.cvvrequired The given payment method requires re-entering the CVV for stored cards, but none was provided
   * - location.wrongcountry.error If the user is located in a country other than the expected one
   * - location.wrongstate.error If the user is located in the expected country but a different state than expected
   * - location.confidencetoolow.error If the confidence that the user is in the expected location is too low
   * - location.consenttimedout.error If the location data sent to the location provider are too old
   * - location.notavailable.error If the location could not be determined
   * - location.spoofingdetected.error If the location check detected a spoofing attempt
   * - location.wrongiplocation.error If the IP is not located in the allowed country or state
   * - location.unauthorizedforlocation.error If the location check has not been authorized by the user
   * - location.profilingeventissue.error If the location check encountered a profiling event issue
   * - location.interceptordetected.error If the location check detected an interceptor like VPN or TOR
   * - location.privatebrowsingdetected.error If the location check detected that private browsing is active
   * - location.iproutingissue.error If the location check ran into an IP routing issue
   * - location.locationfail.error If the device could not be located by the specified location method
   * - location.profilerejected.error If the device profile analysis showed a fraud risk
   * - location.internal.error If an unexpected error occurred while determining the user's location
   *
   */
  addFunds: AddFundsStatusPayload;
  /**
   *
   * Creates a new pay out account (instrument) for the customer.
   *
   * Possible errors:
   * - internal.error In case of a server error.
   * - notfound.payout.account If there is no pay out account for the given payoutAccountId
   * - player.notfound If the player with the given playerId does not exist
   * - player.notverified If the player is not verified and cannot pay out
   * - validation.payout.providerdisabled If the associated pay out provider is not enabled in the customer's licensed territory
   * - validation.payout.invalidinstrument If the customer tries to pay out to a saved bank account while another payout instrument is active
   * - payout.aeropay.missinguserid If the Aeropay user ID is not provided when creating a new Aeropay pay out account
   * - payout.aeropay.missinguserpassword If the Aeropay user password is not provided when creating a new Aeropay pay out account
   * - payout.bank.missingaccountnumber If the bank account number is not provided when creating a new bank pay out account
   * - payout.bank.missingroutingnumber If the bank routing number is not provided when creating a new bank pay out account
   *
   */
  addPayOutAccount: AddPayOutAccountPayload;
  /**
   *
   * Creates a new payment instrument or updates an existing one. Currently only credit cards are supported.
   * Possible errors:
   * - paymenttype.invalid if the paymentData's type is invalid (i.E. currently anything other than 'CreditCard')
   * - cardtype.invalid if the paymentData's 'cardType' does not exist or is not a valid payment method
   * - provider.active if the paymentData's 'provider' is not enabled for the user's licensed territory
   * - provider.invalid if the paymentData's 'provider' is not a recognized provider
   * - instrument.registration.failed if the registration of the payment instrument failed
   * - paymentdata.invalid if required values for the requested provider are missing from the payment data
   */
  addPaymentInstrument: AddPaymentInstrumentPayload;
  /**
   *
   *         Lets the player apply a bonus code on the checkout page.
   *         The same validations as in the BonusCodeValidationQuery apply, but this mutation is only accessible for logged in customers.
   *         If the validation of the bonus code succeeds, the checkout is messaged, so that it can update the discounted price accordingly.
   *         Any already applied bonus code will be removed.
   *         If the bonus code validation fails, one of the following errors is possible:
   *         - validation.bonusconditions.notfulfilled
   *           If the bonus code can be applied, but some of the bonus' conditions have not been fulfilled yet.
   *         - validation.bonusconditions.unfulfillable
   *           If the bonus code cannot be applied (e.g. the promotion belonging to the bonus code has expired).
   *
   *         If product ID cannot be resolved to a product, then the following error will be returned:
   *         - product.unknown
   *
   */
  applyBonusCode: BonusValidationResult;
  /**
   *
   *     Attempts to buy the given product (e.g. play slip).
   *     Possible errors:
   *     - account.notfound If no account for the current player was found
   *     - product.notfound If the given product was not found
   *     - player.notfound If the current player is not known
   *     - insufficientfunds.error If the current player's account has insufficient funds to buy the product
   *     - limit.exceeded.error If there are limits on the current player's account that would be exceeded by the purchase
   *     - order.update.error If an error occurred while updating the order
   *     - product.update.error If an error occurred while updating the product
   *     - player.status.error If the current player's status (e.g. SelfExcluded) prevents them from purchasing
   *     - player.notverified.error If the current player hasn't been verified
   *     - server.error If an unexpected error occurred while processing the purchase
   *     - stake.error If an error occurred while processing the stake transaction
   *     - location.wrongcountry.error If the user is located in a country other than the expected one
   *     - location.wrongstate.error If the user is located in the expected country but a different state than expected
   *     - location.confidencetoolow.error If the confidence that the user is in the expected location is too low
   *     - location.consenttimedout.error If the location data sent to the location provider are too old
   *     - location.notavailable.error If the location could not be determined
   *     - location.spoofingdetected.error If the location check detected a spoofing attempt
   *     - location.wrongiplocation.error If the IP is not located in the allowed country or state
   *     - location.unauthorizedforlocation.error If the location check has not been authorized by the user
   *     - location.profilingeventissue.error If the location check encountered a profiling event issue
   *     - location.interceptordetected.error If the location check detected an interceptor like VPN or TOR
   *     - location.privatebrowsingdetected.error If the location check detected that private browsing is active
   *     - location.iproutingissue.error If the location check ran into an IP routing issue
   *     - location.locationfail.error If the device could not be located by the specified location method
   *     - location.profilerejected.error If the device profile analysis showed a fraud risk
   *     - location.internal.error If an unexpected error occurred while determining the user's location
   *
   */
  buySingleProductWithBalance: Order;
  /**
   *
   *     Attempts to buy the given product (e.g. play slip).
   *     Possible errors:
   *     - account.notfound If no account for the current player was found
   *     - product.notfound If the given product was not found
   *     - player.notfound If the current player is not known
   *     - insufficientfunds.error If the current player's account has insufficient funds to buy the product
   *     - limit.exceeded.error If there are limits on the current player's account that would be exceeded by the purchase
   *     - order.update.error If an error occurred while updating the order
   *     - product.update.error If an error occurred while updating the product
   *     - player.status.error If the current player's status (e.g. SelfExcluded) prevents them from purchasing
   *     - player.notverified.error If the current player hasn't been verified
   *     - server.error If an unexpected error occurred while processing the purchase
   *     - stake.error If an error occurred while processing the stake transaction
   *     - location.wrongcountry.error If the user is located in a country other than the expected one
   *     - location.wrongstate.error If the user is located in the expected country but a different state than expected
   *     - location.confidencetoolow.error If the confidence that the user is in the expected location is too low
   *     - location.consenttimedout.error If the location data sent to the location provider are too old
   *     - location.notavailable.error If the location could not be determined
   *     - location.spoofingdetected.error If the location check detected a spoofing attempt
   *     - location.wrongiplocation.error If the IP is not located in the allowed country or state
   *     - location.unauthorizedforlocation.error If the location check has not been authorized by the user
   *     - location.profilingeventissue.error If the location check encountered a profiling event issue
   *     - location.interceptordetected.error If the location check detected an interceptor like VPN or TOR
   *     - location.privatebrowsingdetected.error If the location check detected that private browsing is active
   *     - location.iproutingissue.error If the location check ran into an IP routing issue
   *     - location.locationfail.error If the device could not be located by the specified location method
   *     - location.profilerejected.error If the device profile analysis showed a fraud risk
   *     - location.internal.error If an unexpected error occurred while determining the user's location
   *
   */
  buySingleProductWithPxpCreditCard: Order;
  /**
   *
   *     Attempts to buy the given product (e.g. play slip).
   *     Possible errors:
   *     - account.notfound If no account for the current player was found
   *     - product.notfound If the given product was not found
   *     - player.notfound If the current player is not known
   *     - insufficientfunds.error If the current player's account has insufficient funds to buy the product
   *     - limit.exceeded.error If there are limits on the current player's account that would be exceeded by the purchase
   *     - order.update.error If an error occurred while updating the order
   *     - product.update.error If an error occurred while updating the product
   *     - player.status.error If the current player's status (e.g. SelfExcluded) prevents them from purchasing
   *     - player.notverified.error If the current player hasn't been verified
   *     - server.error If an unexpected error occurred while processing the purchase
   *     - stake.error If an error occurred while processing the stake transaction
   *     - location.wrongcountry.error If the user is located in a country other than the expected one
   *     - location.wrongstate.error If the user is located in the expected country but a different state than expected
   *     - location.confidencetoolow.error If the confidence that the user is in the expected location is too low
   *     - location.consenttimedout.error If the location data sent to the location provider are too old
   *     - location.notavailable.error If the location could not be determined
   *     - location.spoofingdetected.error If the location check detected a spoofing attempt
   *     - location.wrongiplocation.error If the IP is not located in the allowed country or state
   *     - location.unauthorizedforlocation.error If the location check has not been authorized by the user
   *     - location.profilingeventissue.error If the location check encountered a profiling event issue
   *     - location.interceptordetected.error If the location check detected an interceptor like VPN or TOR
   *     - location.privatebrowsingdetected.error If the location check detected that private browsing is active
   *     - location.iproutingissue.error If the location check ran into an IP routing issue
   *     - location.locationfail.error If the device could not be located by the specified location method
   *     - location.profilerejected.error If the device profile analysis showed a fraud risk
   *     - location.internal.error If an unexpected error occurred while determining the user's location
   *
   */
  buySingleProductWithTopUp: Order;
  /** Cancels a subscription and returns the resulting subscription code. */
  cancelSubscription: SubscriptionInfo;
  changeLimitValue: Array<Limit>;
  /**
   *
   * Change a logged-in player's language preference.
   * Languages are normalized to English (en_US) and Spanish (es_US).
   * Later, this will be extended so that other player data can be changed as well.
   *
   */
  changePlayerData: ChangePlayerDataPayload;
  /** Change a logged-in players two factor configuration. */
  changeTwoFactorConfiguration: ChangeTwoFactorConfigurationPayload;
  /** Closes a player's account */
  closePlayer: ClosePlayerPayload;
  /**
   *
   *         When Aeropay already knows the user, it sends a multi-factor authentication (MFA) code to the user's email address.
   *         This mutation confirms that code. This only has to be done once per existing Aeropay user (not for new users).
   *
   *         Possible errors:
   *         - player.notfound: The player does not exist.
   *         - player.notverified: The player is not verified and cannot pay out.
   *         - paymentprovider.error.unknown: Aeropay is not active/configured for the given licensed territory.
   *         - validation.aeropayuser.invalidmfacode: The MFA code is invalid.
   *         - validation.aeropayuser.mfamaxattempts: The maximum number of attempts to confirm the MFA code has been exceeded.
   *         - error.aeropayuser.internalservererror: An internal server error occurred while confirming the MFA code.
   *
   */
  confirmMfa: AeropayConfirmMfaPayload;
  /**
   *
   *         Deactivates a given payIn or payOut instrument.
   *         Possible errors:
   *         - paymentinstrument.notfound If the specified payIn/payOut instrument was not found for the player
   *
   */
  deactivateStoredPaymentInstrument: TogglePaymentInstrument;
  /**
   *
   *             Replays a High Frequency Game play slip.
   *
   *             Possible errors:
   *             - `highfrequency.replay.error.internalserver`: If an internal error occurs.
   *             - `highfrequency.replay.playslip.notreplayable`: If the play slip licensed territory does not match the input licensed territory or the status is not revealed or cancelled.
   *             - `highfrequency.replay.licensedterritory.invalid`: If the provided licensed territory is invalid.
   *             - `highfrequency.replay.playslip.notfound`: If the play slip cannot be found by the provided order ID.
   *             - `highfrequency.replay.orderid.invalid`: If the provided order ID is invalid.
   *             - `highfrequency.replay.player.cannotplay`: If the player is not allowed to play (e.g. due to restrictions or insufficient funds).
   *             - `highfrequency.replay.game.notactive`: If the game is currently not active in the licensed territory.
   *
   */
  highFrequencyReplayPlaySlip: HighFrequency_PlaySlipStored_Or_HighFrequency_ReplayErrors;
  /**
   *
   *             Reveals a single participation from a play slip.
   *
   *             If all participations from the play slip are revealed, the play slip will also be revealed.
   *
   *             Possible errors:
   *             - `highfrequency.reveal.failed`: If any error occurs. The specific error is logged.
   *
   */
  highFrequencyRevealDrawParticipation: HighFrequency_DrawParticipationRevealPayload_Or_HighFrequency_RevealErrors;
  /**
   *
   *         Reveals the whole play slip with all its participations, if they are evaluated.
   *
   *         Possible errors:
   *         - `highfrequency.reveal.failed`: If any error occurs. The specific error is logged.
   *
   */
  highFrequencyRevealOrder: HighFrequency_OrderDetailsPayload_Or_HighFrequency_RevealErrors;
  /**
   *
   *             Stores an ordered play slip.
   *
   *             Possible errors:
   *             - `highfrequency.disclaimernotaccepted`: The disclaimer was not accepted.
   *             - `highfrequency.invalidplayslip`: The play slip input is invalid (e.g. invalid numbers, draws or add-ons).
   *             - `highfrequency.maxplayslippriceexceeded`: The play slip price exceeds the maximum allowed price for the game.
   *             - `highfrequency.playercannotplay`: The player cannot play (e.g. unknown player or unexpected validation error).
   *             - `highfrequency.playerrestriced`: The player is currently restricted from playing (e.g. reached his spending limit).
   *             - `highfrequency.error.internalserver`: An unexpected internal error occurred. The specific error is logged.
   *
   */
  highFrequencyStorePlaySlip: HighFrequency_PlaySlipStored_Or_HighFrequency_PlaySlipStoredErrors;
  /** Verifies a user’s email address */
  loudlyVerifyEmail: LoudlyVerifyEmailPayload_Or_LoudlyVerifyEmailErrors;
  /**
   *
   * Creates a pay out bank account and a pay out of the given amount.
   *
   * Possible errors:
   * - validation.payout.minimum If the pay out amount is lower than the minimum value.
   * - validation.payout.notEnoughPayableBalance If the customer account does not have enough payable balance
   * - validation.payout.invalidinstrument If the customer has an active PayPal instrument, it must be used instead
   *
   */
  payOutToBankAccount: PayOutPayload;
  /**
   *
   * Creates a pay out of the given amount and the saved pay out account referenced by the payoutAccountId.
   * Possible errors:
   * - notfound.payout.account If there is no pay out account for the given payoutAccountId
   * - validation.payout.minimum If the pay out amount is lower than the minimum value.
   * - validation.payout.notEnoughPayableBalance If the customer account does not have enough payable balance
   * - validation.payout.invalidinstrument If the customer tries to pay out to a saved bank account while another payout instrument is active
   *
   */
  payOutToSavedAccount: PayOutPayload;
  /**
   *
   *         Registers a new Aeropay user or returns an existing user. Aeropay differentiates between a 'Network' user that is not
   *         associated with our merchant account and a 'Returning' user that is. Both are existing users, but the former must perform
   *         a one-time multi-factor authentication (MFA) step to link their Aeropay user to our merchant account.
   *         Must be called before any other Aeropay operation.
   *
   *         Possible errors:
   *         - player.notfound: The player does not exist.
   *         - player.notverified: The player is not verified and cannot pay out.
   *         - paymentprovider.error.unknown: Aeropay is not active/configured for the given licensed territory.
   *         - error.aeropayuser.creationfailed: Failed to create the Aeropay user. (See error logs for details.)
   *
   */
  registerUser: AeropayRegisterUserPayload;
  /**
   *
   *         Removes an applied bonus code from a product for a logged in player.
   *         If the bonus code does not exist, the following error is returned:
   *         - validation.bonuscode.unknown
   *
   *         If an invalid product ID is supplied, the mutation will return:
   *         - product.unknown
   *
   *         If for any reason the message cannot be send to the checkout, this error will be returned:
   *         - internal.error
   *
   */
  removeBonusCode: BonusCodeRemovalPayload;
  /** Stores a new play slip from the one defined with the 'playSlipId' parameter. */
  replayPlaySlip: PlaySlipStored;
  /** Requests an email for verifying a player’s email address */
  requestEmailVerification: RequestEmailVerificationPayload_Or_RequestEmailVerificationErrors;
  /** Requests money back */
  requestMoneyBack: MoneyBackPayload;
  /** Requests a new phone verification code */
  requestVerificationCode: ResendCodePayload;
  /** Resend an existing verification token for verification of a user’s email address */
  resendEmailVerification: ResendEmailVerificationPayload_Or_ResendEmailVerificationErrors;
  /**
   *
   *             Attempts to reserve a quantity of scratchcards for a game.
   *
   *             Possible error codes:
   *             - validation.licensedterritory.invalid - if the licensed territory has an invalid format
   *             - validation.licensedterritory.unknown - if the licensed territory is not configured
   *             - validation.value.notinrange - if the requested quantity falls outside the allowed range
   *             - validation.slug.invalid - if the given game slug has an invalid format
   *             - validation.game.notfound - if the game could not be found
   *             - validation.player.notfound - if the player could not be found
   *             - validation.player.invalidstatus - if the player is not verified
   *             - validation.player.minimumage - if the player is below the licensed territory's minimum age
   *             - validation.spendinglimit.exceeded - if the player's limit would be exceeded by reserving
   *             - unavailable.game.soldout - if all scratch cards for the game have been sold
   *             - unavailable.game.reserved - if all scratch cards for the game have been either sold or reserved (reservations may expire)
   *             - unavailable.game.limitedstock - if there are fewer scratch cards available than requested (reservations may expire)
   *             - error.internalserver - if a database error occurs
   *
   */
  reserveScratchcards: ScratchcardReservation;
  /**
   *
   *             Reveals ("scratches") all scratchcards for an order.
   *
   *             The order must belong to the logged in player. The mutation returns the revealed order.
   *
   *             Possible error codes:
   *             - validation.game.notfound - if the game could not be found
   *             - validation.scratchcardorder.notfound - if the order could not be found or does not belong to the logged in player
   *             - validation.scratchcardstate.wrong - if the order does not have the correct state (must be SCRATCHED or REVEALED)
   *             - notfound.scratchcard.id - if one of the scratchcards of the order could not be found
   *             - error.internalServer - if a database error occurs
   *
   */
  revealOrder: ScratchcardOrderDetail;
  /**
   *
   *             Reveals ("scratches") a single scratchcard.
   *
   *             The card must belong to the logged in player. The mutation returns the winnings of the scratchcard.
   *
   *             Possible error codes:
   *             - validation.game.notfound - if the game could not be found
   *             - validation.scratchcard.notfound - if the given scratchcard could not be found or does not belong to the logged in player
   *             - validation.scratchcardstate.wrong - if the scratchcard does not have the correct state (must be SCRATCHED or REVEALED)
   *             - error.internalServer - if a database error occurs
   *
   */
  revealScratchcard: WinningsPayload;
  /** Set a player's account to self-exclude */
  selfExclusion: SelfExclusionPayload;
  /** sets the marketing channel preferences for the player. */
  setMarketingChannelPreferences: MarketingChannelPreferencesPayload;
  setPreferences: Array<PreferencePayload>;
  setScanVerifyUploadStatus: VerificationPayload;
  /** Silently verifies a user’s email address */
  silentlyVerifyEmail: SilentlyVerifyEmailPayload;
  /** Stores a play slip and returns the resulting play slip order ID. */
  storePlaySlip: PlaySlipStored;
  unsubscribeMarketingEmails: UnsubscribeMarketingPayload;
  uploadIdentityDocument: UploadIdentityDocumentPayload;
  /**
   * Silently verifies a user’s email address
   * @deprecated Use `silentlyVerifyEmail` instead
   */
  verifyEmail: VerifyEmailPayload;
  /** Verifies a phone number if given a valid phone verification code */
  verifyPhone: VerifyPhonePayload;
};


export type MutationAddFundsArgs = {
  input: AddFundsMutationInput;
};


export type MutationAddPayOutAccountArgs = {
  input: AddPayOutAccountInput;
};


export type MutationAddPaymentInstrumentArgs = {
  input: AddPaymentInstrumentInput;
};


export type MutationApplyBonusCodeArgs = {
  bonusCode: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};


export type MutationBuySingleProductWithBalanceArgs = {
  licensedTerritory: Scalars['String']['input'];
  locationProfilingId: Scalars['String']['input'];
  locationSessionId?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['ProductId']['input'];
  submitterIPAddress?: InputMaybe<Scalars['String']['input']>;
};


export type MutationBuySingleProductWithPxpCreditCardArgs = {
  licensedTerritory: Scalars['String']['input'];
  locationProfilingId: Scalars['String']['input'];
  locationSessionId?: InputMaybe<Scalars['String']['input']>;
  paymentData: PxpCreditCardInput;
  productId: Scalars['ProductId']['input'];
  submitterIPAddress?: InputMaybe<Scalars['String']['input']>;
};


export type MutationBuySingleProductWithTopUpArgs = {
  licensedTerritory: Scalars['String']['input'];
  locationProfilingId: Scalars['String']['input'];
  locationSessionId?: InputMaybe<Scalars['String']['input']>;
  paymentData: PaymentDataInput;
  productId: Scalars['ProductId']['input'];
  submitterIPAddress?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCancelSubscriptionArgs = {
  input: SubscriptionInput;
};


export type MutationChangeLimitValueArgs = {
  type: LimitType;
  value: LimitsInput;
};


export type MutationChangePlayerDataArgs = {
  input: ChangePlayerDataInput;
};


export type MutationChangeTwoFactorConfigurationArgs = {
  input: TwoFactorAuthenticationChannelSettingPayloadInput;
};


export type MutationClosePlayerArgs = {
  input: ClosePlayerInput;
};


export type MutationConfirmMfaArgs = {
  input: AeropayConfirmMfaInput;
};


export type MutationDeactivateStoredPaymentInstrumentArgs = {
  input: DeactivateStoredPaymentInstrumentInput;
};


export type MutationHighFrequencyReplayPlaySlipArgs = {
  input: HighFrequencyReplayPlaySlipInput;
};


export type MutationHighFrequencyRevealDrawParticipationArgs = {
  input: HighFrequencyRevealDrawParticipationInput;
};


export type MutationHighFrequencyRevealOrderArgs = {
  input: HighFrequencyRevealOrderInput;
};


export type MutationHighFrequencyStorePlaySlipArgs = {
  input: HighFrequency_PlaySlipInput;
};


export type MutationLoudlyVerifyEmailArgs = {
  input: LoudlyVerifyEmailInput;
};


export type MutationPayOutToBankAccountArgs = {
  input: BankPayOutInput;
};


export type MutationPayOutToSavedAccountArgs = {
  input: SavedPayOutInput;
};


export type MutationRegisterUserArgs = {
  input: AeropayRegisterUserInput;
};


export type MutationRemoveBonusCodeArgs = {
  bonusCode: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};


export type MutationReplayPlaySlipArgs = {
  licensedTerritory: Scalars['String']['input'];
  playSlipOrderId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRequestEmailVerificationArgs = {
  input: RequestEmailVerificationInput;
};


export type MutationRequestMoneyBackArgs = {
  input: MoneyBackInput;
};


export type MutationRequestVerificationCodeArgs = {
  input: ResendCodeMutationInput;
};


export type MutationResendEmailVerificationArgs = {
  input: ResendEmailVerificationInput;
};


export type MutationReserveScratchcardsArgs = {
  input: ReserveScratchcardsInput;
};


export type MutationRevealOrderArgs = {
  input: RevealOrderInput;
};


export type MutationRevealScratchcardArgs = {
  input: RevealScratchcardInput;
};


export type MutationSelfExclusionArgs = {
  input: SelfExclusionInput;
};


export type MutationSetMarketingChannelPreferencesArgs = {
  input: MarketingChannelPreferenceMutationInput;
};


export type MutationSetPreferencesArgs = {
  input: PreferencesInput;
};


export type MutationSetScanVerifyUploadStatusArgs = {
  input: SetScanVerifyUploadStatusInput;
};


export type MutationSilentlyVerifyEmailArgs = {
  input: SilentlyVerifyEmailInput;
};


export type MutationStorePlaySlipArgs = {
  input: PlaySlipInput;
};


export type MutationUnsubscribeMarketingEmailsArgs = {
  input: UnsubscribeMarketingInput;
};


export type MutationUploadIdentityDocumentArgs = {
  input: UploadIdentityDocumentInput;
};


export type MutationVerifyEmailArgs = {
  input: VerifyEmailInput;
};


export type MutationVerifyPhoneArgs = {
  input: VerifyPhoneInput;
};

export enum Notification {
  CreditNoteGranted = 'CREDIT_NOTE_GRANTED',
  DormancyReminder = 'DORMANCY_REMINDER',
  EmailChanged = 'EMAIL_CHANGED',
  EmailVerificationRequested = 'EMAIL_VERIFICATION_REQUESTED',
  FundsAdded = 'FUNDS_ADDED',
  GameNumbersChanged = 'GAME_NUMBERS_CHANGED',
  HfgOrderConfirmation = 'HFG_ORDER_CONFIRMATION',
  HfgOrderReady = 'HFG_ORDER_READY',
  HfgOrderRevealed = 'HFG_ORDER_REVEALED',
  HfgProductCancelled = 'HFG_PRODUCT_CANCELLED',
  Login = 'LOGIN',
  LoginCode = 'LOGIN_CODE',
  LoyaltyGameWin = 'LOYALTY_GAME_WIN',
  MoneyBackCreated = 'MONEY_BACK_CREATED',
  MoneyBackReminder = 'MONEY_BACK_REMINDER',
  OrderConfirmation = 'ORDER_CONFIRMATION',
  PasswordChanged = 'PASSWORD_CHANGED',
  PasswordReset = 'PASSWORD_RESET',
  PasswordResetRequested = 'PASSWORD_RESET_REQUESTED',
  PayoutConfirmation = 'PAYOUT_CONFIRMATION',
  PayoutRejected = 'PAYOUT_REJECTED',
  PhoneVerificationCode = 'PHONE_VERIFICATION_CODE',
  PlayerAccountClosed = 'PLAYER_ACCOUNT_CLOSED',
  PlayerCoolOff = 'PLAYER_COOL_OFF',
  PlayerLoginBlocked = 'PLAYER_LOGIN_BLOCKED',
  PlayerManuallyAgeVerified = 'PLAYER_MANUALLY_AGE_VERIFIED',
  PlayerSelfExcluded = 'PLAYER_SELF_EXCLUDED',
  PlayerSuspended = 'PLAYER_SUSPENDED',
  PlayerSuspendedAfterSelfExclusion = 'PLAYER_SUSPENDED_AFTER_SELF_EXCLUSION',
  ProductCancelled = 'PRODUCT_CANCELLED',
  PurchaseConfirmation = 'PURCHASE_CONFIRMATION',
  ScratchcardBatchCancelled = 'SCRATCHCARD_BATCH_CANCELLED',
  ScratchcardOrdered = 'SCRATCHCARD_ORDERED',
  ScratchcardOrderRevealed = 'SCRATCHCARD_ORDER_REVEALED',
  ScratchcardReady = 'SCRATCHCARD_READY',
  ScratchcardWin = 'SCRATCHCARD_WIN',
  SubscriptionCancellation = 'SUBSCRIPTION_CANCELLATION',
  VerifyEmailChange = 'VERIFY_EMAIL_CHANGE',
  Welcome = 'WELCOME',
  WinningCorrection = 'WINNING_CORRECTION',
  WinningNotification = 'WINNING_NOTIFICATION'
}

export enum NotificationChannel {
  Email = 'EMAIL',
  Sms = 'SMS'
}

export type NumberLottery = PrizeTierRequirements & {
  __typename?: 'NumberLottery';
  numberRequirements: Array<NumberRequirement>;
  type: PrizeTierRequirementsPayloadType;
};

export type NumberRequirement = {
  __typename?: 'NumberRequirement';
  amountOfCorrectNumbers: Scalars['Int']['output'];
  numbersReference: Scalars['String']['output'];
};

export type NumberWithMatch = {
  __typename?: 'NumberWithMatch';
  matching: Scalars['Boolean']['output'];
  value: Scalars['Int']['output'];
};

export type Numbers = LotteryNumbersSortableByName & {
  __typename?: 'Numbers';
  /** When set, the value(s) already set in the `Numbers` block with the name stored in this field. They just have additional properties (like the Bullseye number for NJ Cash5, where this field would refer to 'BASE') */
  modifies?: Maybe<Scalars['String']['output']>;
  /** Matches lottery numbers name like 'BASE' or 'EXTRA' */
  name: Scalars['String']['output'];
  values: Array<Scalars['Int']['output']>;
};

export type NumbersConfig = {
  __typename?: 'NumbersConfig';
  ignoredForAddOns: Array<AddOnWithValue>;
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  selectableMax: Scalars['Int']['output'];
  selectableMin: Scalars['Int']['output'];
};

export type OperatingHoursRange = {
  __typename?: 'OperatingHoursRange';
  nextEndInclusive: Scalars['Instant']['output'];
  nextStart: Scalars['Instant']['output'];
};

export type Order = {
  /** Optional bonus applied to this order */
  bonus?: Maybe<OrderBonus>;
  /** Flag that indicates whether this order is the first pay in */
  firstPayIn: Scalars['Boolean']['output'];
  /** Order id for this player */
  orderId: Scalars['OrderId']['output'];
  /** Federated play slip */
  playSlip: PlaySlipPayload;
  /** Unique order reference */
  reference: Scalars['String']['output'];
  status: OrderStatus;
};

export type OrderBonus = {
  __typename?: 'OrderBonus';
  /** Bonus code applied to this order */
  bonusCode: Scalars['String']['output'];
  /** Discount amount granted for this order */
  discount: Money;
};

export enum OrderStatus {
  Cancelled = 'CANCELLED',
  Paid = 'PAID',
  PartiallyCancelled = 'PARTIALLY_CANCELLED',
  PaymentDone = 'PAYMENT_DONE',
  Processing = 'PROCESSING'
}

export type OrderedTypePayload = {
  __typename?: 'OrderedTypePayload';
  highFrequency: Scalars['Boolean']['output'];
  lottery: Scalars['Boolean']['output'];
  scratchcard: Scalars['Boolean']['output'];
  subscription: Scalars['Boolean']['output'];
};

export type PaidOrder = Order & {
  __typename?: 'PaidOrder';
  bonus?: Maybe<OrderBonus>;
  firstPayIn: Scalars['Boolean']['output'];
  orderId: Scalars['OrderId']['output'];
  playSlip: PlaySlipPayload;
  reference: Scalars['String']['output'];
  status: OrderStatus;
};

export type PayOutAccount = {
  holderName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  type: PayOutAccountType;
};

export type PayOutAccountAeropay = PayOutAccount & {
  __typename?: 'PayOutAccountAeropay';
  /** Masked account number. Only the last 4 digits are displayed. */
  accountNumber: Scalars['String']['output'];
  /** A descriptive name for the bank account, such as 'Checking Account'. */
  bankAccountName: Scalars['String']['output'];
  /** The name of the bank. */
  bankName: Scalars['String']['output'];
  holderName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  type: PayOutAccountType;
};

export type PayOutAccountBank = PayOutAccount & {
  __typename?: 'PayOutAccountBank';
  /** Masked account number. Only the last 4 digits are displayed. */
  accountNumber: Scalars['String']['output'];
  holderName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /** Masked routing number. Only the last 4 digits are displayed. */
  routingNumber: Scalars['String']['output'];
  type: PayOutAccountType;
};

export type PayOutAccountPayPal = PayOutAccount & {
  __typename?: 'PayOutAccountPayPal';
  holderName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /** The payer's PayPal email address. */
  payPalPayerEmail: Scalars['String']['output'];
  type: PayOutAccountType;
};

export enum PayOutAccountType {
  Aeropay = 'Aeropay',
  Bank = 'Bank',
  PayPal = 'PayPal'
}

export type PayOutOptions = {
  __typename?: 'PayOutOptions';
  /** Saved accounts for pay out. Use the ID to call payOutToSavedAccount. */
  accounts: Array<PayOutAccount>;
  /** Given name + family name of the player used as account holder for payment accounts */
  holderName: Scalars['String']['output'];
  /** Initial details to create new pay out accounts */
  initialAccounts: Array<InitialPayOutAccount>;
  /** The maximum payable amount. */
  maxPayableBalance: Money;
  /** The lowest possible amount to pay out. */
  minPayableBalance: Money;
  restrictions?: Maybe<PaymentRestrictions>;
};

export type PayOutPayload = {
  __typename?: 'PayOutPayload';
  amount: Money;
  id: Scalars['String']['output'];
  state: PayOutState;
};

export enum PayOutState {
  Created = 'CREATED',
  Finished = 'FINISHED',
  Invalid = 'INVALID',
  OnHold = 'ON_HOLD',
  Performed = 'PERFORMED',
  Rejected = 'REJECTED'
}

export type PayWithBalance = Payment & {
  __typename?: 'PayWithBalance';
  accountBalance: Money;
  payWithBalance: Scalars['Boolean']['output'];
  topUpAmount: Money;
  totalPrice: Money;
};

export type PayWithTopUp = Payment & {
  __typename?: 'PayWithTopUp';
  accountBalance: Money;
  initial: Array<InitialPaymentInstrument>;
  payWithBalance: Scalars['Boolean']['output'];
  paymentId: Scalars['String']['output'];
  stored: Array<StoredPaymentInstrument>;
  topUpAmount: Money;
  totalPrice: Money;
};

export type Payload = {
  __typename?: 'Payload';
  iframeUrl: Scalars['String']['output'];
};

export type Payment = {
  accountBalance: Money;
  payWithBalance: Scalars['Boolean']['output'];
  topUpAmount: Money;
  totalPrice: Money;
};

export type PaymentDataEntryInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type PaymentDataInput = {
  accountId: Scalars['String']['input'];
  paymentId: Scalars['String']['input'];
  provider: Scalars['String']['input'];
  providerData: Array<PaymentDataEntryInput>;
  /** For example Visa, MasterCard etc. */
  specificType?: InputMaybe<Scalars['String']['input']>;
  stored: Scalars['Boolean']['input'];
  /** For example CreditCard, PayPal etc. */
  type: Scalars['String']['input'];
};

export enum PaymentInstrumentType {
  CreditCard = 'CreditCard',
  PayPal = 'PayPal',
  Venmo = 'Venmo'
}

export type PaymentInstrumentsError = {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type PaymentInstrumentsError_PaymentInstrumentsError_AmountExceedsFundingLimit = PaymentInstrumentsError & TypedGraphQlError & {
  __typename?: 'PaymentInstrumentsError_PaymentInstrumentsError_AmountExceedsFundingLimit';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type PaymentInstrumentsError_PaymentInstrumentsError_AmountTooLow = PaymentInstrumentsError & TypedGraphQlError & {
  __typename?: 'PaymentInstrumentsError_PaymentInstrumentsError_AmountTooLow';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type PaymentInstrumentsError_PaymentInstrumentsError_DatabaseError = PaymentInstrumentsError & TypedGraphQlError & {
  __typename?: 'PaymentInstrumentsError_PaymentInstrumentsError_DatabaseError';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type PaymentInstrumentsError_PaymentInstrumentsError_InvalidConfigurationError = PaymentInstrumentsError & TypedGraphQlError & {
  __typename?: 'PaymentInstrumentsError_PaymentInstrumentsError_InvalidConfigurationError';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type PaymentInstrumentsError_PaymentInstrumentsError_InvalidLicensedTerritory = PaymentInstrumentsError & TypedGraphQlError & {
  __typename?: 'PaymentInstrumentsError_PaymentInstrumentsError_InvalidLicensedTerritory';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type PaymentInstrumentsError_PaymentInstrumentsError_PlayerAgeVerificationError = PaymentInstrumentsError & TypedGraphQlError & {
  __typename?: 'PaymentInstrumentsError_PaymentInstrumentsError_PlayerAgeVerificationError';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type PaymentInstrumentsError_PaymentInstrumentsError_PlayerBelowMinimumAge = PaymentInstrumentsError & TypedGraphQlError & {
  __typename?: 'PaymentInstrumentsError_PaymentInstrumentsError_PlayerBelowMinimumAge';
  actualAge: Scalars['Int']['output'];
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  requiredAge: Scalars['Int']['output'];
};

export type PaymentInstrumentsError_PaymentInstrumentsError_PlayerNotFound = PaymentInstrumentsError & TypedGraphQlError & {
  __typename?: 'PaymentInstrumentsError_PaymentInstrumentsError_PlayerNotFound';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type PaymentInstrumentsError_PaymentInstrumentsError_PlayerNotVerified = PaymentInstrumentsError & TypedGraphQlError & {
  __typename?: 'PaymentInstrumentsError_PaymentInstrumentsError_PlayerNotVerified';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type PaymentInstrumentsError_PaymentInstrumentsError_Unauthenticated = PaymentInstrumentsError & TypedGraphQlError & {
  __typename?: 'PaymentInstrumentsError_PaymentInstrumentsError_Unauthenticated';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type PaymentInstrumentsErrors = {
  __typename?: 'PaymentInstrumentsErrors';
  errors: Array<PaymentInstrumentsError>;
};

export type PaymentInstrumentsInput = {
  amount: MoneyInput;
  licensedTerritory: Scalars['String']['input'];
  playerIpAddress: Scalars['String']['input'];
  userAgent?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentInstrumentsPayload = {
  __typename?: 'PaymentInstrumentsPayload';
  expires?: Maybe<Scalars['DateTime']['output']>;
  initial: Array<InitialPaymentInstrument>;
  paymentId: Scalars['String']['output'];
  stored: Array<StoredPaymentInstrument>;
};

export type PaymentInstrumentsPayload_Or_PaymentInstrumentsErrors = PaymentInstrumentsErrors | PaymentInstrumentsPayload;

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  allowsSubscriptionPurchase: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type PaymentRestrictions = {
  __typename?: 'PaymentRestrictions';
  playerCheck: PlayerRestriction;
};

export type PaymentToken = {
  __typename?: 'PaymentToken';
  expires: Scalars['DateTime']['output'];
  value: Scalars['String']['output'];
};

/** How often a prize is paid out */
export enum PayoutInterval {
  Daily = 'DAILY',
  Once = 'ONCE',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export type PendingPlaySlip = PlaySlip & {
  __typename?: 'PendingPlaySlip';
  firstDrawDate: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  lastDrawDate: Scalars['DateTime']['output'];
  licensedTerritory: Scalars['String']['output'];
  lotteryId: LotteryId;
  nextDrawDate: Scalars['DateTime']['output'];
  numberOfDraws: Scalars['Int']['output'];
  numberOfPlays: Scalars['Int']['output'];
  orderId: Scalars['String']['output'];
  orderedAt: Scalars['DateTime']['output'];
  selectedAddOns: Array<Scalars['String']['output']>;
  status: PlaySlipStatus;
  /** @deprecated Please check for (optional) subscriptionInfo instead */
  subscription: Scalars['Boolean']['output'];
  subscriptionInfo?: Maybe<SubscriptionInfo>;
};

export type PendingPlaySlipOrder = PlaySlipOrder & {
  __typename?: 'PendingPlaySlipOrder';
  firstDrawDate: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  lastDrawDate: Scalars['DateTime']['output'];
  licensedTerritory: Scalars['String']['output'];
  lotteryId: LotteryId;
  nextDrawDate: Scalars['DateTime']['output'];
  numberOfDraws: Scalars['Int']['output'];
  numberOfExtraHitPlays: Scalars['Int']['output'];
  numberOfPlays: Scalars['Int']['output'];
  orderId: Scalars['String']['output'];
  orderedAt: Scalars['DateTime']['output'];
  replayable: Scalars['Boolean']['output'];
  selectedAddOns: Array<Scalars['String']['output']>;
  status: PlaySlipOrderStatus;
  subscriptionInfo?: Maybe<SubscriptionInfo>;
};

/** Representation of a phone number. */
export type Phone = {
  __typename?: 'Phone';
  /** The country code of the phone number. */
  countryCode: Scalars['CountryCode']['output'];
  /** The phone number without the country code. */
  number: Scalars['NationalNumber']['output'];
  /** The verification status of this phone number */
  status: VerificationPayloadStatus;
};

export type PickLottery = PrizeTierRequirements & {
  __typename?: 'PickLottery';
  pickRequirements: Array<PickRequirement>;
  type: PrizeTierRequirementsPayloadType;
};

export type PickRequirement = {
  __typename?: 'PickRequirement';
  betType: Scalars['String']['output'];
  identicalDigits?: Maybe<Scalars['Int']['output']>;
  identicalPairs?: Maybe<Scalars['Int']['output']>;
  ignoreFields: Array<Scalars['String']['output']>;
  /** One of FORWARD, BACKWARD, IGNORED */
  order: Scalars['String']['output'];
  /** @deprecated use order instead */
  orderMatters: Scalars['Boolean']['output'];
};

export type PlayInput = {
  addOns: Array<AddOnInput>;
  fields: Array<FieldInput>;
  stake: StakeInput;
};

export type PlayMultipleLines = {
  /** A list of addons with values of the play slip for the respective draw */
  addOnValues: Array<AddOnOutput>;
  /** A list of all available addons for this draw's lottery */
  addOns: Array<AddOnOutput>;
  /** The list of fields with matches (if evaluated) */
  fields: Array<FieldWithMatches>;
  /** The serial number of the play slip */
  serialNumber: Scalars['String']['output'];
  /** The status of the play slip */
  state: PlaySlipStatus;
  /** The monetary or free ticket winnings (if evaluated) */
  winnings: WinningMultipleLines;
};

export type PlaySlip = {
  firstDrawDate: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  lastDrawDate: Scalars['DateTime']['output'];
  licensedTerritory: Scalars['String']['output'];
  lotteryId: LotteryId;
  nextDrawDate: Scalars['DateTime']['output'];
  numberOfDraws: Scalars['Int']['output'];
  numberOfPlays: Scalars['Int']['output'];
  orderId: Scalars['String']['output'];
  orderedAt: Scalars['DateTime']['output'];
  selectedAddOns: Array<Scalars['String']['output']>;
  status: PlaySlipStatus;
  /** @deprecated Please check for (optional) subscriptionInfo instead */
  subscription: Scalars['Boolean']['output'];
  subscriptionInfo?: Maybe<SubscriptionInfo>;
};

export type PlaySlipHistoryFilterInput = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  lotteries?: InputMaybe<Array<LotteryId>>;
  onlyWithWinnings?: InputMaybe<Scalars['Boolean']['input']>;
  states?: InputMaybe<Array<PlaySlipStatus>>;
  subscriptionCode?: InputMaybe<Scalars['String']['input']>;
};

/** Contains a page of the current player's play slip history, split up into active, pending and closed play slips.  */
export type PlaySlipHistoryPayload = {
  __typename?: 'PlaySlipHistoryPayload';
  active: Array<ActivePlaySlip>;
  closed: Array<ClosedPlaySlip>;
  pending: Array<PendingPlaySlip>;
  totalActive: Scalars['Int']['output'];
  totalClosed: Scalars['Int']['output'];
  totalPending: Scalars['Int']['output'];
};


/** Contains a page of the current player's play slip history, split up into active, pending and closed play slips.  */
export type PlaySlipHistoryPayloadActiveArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


/** Contains a page of the current player's play slip history, split up into active, pending and closed play slips.  */
export type PlaySlipHistoryPayloadClosedArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


/** Contains a page of the current player's play slip history, split up into active, pending and closed play slips.  */
export type PlaySlipHistoryPayloadPendingArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

export type PlaySlipInput = {
  addOns: Array<AddOnInput>;
  bonusCode?: InputMaybe<Scalars['BonusCode']['input']>;
  configVersion: Scalars['String']['input'];
  licensedTerritory: Scalars['String']['input'];
  lotteryId: LotteryId;
  numberOfDraws: Scalars['Int']['input'];
  plays: Array<PlayInput>;
  subscription?: InputMaybe<Scalars['Boolean']['input']>;
  subscriptionOptions?: InputMaybe<SubscriptionOptionsInput>;
};

export type PlaySlipOrder = {
  firstDrawDate: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  lastDrawDate: Scalars['DateTime']['output'];
  licensedTerritory: Scalars['String']['output'];
  lotteryId: LotteryId;
  nextDrawDate: Scalars['DateTime']['output'];
  numberOfDraws: Scalars['Int']['output'];
  /** The number of extra hit plays, if applicable, otherwise 0 */
  numberOfExtraHitPlays: Scalars['Int']['output'];
  /** The number of normal plays, excluding any extra hit plays */
  numberOfPlays: Scalars['Int']['output'];
  orderId: Scalars['String']['output'];
  orderedAt: Scalars['DateTime']['output'];
  /** Whether this order can be replayed from the licensedTerritory passed to the query. False when that argument is omitted. */
  replayable: Scalars['Boolean']['output'];
  selectedAddOns: Array<Scalars['String']['output']>;
  status: PlaySlipOrderStatus;
  subscriptionInfo?: Maybe<SubscriptionInfo>;
};

export enum PlaySlipOrderStatus {
  Cancelled = 'CANCELLED',
  Closed = 'CLOSED',
  Ordered = 'ORDERED',
  Purchased = 'PURCHASED'
}

export type PlaySlipOrdersFilterInput = {
  lotteries?: InputMaybe<Array<LotteryId>>;
  status: Array<PlaySlipOrderStatus>;
  subscription?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PlaySlipOrdersPayload = {
  __typename?: 'PlaySlipOrdersPayload';
  count: Scalars['Long']['output'];
  playSlipOrders: Array<PlaySlipOrder>;
};

export type PlaySlipPayload = {
  __typename?: 'PlaySlipPayload';
  id: Scalars['String']['output'];
};

export type PlaySlipPriceBreakdownInput = {
  /** Add-on charge per playSlip but not multiplied with draws */
  addOnChargePerPlaySlip: MoneyInput;
  /** Add-on fee per playSlip but not multiplied with draws */
  addOnFeePerPlaySlip: MoneyInput;
  /** Sum of all charges per draw */
  chargePerPlaySlip: MoneyInput;
  /** Sum of all charges, multiplied with number of draws */
  chargeTotal: MoneyInput;
  /** List of charges for addons */
  chargesForPlaySlipAddOns: Array<ChargeForAddOnInput>;
  /** List of charges per play */
  chargesPerPlay: Array<ChargeForPlayInput>;
  /** Sum of all fees per draw */
  feePerPlaySlip: MoneyInput;
  /** Sum of all convenience fees, multiplied with number of draws */
  feeTotal: MoneyInput;
  /** Total price including sales tax */
  grossTotal: MoneyInput;
  /** Version of the price calculation library used to calculate fees and charges */
  libraryVersion: Scalars['String']['input'];
  /** Version of the lottery configuration */
  lotteryConfigVersion: Scalars['String']['input'];
  /** Total price without sales tax */
  netTotal: MoneyInput;
  /** Number of draws */
  numberOfDraws: Scalars['Int']['input'];
  /** Number of plays */
  numberOfPlays: Scalars['Int']['input'];
  /** Charge per playSlip but not multiplied with draws */
  playChargePerPlaySlip: MoneyInput;
  /** Fee per playSlip but not multiplied with draws */
  playFeePerPlaySlip: MoneyInput;
  /** Version of the price list */
  priceListVersion: Scalars['String']['input'];
  /** Sales tax for markets where it is calculated separately */
  salesTax: MoneyInput;
};

export enum PlaySlipStatus {
  Cancelled = 'CANCELLED',
  Closed = 'CLOSED',
  ManualReview = 'MANUAL_REVIEW',
  Ordered = 'ORDERED',
  Preliminary = 'PRELIMINARY',
  Purchased = 'PURCHASED',
  Rejected = 'REJECTED'
}

/** Response to a storePlaySlip mutation request. Contains the resulting play slip ID and if the play slip is subscribed. */
export type PlaySlipStored = {
  __typename?: 'PlaySlipStored';
  id: Scalars['String']['output'];
  subscription: Scalars['Boolean']['output'];
};

export enum PlaySlipType {
  FreeTicket = 'FREE_TICKET',
  Normal = 'NORMAL',
  PrepaidSubscription = 'PREPAID_SUBSCRIPTION',
  Subscription = 'SUBSCRIPTION'
}

export type PlaySlipValidationPayload = {
  __typename?: 'PlaySlipValidationPayload';
  success: Scalars['Boolean']['output'];
};

export enum PlayerCheckStatus {
  BelowMinimumAge = 'BELOW_MINIMUM_AGE',
  NotVerified = 'NOT_VERIFIED',
  Ok = 'OK',
  SelfBan = 'SELF_BAN',
  Suspended = 'SUSPENDED'
}

/** The current configuration of a player. */
export type PlayerConfigurationPayload = {
  __typename?: 'PlayerConfigurationPayload';
  twoFactorAuthentication: TwoFactorAuthenticationSetting;
};

export type PlayerLimit = Limit & {
  __typename?: 'PlayerLimit';
  available: Money;
  nextIncreaseFrom: Scalars['Instant']['output'];
  nextPeriodStart: Scalars['Instant']['output'];
  period: LimitPeriod;
  type: LimitType;
  value: Money;
};

/** contains the payload of the player (e.g. given name, family name) */
export type PlayerPayload = {
  __typename?: 'PlayerPayload';
  /** The physical address of the player. */
  address: Scalars['Address']['output'];
  customerId: Scalars['CustomerId']['output'];
  dateOfBirth: Scalars['Date']['output'];
  email: Scalars['EMailAddress']['output'];
  /** The family name. */
  familyName: Scalars['Name']['output'];
  /** The given name. */
  givenName: Scalars['Name']['output'];
  id: Scalars['String']['output'];
  /** The last time this player acknowledged terms & conditions. */
  lastAcknowledgedTermsAndConditions: Scalars['Instant']['output'];
  locale: Scalars['LanguageTag']['output'];
  /** The phone number of the player. */
  phone: Phone;
  registrationDate: Scalars['Instant']['output'];
  /** Information about an active self-exclusion if there is an active one. */
  selfExclusion?: Maybe<PlayerSelfExclusionPayload>;
  /** The current status of the player. */
  status: Status;
  /** The verifications concerning the player. */
  verifications: Array<VerificationPayload>;
};

export enum PlayerRestriction {
  NotVerified = 'NotVerified',
  Ok = 'Ok'
}

/** Information about a self-exclusion. */
export type PlayerSelfExclusionPayload = {
  __typename?: 'PlayerSelfExclusionPayload';
  /** The point in time at which the players' self-exclusion will end. */
  expires: Scalars['Instant']['output'];
  type: SelfExclusionType;
};

export type PreferenceInput = {
  channel: NotificationChannel;
  notification: Notification;
  selected: Scalars['Boolean']['input'];
};

export type PreferencePayload = {
  __typename?: 'PreferencePayload';
  channels: Array<ChannelPayload>;
  notification: Notification;
};

export type PreferencesInput = {
  preferences: Array<PreferenceInput>;
};

export type PrepaidOptions = {
  __typename?: 'PrepaidOptions';
  participatedDraws: Scalars['Int']['output'];
  remainingDraws: Scalars['Int']['output'];
  totalDraws: Scalars['Int']['output'];
};

export type PrepaidSubscriptionsConfig = {
  __typename?: 'PrepaidSubscriptionsConfig';
  customDrawsMax: Scalars['Int']['output'];
  customDrawsMin: Scalars['Int']['output'];
  selectableDrawsOptions: Array<Scalars['Int']['output']>;
};

export type PriceBreakdown = {
  __typename?: 'PriceBreakdown';
  /** Add-on charge per playSlip but not multiplied with draws */
  addOnChargePerPlaySlip: Money;
  /** Add-on fee per playSlip but not multiplied with draws */
  addOnFeePerPlaySlip: Money;
  /** Sum of all charges per draw */
  chargePerPlaySlip: Money;
  /** Sum of all charges, multiplied with number of draws */
  chargeTotal: Money;
  /** List of charges for addons */
  chargesForPlaySlipAddOns: Array<ChargeForAddOn>;
  /** List of charges per play */
  chargesPerPlay: Array<ChargeForPlay>;
  /** Sum of all fees per draw */
  feePerPlaySlip: Money;
  /** Sum of all convenience fees, multiplied with number of draws */
  feeTotal: Money;
  /** Total price including sales tax */
  grossTotal: Money;
  groupedPlays: Array<GroupedPlays>;
  /** Version of the price calculation library used to calculate fees and charges */
  libraryVersion: Scalars['String']['output'];
  /** Version of the lottery configuration */
  lotteryConfigVersion: Scalars['String']['output'];
  /** Total price without sales tax */
  netTotal: Money;
  /** Number of draws */
  numberOfDraws: Scalars['Int']['output'];
  /** Number of plays */
  numberOfPlays: Scalars['Int']['output'];
  /** Charge per playSlip but not multiplied with draws */
  playChargePerPlaySlip: Money;
  /** Fee per playSlip but not multiplied with draws */
  playFeePerPlaySlip: Money;
  /** Version of the price list */
  priceListVersion: Scalars['String']['output'];
  /** Sales tax for markets where it is calculated separately */
  salesTax: Money;
};

export type PriceListPayload = {
  __typename?: 'PriceListPayload';
  charges: Array<Charge>;
  fees: Array<Fee>;
  lotteryId: LotteryId;
  salesTaxStrategy: SalesTaxStrategy;
  version: Scalars['String']['output'];
};

export type PricePoint = {
  __typename?: 'PricePoint';
  amount: Money;
  fees: Money;
  isMostPopular: Scalars['Boolean']['output'];
  totalAmount: Money;
  /** If the amount + the calculated fees exceed any of the deposit limits */
  withinFundingLimit: Scalars['Boolean']['output'];
};

export enum PriceType {
  Draw = 'DRAW',
  Once = 'ONCE',
  Week = 'WEEK'
}

export type Prize = PrizePayload & {
  __typename?: 'Prize';
  prize: Money;
  tier: Scalars['String']['output'];
  tierInfo: PrizeTier;
  type: PrizeTierType;
  winners: Scalars['Int']['output'];
};

export type PrizeCategory = {
  __typename?: 'PrizeCategory';
  group: Scalars['DrawnNumbersGroup']['output'];
  /** @deprecated Use group instead */
  lotteryId: LotteryId;
  name: Scalars['String']['output'];
  prizes: Array<PrizePayload>;
};

export type PrizePayload = {
  prize?: Maybe<Money>;
  tier: Scalars['String']['output'];
  tierInfo: PrizeTier;
  type: PrizeTierType;
  winners: Scalars['Int']['output'];
};

export type PrizeTier = {
  __typename?: 'PrizeTier';
  amount?: Maybe<Money>;
  jackpot: Scalars['Boolean']['output'];
  /** @deprecated Will be removed in the future */
  odds: Scalars['Long']['output'];
  payoutInterval: PayoutInterval;
  requirements: PrizeTierRequirements;
  tier: Scalars['String']['output'];
  type: PrizeTierType;
};

export type PrizeTierCategory = {
  __typename?: 'PrizeTierCategory';
  categoryRequirements: Array<PrizeTierCategoryRequirements>;
  group: Scalars['DrawnNumbersGroup']['output'];
  name: Scalars['String']['output'];
  prizeTiers: Array<PrizeTier>;
  /** @deprecated Contains only the first requirement, use categoryRequirements instead, replace with categoryRequirements */
  requirements?: Maybe<PrizeTierCategoryRequirements>;
};

export type PrizeTierCategoryRequirements = {
  type: PrizeTierCategoryRequirementsPayloadType;
};

export enum PrizeTierCategoryRequirementsPayloadType {
  AlwaysActive = 'ALWAYS_ACTIVE',
  ByAddonSelected = 'BY_ADDON_SELECTED',
  ByMultiplierDeselected = 'BY_MULTIPLIER_DESELECTED',
  ByMultiplierSelected = 'BY_MULTIPLIER_SELECTED',
  ByMultiplierValueMatched = 'BY_MULTIPLIER_VALUE_MATCHED',
  /** @deprecated Will be removed in the future */
  LotterySpecific = 'LOTTERY_SPECIFIC'
}

export type PrizeTierRequirements = {
  type: PrizeTierRequirementsPayloadType;
};

export enum PrizeTierRequirementsPayloadType {
  DateLottery = 'DATE_LOTTERY',
  /** @deprecated Will be removed in the future */
  LotterySpecific = 'LOTTERY_SPECIFIC',
  LuckyLines = 'LUCKY_LINES',
  NumberLottery = 'NUMBER_LOTTERY',
  PickLottery = 'PICK_LOTTERY'
}

export enum PrizeTierType {
  Fixed = 'FIXED',
  FreeTicket = 'FREE_TICKET',
  Jackpot = 'JACKPOT'
}

export type Product = HighFrequencyProduct | LotteryProduct | ScratchcardProduct;

export type ProductCatalogElement = FreeToPlayTeaserPayload | HighFrequencyTeaserPayload | LotteryTeaserPayload | ScratchcardTeaserPayload;

export type ProductCatalogError = ProductCatalogError_Failed;

export type ProductCatalogError_Failed = TypedGraphQlError & {
  __typename?: 'ProductCatalogError_Failed';
  message: Scalars['String']['output'];
};

export type ProductCatalogErrors = {
  __typename?: 'ProductCatalogErrors';
  errors: Array<ProductCatalogError>;
};

export type ProductCatalogPayload = {
  __typename?: 'ProductCatalogPayload';
  elements: Array<ProductCatalogElement>;
};

export type ProductCatalogPayload_Or_ProductCatalogErrors = ProductCatalogErrors | ProductCatalogPayload;

export enum ProductType {
  HighFrequencyGame = 'HighFrequencyGame',
  Lottery = 'Lottery',
  LotterySubscription = 'LotterySubscription',
  Scratchcard = 'Scratchcard'
}

export type ProviderSpecificDataEntryInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type PxpCreditCardInput = {
  accountId: Scalars['String']['input'];
  paymentId: Scalars['String']['input'];
  providerData?: InputMaybe<PxpCreditCardProviderDataInput>;
  specificType?: InputMaybe<Scalars['String']['input']>;
};

export type PxpCreditCardProviderDataInput = {
  accountFundingSource?: InputMaybe<Scalars['String']['input']>;
  cardNumber: Scalars['String']['input'];
  cardToken: Scalars['String']['input'];
  cardType: Scalars['String']['input'];
  expiryMonth: Scalars['Int']['input'];
  expiryYear: Scalars['Int']['input'];
  holderName: Scalars['String']['input'];
  id: Scalars['String']['input'];
  issuerCountryCode?: InputMaybe<Scalars['String']['input']>;
  issuerName?: InputMaybe<Scalars['String']['input']>;
  paymentAccountTypeID: Scalars['Int']['input'];
  paymentMethodID: Scalars['Int']['input'];
};

export type Query = {
  __typename?: 'Query';
  account: AccountPayload;
  /** Retrieves the active announcement for a given licensed territory (or null) */
  activeAnnouncement?: Maybe<AnnouncementQueryResponse>;
  /**
   *
   * Prepares a payment to add funds to the player's account.
   * Possible errors:
   * - internal.error In case of a server error.
   * - authentication.noauthheader If the player is not logged in.
   * - validation.addfunds.fundinglimitexceeded If none of the price points is lower or equal to the player's funding limit.
   *
   */
  addFundsConfig: AddFundsConfigPayload;
  /**
   *
   * Queries for the status of the add funds process with the given ID
   * Possible errors:
   * - internal.error In case of a server error.
   * - authentication.noauthheader If the player is not logged in.
   * - validation.addfunds.notfound If the add funds process can not be found for the given ID
   * - validation.addfunds.invalidpaymentid If the payment associated with the add funds can not be found
   * - validation.addfunds.invalidfundingid If the passed ID has an incorrect format.
   *
   */
  addFundsStatus: AddFundsStatusPayload;
  /**
   *
   * Requests an Apple Pay payment session for merchant validation.
   * Possible errors:
   * - authentication.noauthheader If the player is not logged in.
   * - internal.error For any other error.
   *
   */
  applePayMerchantValidation: ApplePayMerchantValidationPayload;
  /**
   *
   *         Returns information about the given bonus code, like type, value and descriptions.
   *         Possible errors are:
   *         - internal.error: Unexpected internal error
   *         - bonus.code.invalid: The code is either invalid or not enabled
   *         - bonus.code.expired: The promotion the code belongs to has expired
   *
   */
  bonusCodeInfo: BonusCodeInfoPayload;
  /**
   *
   *             Validates a bonus code for a play slip with the given context information. The player can be optionally logged in.
   *             If not logged in, they will be treated as a new customer.
   *             If the code is valid and can possibly be redeemed, a BonusCodePayload object with details is returned.
   *             If the code cannot be redeemed, one of the following errors is returned:
   *             - internal.error: Unexpected internal error
   *             - precondition.failed: The chargesPerPlay from the bonus code input is empty
   *             - bonus.code.invalid: The code is either invalid or not enabled
   *             - bonus.code.expired: The promotion the code belongs to has expired
   *             - bonus.code.redeemed: The code has already been redeemed the maximum amount of uses for this player (logged in only)
   *             - bonus.code.noredemptions: The limit of redemptions for this code has been exceeded
   *             - bonus.code.invalidfordrawgames: The code is not applicable to draw games
   *             - bonus.code.invalidforscratchgames: The code is not applicable to scratch games
   *
   */
  checkBonusCodeForPlaySlip: BonusValidationResult;
  checkRoutingNumber: CheckRoutingNumberPayload;
  cookies?: Maybe<Scalars['String']['output']>;
  /**
   *
   *         Creates a list of teasers for the provided product type (lottery or scratchcard).
   *         Possible errors are:
   *         - internal.error: Unexpected internal error
   *         - validation.licensedterritory.invalid: The licensed territory is invalid
   *
   */
  defaultTeasers: DefaultTeasersPayload;
  /**
   *
   *         Returns all the draw information for the given draw ID.
   *         Possible errors:
   *         - draw.notfound if there is no draw for the given ID
   *         - lottery.notfound if there is no lottery configuration valid at the draw's draw date
   *
   */
  drawDetail: FinishedDrawPayload;
  /**
   *
   *         Returns all matching draws for which numbers have been entered.
   *         Valid limits are 1-50.
   *         Valid offsets are >= 0.
   *
   */
  drawHistory: DrawHistoryPayload;
  /**
   *
   *         Returns the latest finished draw for each active lottery in the given licensed territory,
   *         grouped by day in the licensed territory's time zone.
   *
   */
  drawListByDay: DrawHistoryByDayPayload;
  /**
   *
   *         Returns the previous and following draw IDs for the given draw ID.
   *
   *         Possible errors:
   *         - draw.notfound - if there is no draw for the given ID
   *         - error.internalServer - if a database error occurs
   *
   */
  drawNavigation: DrawNavigationPayload;
  /** Iframe url for the free-to-play game */
  freeToPlayIframeUrl: Payload;
  /**
   *
   *             Queries the participation results of the given draw.
   *
   *             Possible errors:
   *             - `highfrequency.drawparticipation.failed`: If any error occurs. The specific error is logged.
   *
   */
  highFrequencyDrawParticipation: HighFrequency_DrawParticipationPayload_Or_HighFrequency_DrawParticipationPayloadErrors;
  /**
   *
   *             Returns the currently active game configuration for the given game and licensed territory,
   *             its active/inactive status and whether the (optionally authenticated) player has accepted the game's disclaimer.
   *
   *             Possible errors:
   *             - `licensedterritory.error.invalid`: The provided licensed territory is invalid.
   *             - `highfrequency.game.notfound`: No game configuration was found for the given game and licensed territory.
   *             - `highfrequency.error.internalserver`: An unexpected internal error occurred. The specific error is logged.
   *
   */
  highFrequencyGameConfig: HighFrequency_GameConfig_Or_HighFrequency_GamesErrors;
  /**
   *
   *             Returns all game configurations available in the given licensed territory, including each game's active/inactive status
   *             and whether the (optionally authenticated) player has accepted the game's disclaimer.
   *
   *             Possible errors:
   *             - `licensedterritory.error.invalid`: The provided licensed territory is invalid.
   *             - `highfrequency.error.internalserver`: An unexpected internal error occurred. The specific error is logged.
   *
   */
  highFrequencyGameConfigs: HighFrequency_GameConfigs_Or_HighFrequency_GamesErrors;
  /**
   *
   *             Returns the details of a single high frequency order including all draws, participations, winnings and whether the order can be
   *             replayed.
   *
   *             Possible errors:
   *             - `licensedterritory.error.invalid`: The provided licensed territory is invalid.
   *             - `highfrequency.order.notfound`: No order was found for the given order ID and player.
   *             - `highfrequency.error.internalserver`: An unexpected internal error occurred. The specific error is logged.
   *
   */
  highFrequencyOrderDetail: HighFrequency_OrderDetailsPayload_Or_HighFrequency_OrderDetailsErrors;
  /**
   *
   *             Returns a paginated list of high frequency orders for the player matching the given filter.
   *
   *             Possible errors:
   *             - `highfrequency.error.internalserver`: An unexpected internal error occurred. The specific error is logged.
   *
   */
  highFrequencyOrders: HighFrequency_OrdersPayload_Or_HighFrequency_OrdersErrors;
  /**
   *
   *             Returns the latest keno draw results for the given licensed territory and game,
   *             together with the number of winning participations evaluated in the last 24 hours
   *             and the currently active game configuration when one exists.
   *
   *             Possible errors:
   *             - `highfrequency.resultsandwinners.failed`: If any error occurs. The specific error is logged.
   *
   */
  highFrequencyResultsAndWinners: HighFrequency_ResultsAndWinnersPayload_Or_HighFrequency_ResultsAndWinnersErrors;
  /**
   *
   *             Returns the current draw together with its status and results and the next draw information,
   *             used by the Keno Hub watch mode.
   *
   *             Possible errors:
   *             - `highfrequency.watchdraw.failed`: If any error occurs. The specific error is logged.
   *
   */
  highFrequencyWatchDraw: HighFrequency_WatchDrawPayload_Or_HighFrequency_WatchDrawErrors;
  /** Hype specific validations */
  hypeValidations: HypeValidationsPayload;
  /**
   *
   * Lists all available payment instruments the user can create.
   *
   */
  initialPaymentInstruments: Array<InitialPaymentInstrumentsPayload>;
  /**
   *
   *         Returns the latest finished draw for each active lottery in the given licensed territory.
   *
   */
  latestDraws: DrawHistoryPayload;
  limits: Limits;
  lotteries: Array<LotteryPayload>;
  lottery: LotteryPayload;
  /** Returns the marketing notification preferences for the player. */
  marketingPreferences: MarketingPreferencesPayload;
  nextDraw?: Maybe<DrawPayload>;
  noop: Scalars['String']['output'];
  /** Returns status PENDING while the payment is being processed */
  order: Order;
  /**
   *
   *         The type of products the current player already purchased. Only successful purchases are considered.
   *
   *         Even though subscription is technically a product of type 'LOTTERY', it is included as a separate option.
   *
   */
  orderedType: OrderedTypePayload;
  /**
   *
   *         Lists all pay out accounts for the logged-in player.
   *         Pay out is restricted, if the player is not (yet) verified.
   *         If PayPal is active and the logged-in player has successfully deposited
   *         via PayPal, then only the PayPal pay out account is listed.
   *
   */
  payOutAccounts: PayOutOptions;
  paymentInstruments: PaymentInstrumentsPayload_Or_PaymentInstrumentsErrors;
  /**
   *
   * Just the list of available payment methods.
   * If a payment method is available from different providers, it will only be returned once.
   *
   */
  paymentMethods: Array<PaymentMethod>;
  /**
   *
   *         Returns the play slip history for a player, split up into active, pending and closed play slips.
   *         Paging is applied to all selected lists.
   *
   */
  playSlipHistory: PlaySlipHistoryPayload;
  /**
   *
   *         Returns all play slip orders for the given filter.
   *
   *         Offset must be at least 0.
   *         Limit (page size) will be limited to max 50 and at least 1.
   *
   *         If the filter status is empty, an empty list will be returned.
   *
   *         Possible errors:
   *         - playslips.notfound: If there are no play slips found for the play slip order given the filter criteria.
   *         - error.internalserver - if a database error occurs
   *
   */
  playSlipOrders: PlaySlipOrdersPayload;
  player: PlayerPayload;
  /**
   *
   * Get the current configuration of a logged-in player.
   * A configuration contains technical settings on the platform that are not related to the master data of a player.
   *
   * @deprecated use twoFactorConfiguration instead
   */
  playerConfiguration: PlayerConfigurationPayload;
  playerSignupFinished: SignupFinishedPayload;
  /** Returns a list of notification preferences for the current user, grouped by notification type. */
  preferences: Array<PreferencePayload>;
  priceList?: Maybe<PriceListPayload>;
  productCatalog: ProductCatalogPayload_Or_ProductCatalogErrors;
  recommendationElements: RecommendationElementPayload_Or_RecommendationElementErrors;
  /**
   *
   *             Returns 2 personalized recommendations for a player based on their purchased product.
   *             `licensedTerritory` must be a valid licensed territory. Required.
   *             `purchasedProductType` must be either LOTTERY or SCRATCHCARD. Required.
   *             `purchasedProductSubtype` must be a lottery ID or scratchcard game slug. Required.
   *             `playerId` This is used if the query has neither a player authorization or soft login cookie information. Optional.
   *             Possible errors are:
   *             - internal.error: Unexpected internal error
   *             - validation.licensedterritory.invalid: The licensed territory is invalid
   *
   */
  recommendations: TeasersPayload;
  scheduledDraws: Array<DrawPayload>;
  /**
   *
   *             Queries a specific scratchcard game by licensed territory and game slug.
   *
   *             Possible error codes:
   *             - validation.licensedterritory.invalid - if the licensed territory has an invalid format
   *             - validation.licensedterritory.unknown - if the licensed territory is not configured
   *             - validation.slug.invalid - if the given game slug has an invalid format
   *             - validation.game.notfound - if the game could not be found
   *             - error.internalserver - if a database error occurs
   *
   */
  scratchcardGame: ScratchcardGame;
  /** Returns the order details for one scratchcard order of the current player. */
  scratchcardOrder: ScratchcardOrderDetail;
  /** Returns the paginated list of scratchcard orders for a player. */
  scratchcardOrders: ScratchcardOrdersPayload;
  /**
   *
   *             Lists the teasers for all enabled and available scratchcard games, sorted descending by max prize.
   *
   *             Possible error codes:
   *             - validation.licensedterritory.invalid - if the licensed territory has an invalid format
   *             - validation.licensedterritory.unknown - if the licensed territory is not configured
   *             - error.internalserver - if a database error occurs
   *
   */
  scratchcardTeasers: Array<ScratchcardTeaser>;
  /**
   *
   *         Returns all ticket details of a single play slip order given by its order ID
   *         including potential winnings and draw results.
   *
   *         Possible error codes:
   *         - validation.playsliporder.unknown: The play slip order could not be found
   *         - pricelist.notfound: The price list could not be found
   *         - error.internalserver: If a database error occurs
   *
   */
  singleOrderMultipleLines: SingleOrderMultipleLines;
  /** Returns state PENDING if no play slip found for the given productId */
  singleProductCheckout: CheckoutPayload;
  /**
   *
   * Lists the active payment instruments (pay-in and pay-out) for a player.
   * Possible errors:
   * - licensedterritory.error.invalid: If the licensed territory is unknown
   * - authentication.noauthheader: If the authentication header is missing
   * - error.databaseerror: If the database cannot be found
   * - internal.error: If an unexpected error occurred while looking up the stored payment instruments in the database
   *
   */
  storedPaymentInstruments: StoredPaymentInstruments;
  /**
   *
   *         Returns subscription details for the provided subscription by its order ID.
   *
   */
  subscriptionOrderMultipleLines: SubscriptionOrderMultipleLinesPayload;
  /**
   *
   *         Returns all subscriptions for the given filter.
   *
   *         Valid values for the limit are 1 to 50.
   *         Valid values for offset are at least 0.
   *
   */
  subscriptionsMultipleLines: SubscriptionsMultipleLines;
  /**
   *
   *         Creates a list of teasers from active lotteries and active scratchcard games.
   *         Possible errors are:
   *         - internal.error: Unexpected internal error
   *         - validation.licensedterritory.invalid: The licensed territory is invalid
   *
   */
  teasers: TeasersPayload;
  /**
   *
   *         Returns a paged list of the current user's transactions, newest first.
   *
   *         Parameters:
   *         - offset: Index of the first transaction to return. Use 0 to retrieve the most recent transaction
   *         - limit: The page size, 1 to 20
   *
   *         Possible error codes:
   *         - validation.accountnotfound if no account exists for the current user
   *
   */
  transactionHistory: TransactionHistory;
  /** Get the current two factor configuration of a logged-in player. */
  twoFactorConfiguration: TwoFactorConfigurationPayload;
  validatePlaySlip: PlaySlipValidationPayload;
};


export type QueryActiveAnnouncementArgs = {
  licensedTerritory: Scalars['String']['input'];
};


export type QueryAddFundsConfigArgs = {
  input?: InputMaybe<AddFundsInput>;
  licensedTerritory: Scalars['String']['input'];
};


export type QueryAddFundsStatusArgs = {
  id: Scalars['String']['input'];
};


export type QueryApplePayMerchantValidationArgs = {
  input: ApplePayMerchantValidationInput;
};


export type QueryBonusCodeInfoArgs = {
  code: Scalars['String']['input'];
};


export type QueryCheckBonusCodeForPlaySlipArgs = {
  input: BonusCodeValidationInput;
};


export type QueryCheckRoutingNumberArgs = {
  routingNumber: Scalars['String']['input'];
};


export type QueryDefaultTeasersArgs = {
  licensedTerritory: Scalars['String']['input'];
  productType: KnownProductType;
};


export type QueryDrawDetailArgs = {
  id: Scalars['String']['input'];
};


export type QueryDrawHistoryArgs = {
  filter?: InputMaybe<DrawResultsFilterInput>;
  licensedTerritory: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryDrawListByDayArgs = {
  filter?: InputMaybe<DrawResultsFilterInput>;
  licensedTerritory: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryDrawNavigationArgs = {
  drawId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryHighFrequencyDrawParticipationArgs = {
  drawNumber: Scalars['Int']['input'];
  orderId: Scalars['String']['input'];
};


export type QueryHighFrequencyGameConfigArgs = {
  gameId: HighFrequency_GameId;
  licensedTerritory: Scalars['String']['input'];
};


export type QueryHighFrequencyGameConfigsArgs = {
  licensedTerritory: Scalars['String']['input'];
};


export type QueryHighFrequencyOrderDetailArgs = {
  licensedTerritory: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
};


export type QueryHighFrequencyOrdersArgs = {
  filter: HighFrequency_OrdersFilterInput;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryHighFrequencyResultsAndWinnersArgs = {
  input: HighFrequency_ResultsAndWinnersInput;
};


export type QueryHighFrequencyWatchDrawArgs = {
  gameId: HighFrequency_GameId;
};


export type QueryInitialPaymentInstrumentsArgs = {
  input: InitialPaymentInstrumentsInput;
};


export type QueryLatestDrawsArgs = {
  licensedTerritory: Scalars['String']['input'];
};


export type QueryLotteriesArgs = {
  licensedTerritory: Scalars['String']['input'];
};


export type QueryLotteryArgs = {
  id: LotteryId;
  licensedTerritory: Scalars['String']['input'];
};


export type QueryNextDrawArgs = {
  licensedTerritory: Scalars['String']['input'];
  lotteryId: LotteryId;
};


export type QueryOrderArgs = {
  id: Scalars['OrderId']['input'];
};


export type QueryPayOutAccountsArgs = {
  licensedTerritory: Scalars['String']['input'];
  useManualAccountsOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPaymentInstrumentsArgs = {
  input: PaymentInstrumentsInput;
};


export type QueryPaymentMethodsArgs = {
  licensedTerritory: Scalars['String']['input'];
};


export type QueryPlaySlipHistoryArgs = {
  filter?: InputMaybe<PlaySlipHistoryFilterInput>;
};


export type QueryPlaySlipOrdersArgs = {
  filter: PlaySlipOrdersFilterInput;
  licensedTerritory?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryPriceListArgs = {
  licensedTerritory: Scalars['String']['input'];
  lotteryId: LotteryId;
};


export type QueryProductCatalogArgs = {
  licensedTerritory: Scalars['String']['input'];
  productType: KnownProductType;
};


export type QueryRecommendationElementsArgs = {
  licensedTerritory: Scalars['String']['input'];
};


export type QueryRecommendationsArgs = {
  licensedTerritory: Scalars['String']['input'];
  purchasedProductSubtype: Scalars['String']['input'];
  purchasedProductType: KnownProductType;
};


export type QueryScheduledDrawsArgs = {
  licensedTerritory: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  lotteryId: LotteryId;
};


export type QueryScratchcardGameArgs = {
  licensedTerritory: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};


export type QueryScratchcardOrderArgs = {
  orderId: Scalars['String']['input'];
};


export type QueryScratchcardOrdersArgs = {
  filter: ScratchcardsFilterInput;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryScratchcardTeasersArgs = {
  licensedTerritory: Scalars['String']['input'];
};


export type QuerySingleOrderMultipleLinesArgs = {
  licensedTerritory?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
};


export type QuerySingleProductCheckoutArgs = {
  licensedTerritory: Scalars['String']['input'];
  productId: Scalars['ProductId']['input'];
};


export type QueryStoredPaymentInstrumentsArgs = {
  input: StoredPaymentInstrumentsInput;
};


export type QuerySubscriptionOrderMultipleLinesArgs = {
  licensedTerritory?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
};


export type QuerySubscriptionsMultipleLinesArgs = {
  filter: SubscriptionsFilterInput;
  licensedTerritory?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryTeasersArgs = {
  licensedTerritory: Scalars['String']['input'];
};


export type QueryTransactionHistoryArgs = {
  filter?: InputMaybe<ShopTransactionsFilterInput>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryValidatePlaySlipArgs = {
  input: PlaySlipInput;
};

export type QuickPickConfiguration = {
  __typename?: 'QuickPickConfiguration';
  addOns: Array<AddOnOutput>;
  plays: Scalars['Int']['output'];
};

export type RecommendationElement = ExploreElement | FreeToPlayTeaserPayload | HighFrequencyTeaserPayload | LotteryTeaserPayload | ReviewElement | ScratchcardTeaserPayload | WelcomeToWineverElement | WinnerTrustElement;

export type RecommendationElementError = RecommendationElementError_Failed;

export type RecommendationElementError_Failed = TypedGraphQlError & {
  __typename?: 'RecommendationElementError_Failed';
  message: Scalars['String']['output'];
};

export type RecommendationElementErrors = {
  __typename?: 'RecommendationElementErrors';
  errors: Array<RecommendationElementError>;
};

export type RecommendationElementPayload = {
  __typename?: 'RecommendationElementPayload';
  elements: Array<RecommendationElement>;
};

export type RecommendationElementPayload_Or_RecommendationElementErrors = RecommendationElementErrors | RecommendationElementPayload;

export type ReformattedDrawPayload = {
  __typename?: 'ReformattedDrawPayload';
  addOns: Array<Scalars['String']['output']>;
  drawDate: Scalars['DateTime']['output'];
  drawnNumbers: Array<ReformattedDrawnNumbers>;
  hasMultipleDrawsOnDay: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  label: DrawLabel;
  lotteryConfig: LotteryPayload;
  /** ID of the main lottery. */
  lotteryId: LotteryId;
  prizeCategories: Array<PrizeCategory>;
};

export type ReformattedDrawnNumbers = {
  __typename?: 'ReformattedDrawnNumbers';
  /** ID of the main lottery or additional lottery, like 'GREENBALL' */
  name: Scalars['String']['output'];
  numbers: Array<Numbers>;
  /** For lotteries like GlücksSpirale or ElGordo where the numbers are drawn per rank */
  rank?: Maybe<Scalars['String']['output']>;
  /** For spiel77 / super6 which only have one single number */
  singleNumber: Scalars['Boolean']['output'];
};

export type RequestEmailVerificationError = RequestEmailVerificationError_AlreadyVerified | RequestEmailVerificationError_EmailExists | RequestEmailVerificationError_InvalidEmail | RequestEmailVerificationError_InvalidPlayerStatus | RequestEmailVerificationError_RequestRateLimit;

export type RequestEmailVerificationError_AlreadyVerified = TypedGraphQlError & {
  __typename?: 'RequestEmailVerificationError_AlreadyVerified';
  message: Scalars['String']['output'];
};

export type RequestEmailVerificationError_EmailExists = TypedGraphQlError & {
  __typename?: 'RequestEmailVerificationError_EmailExists';
  message: Scalars['String']['output'];
};

export type RequestEmailVerificationError_InvalidEmail = TypedGraphQlError & {
  __typename?: 'RequestEmailVerificationError_InvalidEmail';
  message: Scalars['String']['output'];
};

export type RequestEmailVerificationError_InvalidPlayerStatus = TypedGraphQlError & {
  __typename?: 'RequestEmailVerificationError_InvalidPlayerStatus';
  message: Scalars['String']['output'];
};

export type RequestEmailVerificationError_RequestRateLimit = TypedGraphQlError & {
  __typename?: 'RequestEmailVerificationError_RequestRateLimit';
  message: Scalars['String']['output'];
};

export type RequestEmailVerificationErrors = {
  __typename?: 'RequestEmailVerificationErrors';
  errors: Array<RequestEmailVerificationError>;
};

export type RequestEmailVerificationInput = {
  /** The email address to verify. If not provided, the player’s current email address will be used. */
  email?: InputMaybe<Scalars['String']['input']>;
  licensedTerritory: Scalars['String']['input'];
};

export type RequestEmailVerificationPayload = {
  __typename?: 'RequestEmailVerificationPayload';
  success: Scalars['Boolean']['output'];
};

export type RequestEmailVerificationPayload_Or_RequestEmailVerificationErrors = RequestEmailVerificationErrors | RequestEmailVerificationPayload;

export type ResendCodeMutationInput = {
  countryCode: Scalars['String']['input'];
  nationalNumber: Scalars['String']['input'];
};

export type ResendCodePayload = {
  __typename?: 'ResendCodePayload';
  countryCode: Scalars['String']['output'];
  nationalNumber: Scalars['String']['output'];
};

export type ResendEmailVerificationError = ResendEmailVerificationError_RequestRateLimit | ResendEmailVerificationError_UnknownToken;

export type ResendEmailVerificationError_RequestRateLimit = TypedGraphQlError & {
  __typename?: 'ResendEmailVerificationError_RequestRateLimit';
  message: Scalars['String']['output'];
};

export type ResendEmailVerificationError_UnknownToken = TypedGraphQlError & {
  __typename?: 'ResendEmailVerificationError_UnknownToken';
  message: Scalars['String']['output'];
};

export type ResendEmailVerificationErrors = {
  __typename?: 'ResendEmailVerificationErrors';
  errors: Array<ResendEmailVerificationError>;
};

export type ResendEmailVerificationInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  licensedTerritory: Scalars['String']['input'];
};

export type ResendEmailVerificationPayload = {
  __typename?: 'ResendEmailVerificationPayload';
  success: Scalars['Boolean']['output'];
};

export type ResendEmailVerificationPayload_Or_ResendEmailVerificationErrors = ResendEmailVerificationErrors | ResendEmailVerificationPayload;

export type ReserveScratchcardsInput = {
  gameSlug: Scalars['String']['input'];
  licensedTerritory: Scalars['String']['input'];
  /** The amount of scratchcards to reserve. 1 to 10 */
  quantity: Scalars['Int']['input'];
};

export type Restrictions = {
  __typename?: 'Restrictions';
  depositLimit?: Maybe<ExceededLimit>;
  geoCheck: GeoCheckStatus;
  playerCheck: PlayerCheckStatus;
  spendingLimit?: Maybe<ExceededLimit>;
};

export type ResultsMultipleLines = {
  __typename?: 'ResultsMultipleLines';
  drawDate: Scalars['DateTime']['output'];
  hasMultipleDrawsOnDay: Scalars['Boolean']['output'];
  hasWinnings: Scalars['Boolean']['output'];
  label: DrawLabel;
  lotteryResults: Array<LotteryResultsMultipleLines>;
  ticketScanUrlsExpirationDate: Scalars['DateTime']['output'];
  ticketScans: Array<TicketScansMultipleLines>;
  totalNumberOfFreePlays?: Maybe<Scalars['Int']['output']>;
  totalWinnings?: Maybe<Money>;
};

export type RevealOrderInput = {
  orderId: Scalars['String']['input'];
};

export type RevealScratchcardInput = {
  orderId: Scalars['String']['input'];
  serialNumber: Scalars['String']['input'];
};

export type ReviewElement = {
  __typename?: 'ReviewElement';
  id: Scalars['String']['output'];
};

export enum SalesTaxStrategy {
  Es = 'ES',
  Mx = 'MX',
  NoSalesTax = 'NO_SALES_TAX',
  UsAr = 'US_AR',
  UsCo = 'US_CO',
  UsFl = 'US_FL',
  UsMn = 'US_MN',
  UsNj = 'US_NJ',
  UsNy = 'US_NY',
  UsOr = 'US_OR',
  UsTx = 'US_TX'
}

export type SavedPayOutInput = {
  amount: MoneyInput;
  idempotencyKey: Scalars['String']['input'];
  licensedTerritory: Scalars['String']['input'];
  payOutAccountId: Scalars['String']['input'];
};

export enum ScratchArea {
  Bottom = 'BOTTOM',
  Center = 'CENTER',
  Top = 'TOP'
}

export type ScratchAreaPayload = {
  __typename?: 'ScratchAreaPayload';
  height: Scalars['Int']['output'];
  width: Scalars['Int']['output'];
  x: Scalars['Int']['output'];
  y: Scalars['Int']['output'];
};

export type ScratchcardDetail = {
  __typename?: 'ScratchcardDetail';
  image?: Maybe<Scalars['String']['output']>;
  images?: Maybe<ImagesPayload>;
  processedDate?: Maybe<Scalars['DateTime']['output']>;
  serialNumber: Scalars['String']['output'];
  status: ScratchcardState;
  /** @deprecated Use winningsPayload instead */
  winnings?: Maybe<Money>;
  /** Null if there are no winnings or if the order is in a state where winnings are not visible */
  winningsPayload?: Maybe<WinningsPayload>;
};

export type ScratchcardGame = {
  __typename?: 'ScratchcardGame';
  available: Scalars['Int']['output'];
  enabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  priceList: ScratchcardPriceList;
  prizeTiers: Array<ScratchcardPrizeTier>;
  slug: Scalars['String']['output'];
  visualParameters: ScratchcardVisualParameters;
};

export type ScratchcardOrderDetail = {
  __typename?: 'ScratchcardOrderDetail';
  gameName: Scalars['String']['output'];
  licensedTerritory: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  orderedDate: Scalars['DateTime']['output'];
  price: Money;
  quantity: Scalars['Int']['output'];
  /** Quantity of scratchcards which were not viewed yet */
  quantityActive: Scalars['Int']['output'];
  /** Quantity of scratchcards which were already viewed */
  quantityRevealed: Scalars['Int']['output'];
  scratchcards: Array<ScratchcardDetail>;
  state: ScratchcardState;
  visualParameters: ScratchcardVisualParameters;
  /** @deprecated Use winningsPayload instead */
  winnings?: Maybe<Money>;
  /** Null if there are no winnings or if the order is in a state where winnings are not visible */
  winningsPayload?: Maybe<ScratchcardOrderWinningsPayload>;
};

export type ScratchcardOrderPayload = {
  __typename?: 'ScratchcardOrderPayload';
  gameName: Scalars['String']['output'];
  gameSlug: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  /** Quantity of scratchcards which were not viewed yet */
  quantityActive: Scalars['Int']['output'];
  /** Quantity of scratchcards which were already viewed */
  quantityPast: Scalars['Int']['output'];
  state: ScratchcardState;
  /** Color hex string, e.g. '#FF00AB' */
  titleColor: Scalars['String']['output'];
  /** @deprecated Use winningsPayload instead */
  winnings?: Maybe<Money>;
  /** Null if there are no winnings or if the order is in a state where winnings are not visible */
  winningsPayload?: Maybe<ScratchcardOrderWinningsPayload>;
};

export type ScratchcardOrderWinningsPayload = {
  __typename?: 'ScratchcardOrderWinningsPayload';
  amount?: Maybe<Money>;
  freeTickets: Scalars['Int']['output'];
  hasWinnings: Scalars['Boolean']['output'];
  isBigWin: Scalars['Boolean']['output'];
};

export type ScratchcardOrdersPayload = {
  __typename?: 'ScratchcardOrdersPayload';
  count: Scalars['Long']['output'];
  orders: Array<ScratchcardOrderPayload>;
};

export type ScratchcardPriceBreakdown = {
  __typename?: 'ScratchcardPriceBreakdown';
  /** Flat charge per order */
  chargeForOrder: Money;
  /** Sum of all charges */
  chargeTotal: Money;
  /** Sum of the charges for scratchcards */
  chargesForCards: Money;
  /** Flat fee per order */
  feeForOrder: Money;
  /** Sum of all convenience fees, */
  feeTotal: Money;
  /** Sum of the fees for scratchcards */
  feesForCards: Money;
  /** Total price including sales tax */
  grossTotal: Money;
  /** Total price without sales tax */
  netTotal: Money;
  /** Quantity of reserved scratchcards */
  quantity: Scalars['Int']['output'];
  /** Sales tax for markets where it is calculated separately */
  salesTax: Money;
};

export type ScratchcardPriceList = {
  __typename?: 'ScratchcardPriceList';
  chargePerCard: Money;
  chargePerOrder: Money;
  currency: Scalars['String']['output'];
  feePerCard: Money;
  feePerOrder: Money;
  salesTaxStrategy: Scalars['String']['output'];
};

export type ScratchcardPrizeTier = {
  __typename?: 'ScratchcardPrizeTier';
  freeTickets: Scalars['Int']['output'];
  prize: Money;
  tier: Scalars['Int']['output'];
};

export type ScratchcardProduct = {
  __typename?: 'ScratchcardProduct';
  expiresAt: Scalars['DateTime']['output'];
  /** @deprecated Use `productName` - which contains the actual name instead of a key - instead */
  name: Scalars['String']['output'];
  price: Money;
  priceBreakdown: ScratchcardPriceBreakdown;
  productName: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  reservationId: Scalars['String']['output'];
};

export type ScratchcardReservation = {
  __typename?: 'ScratchcardReservation';
  quantity?: Maybe<Scalars['Int']['output']>;
  reservationId?: Maybe<Scalars['String']['output']>;
  restrictions?: Maybe<Restrictions>;
};

export enum ScratchcardState {
  Cancelled = 'CANCELLED',
  InProgress = 'IN_PROGRESS',
  Purchased = 'PURCHASED',
  Revealed = 'REVEALED',
  Scratched = 'SCRATCHED'
}

export type ScratchcardTeaser = {
  __typename?: 'ScratchcardTeaser';
  /** @deprecated Use visualParameters.titleColor instead */
  color: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pricePerCard: Money;
  slug: Scalars['String']['output'];
  /** @deprecated Use visualParameters.teaserImage instead */
  teaserImage?: Maybe<Scalars['String']['output']>;
  /** The maximum prize value for this game */
  value: Money;
  visualParameters: ScratchcardVisualParameters;
};

export type ScratchcardTeaserPayload = {
  __typename?: 'ScratchcardTeaserPayload';
  amount?: Maybe<Money>;
  campaign?: Maybe<CampaignPayload>;
  name: Scalars['String']['output'];
  price?: Maybe<Money>;
  slug: Scalars['String']['output'];
  visualParameters?: Maybe<ScratchcardVisualParameters>;
};

export type ScratchcardVisualParameters = {
  __typename?: 'ScratchcardVisualParameters';
  autoReveal: Scalars['Boolean']['output'];
  autoRevealPercentage?: Maybe<Scalars['Int']['output']>;
  /** Color hex string, e.g. '#FF00AB' */
  primaryColor?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use scratchAreas instead */
  scratchArea?: Maybe<ScratchArea>;
  scratchAreas?: Maybe<Array<ScratchAreaPayload>>;
  /** Color hex string, e.g. '#FF00AB' */
  secondaryColor?: Maybe<Scalars['String']['output']>;
  teaserImage?: Maybe<Scalars['String']['output']>;
  /** Optional teaser image properties, like width and height and blur hash */
  teaserImageProperties?: Maybe<ImagePropertiesPayload>;
  teaserImageUrl?: Maybe<Scalars['String']['output']>;
  /** Color hex string, e.g. '#FF00AB' */
  titleColor: Scalars['String']['output'];
};

export type ScratchcardsFilterInput = {
  status: Array<ScratchcardState>;
};

/** All data needed to self-exclude a player. */
export type SelfExclusionInput = {
  /** Number of days for the duration of the exclusion. The minimum value is 3 days. Values <= 93 will result in a Cool-Off state. */
  duration: Scalars['Int']['input'];
  licensedTerritory: Scalars['LicensedTerritory']['input'];
};

/** The return value of a self-exclusion mutation. */
export type SelfExclusionPayload = {
  __typename?: 'SelfExclusionPayload';
  /** The point in time at which the players' self-exclusion will end. */
  expires: Scalars['Instant']['output'];
  /** The new status of the player. */
  status: Status;
  /** The type of self exclusion, based on the length */
  type: SelfExclusionType;
};

/** The type of self-exclusion, currently defined by its length. */
export enum SelfExclusionType {
  CoolOff = 'CoolOff',
  SelfExclusion = 'SelfExclusion'
}

export type SetScanVerifyUploadStatusInput = {
  success: Scalars['Boolean']['input'];
};

export type ShopTransactionsFilterInput = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  types?: InputMaybe<Array<TransactionType>>;
};

/** Result of a 'playerSignupFinished' query. If the player exists, the result will be `true` */
export type SignupFinishedPayload = {
  __typename?: 'SignupFinishedPayload';
  /** player exists */
  exists: Scalars['Boolean']['output'];
};

export type SilentlyVerifyEmailInput = {
  silentEmailVerificationToken: Scalars['String']['input'];
};

export type SilentlyVerifyEmailPayload = {
  __typename?: 'SilentlyVerifyEmailPayload';
  success: Scalars['Boolean']['output'];
};

export type SingleOrderMultipleLines = {
  __typename?: 'SingleOrderMultipleLines';
  firstDrawDate: Scalars['DateTime']['output'];
  /** Internal ID of the play slip order */
  id: Scalars['String']['output'];
  lastDrawDate: Scalars['DateTime']['output'];
  lottery: LotteryPayload;
  nextDrawDate?: Maybe<Scalars['DateTime']['output']>;
  nextOrderId?: Maybe<Scalars['String']['output']>;
  numberOfDraws: Scalars['Int']['output'];
  /** The number of extra hit plays, if applicable, otherwise 0 */
  numberOfExtraHitPlays: Scalars['Int']['output'];
  /** The number of normal plays, excluding any extra hit plays */
  numberOfPlays: Scalars['Int']['output'];
  /**
   *
   *             Determines if the ticket has any winnings. May be true even if `winnings`
   *             are 0, because of other types of winnings (e.g. free ticket).
   *
   */
  orderId: Scalars['String']['output'];
  /** The ISO code of the licensed territory the order was created in, e.g. US-NJ */
  orderedIn: Scalars['String']['output'];
  previousOrderId?: Maybe<Scalars['String']['output']>;
  price: Money;
  /** Whether this order can be replayed from the licensedTerritory passed to the query. False when that argument is omitted. */
  replayable: Scalars['Boolean']['output'];
  /**
   *
   *             Returns a paginated list of draw results for the play slip order.
   *             Valid values for the limit are 1 to 50.
   *             Valid values for offset are at least 0.
   *             The default values are 0 for offset and 10 for limit.
   *
   */
  results: Array<ResultsMultipleLines>;
  state: Scalars['String']['output'];
  totalDrawResults: Scalars['Int']['output'];
  type: PlaySlipType;
};


export type SingleOrderMultipleLinesResultsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type Stake = {
  __typename?: 'Stake';
  /** References a price from the price list */
  price: Scalars['String']['output'];
};

export type StakeInput = {
  /** References a price from the price list */
  price: Scalars['String']['input'];
};

/** The possible statuses of a player. */
export enum Status {
  Closed = 'Closed',
  Registered = 'Registered',
  SelfExcluded = 'SelfExcluded',
  Suspended = 'Suspended',
  Verified = 'Verified'
}

export type StoredBankInstrument = StoredInstrument & {
  __typename?: 'StoredBankInstrument';
  accountHolderName: Scalars['String']['output'];
  internalId: Scalars['String']['output'];
  maskedAccountNumber: Scalars['String']['output'];
  paymentMethod: Scalars['String']['output'];
  routingNumber: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type StoredCardInstrument = StoredInstrument & {
  __typename?: 'StoredCardInstrument';
  cardholderName: Scalars['String']['output'];
  expirationDate: Scalars['String']['output'];
  expiryMonth?: Maybe<Scalars['Int']['output']>;
  expiryYear?: Maybe<Scalars['Int']['output']>;
  internalId: Scalars['String']['output'];
  maskedCardNumber: Scalars['String']['output'];
  paymentMethod: Scalars['String']['output'];
  type: Scalars['String']['output'];
  walletType?: Maybe<Scalars['String']['output']>;
};

export type StoredInstrument = {
  internalId: Scalars['String']['output'];
  paymentMethod: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type StoredInstrumentAeropay = StoredInstrument & {
  __typename?: 'StoredInstrumentAeropay';
  accountName: Scalars['String']['output'];
  accountNumber: Scalars['String']['output'];
  bankName: Scalars['String']['output'];
  internalId: Scalars['String']['output'];
  paymentMethod: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type StoredInstrumentPayPal = StoredInstrument & {
  __typename?: 'StoredInstrumentPayPal';
  email: Scalars['String']['output'];
  holderName: Scalars['String']['output'];
  internalId: Scalars['String']['output'];
  maskedEmail: Scalars['String']['output'];
  paymentMethod: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type StoredInstrumentVenmo = StoredInstrument & {
  __typename?: 'StoredInstrumentVenmo';
  internalId: Scalars['String']['output'];
  paymentMethod: Scalars['String']['output'];
  type: Scalars['String']['output'];
  venmoUserId: Scalars['String']['output'];
  venmoUserName: Scalars['String']['output'];
};

export type StoredPaymentInstrument = {
  __typename?: 'StoredPaymentInstrument';
  accountId: Scalars['String']['output'];
  cardNumber?: Maybe<Scalars['String']['output']>;
  expiryMonth?: Maybe<Scalars['Int']['output']>;
  expiryYear?: Maybe<Scalars['Int']['output']>;
  holderName?: Maybe<Scalars['String']['output']>;
  /** Either CardDeposit or Redirect */
  integrationType: Scalars['String']['output'];
  /** Time when this payment instrument was last used */
  lastUsed: Scalars['DateTime']['output'];
  /** Visa, AmericanExpress, Mastercard etc. */
  method: Scalars['String']['output'];
  /** Name of the payment provider */
  provider: Scalars['String']['output'];
  /** If true, the CVV has to be resubmitted for each payment */
  requiresCvvConfirmation: Scalars['Boolean']['output'];
  /** @deprecated Stored payment instruments do not need a token */
  token: PaymentToken;
  /** For example CreditCard, PayPal etc. */
  type: Scalars['String']['output'];
  /** For example ApplePay */
  walletType?: Maybe<Scalars['String']['output']>;
};

export type StoredPaymentInstruments = {
  __typename?: 'StoredPaymentInstruments';
  activePayInInstruments: Array<StoredInstrument>;
  activePayOutInstruments: Array<StoredInstrument>;
};

export type StoredPaymentInstrumentsInput = {
  licensedTerritory: Scalars['String']['input'];
};

export enum SubscriptionCancelReason {
  BackofficeRequest = 'BACKOFFICE_REQUEST',
  BreakingChangeInLotteryConfig = 'BREAKING_CHANGE_IN_LOTTERY_CONFIG',
  Closing = 'CLOSING',
  CustomerRequest = 'CUSTOMER_REQUEST',
  InitialSubmissionFailed = 'INITIAL_SUBMISSION_FAILED',
  InsufficientFunds = 'INSUFFICIENT_FUNDS',
  LicensedTerritoryShutdown = 'LICENSED_TERRITORY_SHUTDOWN',
  LimitExceeded = 'LIMIT_EXCEEDED',
  LotterySunset = 'LOTTERY_SUNSET',
  PaymentFailed = 'PAYMENT_FAILED',
  SelfExclusion = 'SELF_EXCLUSION',
  Suspended = 'SUSPENDED',
  UnexpectedError = 'UNEXPECTED_ERROR',
  Unknown = 'UNKNOWN'
}

/** Response to a subscription mutation request. Contains the resulting subscription code and status */
export type SubscriptionInfo = {
  __typename?: 'SubscriptionInfo';
  cancelReason?: Maybe<SubscriptionCancelReason>;
  cancelledDate?: Maybe<Scalars['DateTime']['output']>;
  code: Scalars['SubscriptionCode']['output'];
  drawsPerPurchase: Scalars['Int']['output'];
  firstDraw: Scalars['DateTime']['output'];
  status: SubscriptionStatus;
  type: SubscriptionType;
};

export type SubscriptionInput = {
  code: Scalars['SubscriptionCode']['input'];
};

export type SubscriptionMultipleLines = {
  __typename?: 'SubscriptionMultipleLines';
  cancelReason?: Maybe<SubscriptionCancelReason>;
  cancelledDate?: Maybe<Scalars['DateTime']['output']>;
  /** The subscription's human readable identifier */
  code: Scalars['SubscriptionCode']['output'];
  firstDraw: Scalars['DateTime']['output'];
  /** The subscription's object ID */
  id: Scalars['String']['output'];
  lastDrawDate: Scalars['DateTime']['output'];
  /** The latest order ID for this subscription without suffix (e.g. '.1', '.2') */
  latestOrderId: Scalars['String']['output'];
  /** The latest play slip order ID for this subscription */
  latestPlaySlipOrderId?: Maybe<Scalars['String']['output']>;
  licensedTerritory: Scalars['String']['output'];
  lotteryId: LotteryId;
  nextDrawDate?: Maybe<Scalars['DateTime']['output']>;
  /** The number of extra hit plays, if applicable, otherwise 0 */
  numberOfExtraHitPlays: Scalars['Int']['output'];
  /** The number of normal plays, excluding any extra hit plays */
  numberOfPlays: Scalars['Int']['output'];
  prepaidOptions?: Maybe<PrepaidOptions>;
  /** Whether the latest order of this subscription can be replayed from the licensedTerritory passed to the query. False when that argument is omitted. */
  replayable: Scalars['Boolean']['output'];
  selectedAddOns: Array<Scalars['String']['output']>;
  status: SubscriptionStatus;
};

export type SubscriptionOptions = {
  __typename?: 'SubscriptionOptions';
  drawsPerPurchase: Scalars['Int']['output'];
  type: SubscriptionType;
};

export type SubscriptionOptionsInput = {
  drawsPerPurchase: Scalars['Int']['input'];
  type: SubscriptionType;
};

export type SubscriptionOrderMultipleLinesPayload = {
  __typename?: 'SubscriptionOrderMultipleLinesPayload';
  cancelReason?: Maybe<SubscriptionCancelReason>;
  cancelledDate?: Maybe<Scalars['DateTime']['output']>;
  drawsPerPurchase: Scalars['Int']['output'];
  firstDrawDate: Scalars['DateTime']['output'];
  /** Internal ID of the subscription */
  id: Scalars['String']['output'];
  lastDrawDate: Scalars['DateTime']['output'];
  latestPlaySlipOrderId: Scalars['String']['output'];
  lottery: LotteryPayload;
  nextDrawDate?: Maybe<Scalars['DateTime']['output']>;
  nextOrderId?: Maybe<Scalars['String']['output']>;
  numberOfDraws: Scalars['Int']['output'];
  /** The number of extra hit plays, if applicable, otherwise 0 */
  numberOfExtraHitPlays: Scalars['Int']['output'];
  /** The number of normal plays, excluding any extra hit plays */
  numberOfPlays: Scalars['Int']['output'];
  /** The licensed territory of the subscription order. */
  orderedIn: Scalars['String']['output'];
  prepaidOptions?: Maybe<PrepaidOptions>;
  previousOrderId?: Maybe<Scalars['String']['output']>;
  price: Money;
  /** Whether the latest order of this subscription can be replayed from the licensedTerritory passed to the query. False when that argument is omitted. */
  replayable: Scalars['Boolean']['output'];
  /**
   *
   *             Returns a paginated list of draw results for the play slip order.
   *             Valid values for the limit are 1 to 50.
   *             Valid values for offset are at least 0.
   *             The default values are 0 for offset and 10 for limit.
   *
   */
  results: Array<ResultsMultipleLines>;
  status: SubscriptionStatus;
  subscriptionCode: Scalars['SubscriptionCode']['output'];
  subscriptionType: SubscriptionType;
  totalDrawResults: Scalars['Int']['output'];
  type: PlaySlipType;
};


export type SubscriptionOrderMultipleLinesPayloadResultsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export enum SubscriptionStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Paused = 'PAUSED'
}

export enum SubscriptionType {
  Prepaid = 'PREPAID',
  Renewing = 'RENEWING'
}

export type SubscriptionsFilterInput = {
  licensedTerritory?: InputMaybe<Scalars['String']['input']>;
  status: Array<SubscriptionStatus>;
};

export type SubscriptionsMultipleLines = {
  __typename?: 'SubscriptionsMultipleLines';
  count: Scalars['Long']['output'];
  subscriptions: Array<SubscriptionMultipleLines>;
};

export type TeaserPayload = FreeToPlayTeaserPayload | HighFrequencyTeaserPayload | LotteryTeaserPayload | ScratchcardTeaserPayload;

export type TeasersPayload = {
  __typename?: 'TeasersPayload';
  id: Scalars['String']['output'];
  teasers: Array<TeaserPayload>;
};

export type TicketScanPayload = {
  __typename?: 'TicketScanPayload';
  imageProperties: ImagePropertiesPayload;
  url: Scalars['String']['output'];
};

export type TicketScansMultipleLines = {
  __typename?: 'TicketScansMultipleLines';
  scans: Array<TicketScanPayload>;
  serialNumber: Scalars['String']['output'];
};

export type TogglePaymentInstrument = {
  __typename?: 'TogglePaymentInstrument';
  isActive: Scalars['Boolean']['output'];
  paymentInstrumentId: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type TransactionHistory = {
  __typename?: 'TransactionHistory';
  total: Scalars['Long']['output'];
  transactions: Array<TransactionHistoryPayload>;
};

export type TransactionHistoryPayload = {
  __typename?: 'TransactionHistoryPayload';
  amount: Money;
  bookingDate: Scalars['Instant']['output'];
  comment: Scalars['String']['output'];
  id: Scalars['String']['output'];
  orderId?: Maybe<Scalars['String']['output']>;
  payOutId?: Maybe<Scalars['String']['output']>;
  paymentIdentifier?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  paymentProvider?: Maybe<Scalars['String']['output']>;
  productType?: Maybe<ProductType>;
  serviceFees?: Maybe<Money>;
  totalCharged?: Maybe<Money>;
  type: Scalars['String']['output'];
};

export enum TransactionType {
  Bonus = 'BONUS',
  Chargeback = 'CHARGEBACK',
  CreditNote = 'CREDIT_NOTE',
  DebitNote = 'DEBIT_NOTE',
  PayIn = 'PAY_IN',
  PayOut = 'PAY_OUT',
  Refund = 'REFUND',
  ReverseChargeback = 'REVERSE_CHARGEBACK',
  Stake = 'STAKE',
  Winning = 'WINNING',
  WinningCorrection = 'WINNING_CORRECTION'
}

/** Channel for a player two factor authentication */
export enum TwoFactorAuthenticationChannel {
  /** Email Channel */
  Email = 'EMAIL',
  /** SMS Channel */
  Sms = 'SMS'
}

/** Setting for a players two factor authentication configuration. */
export type TwoFactorAuthenticationChannelSettingPayload = {
  __typename?: 'TwoFactorAuthenticationChannelSettingPayload';
  activated: Scalars['Boolean']['output'];
  channel: TwoFactorAuthenticationChannel;
};

/** Setting for a players two factor authentication configuration. */
export type TwoFactorAuthenticationChannelSettingPayloadInput = {
  activated: Scalars['Boolean']['input'];
  channel: TwoFactorAuthenticationChannel;
};

/** Setting for a players two factor authentication configuration. */
export enum TwoFactorAuthenticationSetting {
  /** Use direct user communication as the second factor for authentication. */
  Notification = 'Notification',
  /** Disable two factor authentication. */
  Off = 'Off'
}

/** The current configuration of a player. */
export type TwoFactorConfigurationPayload = {
  __typename?: 'TwoFactorConfigurationPayload';
  channels: Array<TwoFactorAuthenticationChannelSettingPayload>;
};

export type TypedGraphQlError = {
  message: Scalars['String']['output'];
};

export type Unlimited = Limit & {
  __typename?: 'Unlimited';
  period: LimitPeriod;
  type: LimitType;
};

export type UnsubscribeMarketingInput = {
  unsubscribeToken: Scalars['UUID']['input'];
};

export type UnsubscribeMarketingPayload = {
  __typename?: 'UnsubscribeMarketingPayload';
  success: Scalars['Boolean']['output'];
};

export type UploadIdentityDocumentInput = {
  identityDocumentUploadUrl: Scalars['Url']['input'];
};

export type UploadIdentityDocumentPayload = {
  __typename?: 'UploadIdentityDocumentPayload';
  receivedAt: Scalars['Instant']['output'];
};

/**
 *
 *     One verification item.
 *     | Contains the 'name' of the verification, it's status and which verification-step it depends on, if any.
 *
 */
export type VerificationPayload = {
  __typename?: 'VerificationPayload';
  dependsOn?: Maybe<VerificationPayloadName>;
  manualVerificationUrl?: Maybe<Scalars['String']['output']>;
  name: VerificationPayloadName;
  status: VerificationPayloadStatus;
};

/** A name of a verification step. */
export enum VerificationPayloadName {
  AutomaticAgeVerification = 'AutomaticAgeVerification',
  EmailVerification = 'EmailVerification',
  IdUploadAgeVerification = 'IDUploadAgeVerification',
  ManualAgeVerification = 'ManualAgeVerification',
  PhoneVerification = 'PhoneVerification'
}

/** A status of a verification. */
export enum VerificationPayloadStatus {
  Failure = 'Failure',
  NotStarted = 'NotStarted',
  NotSupported = 'NotSupported',
  Pending = 'Pending',
  Success = 'Success',
  Unverified = 'Unverified',
  UploadRetriesExhausted = 'UploadRetriesExhausted'
}

export type VerifyEmailInput = {
  silentEmailVerificationToken: Scalars['String']['input'];
};

export type VerifyEmailPayload = {
  __typename?: 'VerifyEmailPayload';
  success: Scalars['Boolean']['output'];
};

export type VerifyPhoneInput = {
  verificationCode: Scalars['String']['input'];
};

export type VerifyPhonePayload = {
  __typename?: 'VerifyPhonePayload';
  verified: Scalars['Boolean']['output'];
};

export type VersionedConfig = {
  __typename?: 'VersionedConfig';
  addOns: Array<AddOn>;
  afterPurchaseAddOns: Array<AddOn>;
  /** List of allowed numbers of plays */
  allowedPlays: Array<Scalars['Int']['output']>;
  combinedTierTable: Scalars['Boolean']['output'];
  drawDates: Array<DrawDate>;
  drawInterval: DrawInterval;
  /** If false, the lottery does not provide the number of winners */
  hasNumberOfWinners: Scalars['Boolean']['output'];
  /** If true, certain combinations may get sold out and stop being available for play */
  isLockoutLottery: Scalars['Boolean']['output'];
  jackpotType: JackpotType;
  jackpots: Array<JackpotDefinition>;
  /** @deprecated Use allowedPlays instead */
  maxPlays?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use allowedPlays instead */
  minPlays?: Maybe<Scalars['Int']['output']>;
  numberOfDraws: Array<Scalars['Int']['output']>;
  numbers: Array<NumbersConfig>;
  /** If != null, customers can purchase prepaid subscriptions */
  prepaidSubscription?: Maybe<PrepaidSubscriptionsConfig>;
  prizeTierCategories: Array<PrizeTierCategory>;
  quickPick?: Maybe<VersionedConfigQuickpicks>;
  stakes: Array<Stake>;
  /** If true, customers can purchase play slip subscriptions */
  subscriptionsAllowed: Scalars['Boolean']['output'];
  type: LotteryType;
  /** ID of the first draw with the new rules */
  version: Scalars['String']['output'];
};

export type VersionedConfigQuickpicks = {
  __typename?: 'VersionedConfigQuickpicks';
  addOns: Array<AddOnOutput>;
  plays: Scalars['Int']['output'];
  validQuickPickPlays: Array<Scalars['Int']['output']>;
};

export type WelcomeToWineverElement = {
  __typename?: 'WelcomeToWineverElement';
  id: Scalars['String']['output'];
};

export type WinnerTrustElement = {
  __typename?: 'WinnerTrustElement';
  id: Scalars['String']['output'];
};

export type WinningMultipleLines = {
  __typename?: 'WinningMultipleLines';
  amount?: Maybe<Money>;
  numberOfFreePlays?: Maybe<Scalars['Int']['output']>;
};

export type WinningsPayload = {
  __typename?: 'WinningsPayload';
  amount?: Maybe<Money>;
  freeTickets: Scalars['Int']['output'];
  isBigWin: Scalars['Boolean']['output'];
  prizeTier?: Maybe<Scalars['Int']['output']>;
};

export type ZonedTime = {
  __typename?: 'ZonedTime';
  local: Scalars['LocalTime']['output'];
  zone: Scalars['String']['output'];
};

export type AddOnFragment = { mandatory: boolean, name: string, options: Array<string>, perPlay: boolean };

type Campaign_CampaignBadgePayload_Fragment = { bonusCode: string | null, infoHeadline: string | null, infoText: string | null, title: string, type: Types.BadgeType };

type Campaign_CampaignHeroHighlightPayload_Fragment = { pattern: Types.HeroHighlightPattern, badge: { bonusCode: string | null, color: string, infoHeadline: string | null, infoText: string | null, placement: Types.HeroHighlightStyle, title: string, subtitle: string } };

export type CampaignFragment =
  | Campaign_CampaignBadgePayload_Fragment
  | Campaign_CampaignHeroHighlightPayload_Fragment
;

export type CouponInfoFragment = { code: string, description: string, title: string, value: { amount: number, type: Types.BonusValueEnum } };

export type CouponValidationResultFragment = { fulfillable: boolean, fulfilled: boolean, unfulfilledConditions: Array<string>, info: { code: string, description: string, title: string, value: { amount: number, type: Types.BonusValueEnum } }, minTotalCharge: { currency: string, value: number } | null };

export type FreeToPlayTeaserFragment = { __typename: 'FreeToPlayTeaserPayload', id: string };

type HighFrequencyDrawStatus_HighFrequency_DrawStatusGeneral_Fragment = { status: Types.HighFrequency_DrawStatusEnum };

type HighFrequencyDrawStatus_HighFrequency_DrawStatusNotOperating_Fragment = { resumesAt: string, status: Types.HighFrequency_DrawStatusEnum };

type HighFrequencyDrawStatus_HighFrequency_DrawStatusPending_Fragment = { status: Types.HighFrequency_DrawStatusEnum, drawsAt: string };

type HighFrequencyDrawStatus_HighFrequency_DrawStatusReady_Fragment = { status: Types.HighFrequency_DrawStatusEnum };

export type HighFrequencyDrawStatusFragment =
  | HighFrequencyDrawStatus_HighFrequency_DrawStatusGeneral_Fragment
  | HighFrequencyDrawStatus_HighFrequency_DrawStatusNotOperating_Fragment
  | HighFrequencyDrawStatus_HighFrequency_DrawStatusPending_Fragment
  | HighFrequencyDrawStatus_HighFrequency_DrawStatusReady_Fragment
;

export type HighFrequencyOrderDetailFragment = { gameId: Types.HighFrequency_GameId, orderId: string, orderedIn: string, status: Types.HighFrequency_OrderStatus, replayable: boolean, numberOfDraws: number, numberOfSpots: number, addOns: Array<{ name: string, value: string }>, price: { currency: string, value: number }, wager: { currency: string, value: number }, numbers: Array<{ name: string, values: Array<{ value: number, matching: boolean | null }> }>, ticketScans: { expirationDate: string, front: { blurHash: string, height: number, width: number, url: string }, back: { blurHash: string, height: number, width: number, url: string } } | null, draws: Array<{ id: string, orderId: string, participationId: string, number: number, results: Array<{ name: string, values: Array<{ value: number, matching: boolean | null }> }>, status:
      | { status: Types.HighFrequency_DrawStatusEnum }
      | { resumesAt: string, status: Types.HighFrequency_DrawStatusEnum }
      | { drawsAt: string, status: Types.HighFrequency_DrawStatusEnum }
      | { status: Types.HighFrequency_DrawStatusEnum }
    , winnings: { isBigWin: boolean, pariMutuel: boolean, amount: { currency: string, value: number } } | null }>, nextDraw: { id: string, orderId: string, participationId: string, number: number, status:
      | { status: Types.HighFrequency_DrawStatusEnum }
      | { resumesAt: string, status: Types.HighFrequency_DrawStatusEnum }
      | { drawsAt: string, status: Types.HighFrequency_DrawStatusEnum }
      | { status: Types.HighFrequency_DrawStatusEnum }
     } | null, totalWinnings: { isBigWin: boolean, pariMutuel: boolean, amount: { currency: string, value: number } } | null };

export type HighFrequencyTeaserFragment = { __typename: 'HighFrequencyTeaserPayload', id: string, jackpotType: Types.JackpotType, operating: boolean, jackpotSize: { currency: string, value: number }, campaign:
    | { bonusCode: string | null, infoHeadline: string | null, infoText: string | null, title: string, type: Types.BadgeType }
    | { pattern: Types.HeroHighlightPattern, badge: { bonusCode: string | null, color: string, infoHeadline: string | null, infoText: string | null, placement: Types.HeroHighlightStyle, title: string, subtitle: string } }
   | null, operatingHours: { nextStart: string, nextEndInclusive: string } };

export type ImagePropertiesFragment = { blurHash: string, height: number, width: number };

export type LotteryTeaserFragment = { __typename: 'LotteryTeaserPayload', closingDate: string, comingSoon: boolean, drawDate: string, id: string, jackpotType: Types.JackpotType, lotteryType: Types.LotteryType, campaign:
    | { bonusCode: string | null, infoHeadline: string | null, infoText: string | null, title: string, type: Types.BadgeType }
    | { pattern: Types.HeroHighlightPattern, badge: { bonusCode: string | null, color: string, infoHeadline: string | null, infoText: string | null, placement: Types.HeroHighlightStyle, title: string, subtitle: string } }
   | null, jackpotSize: { __typename: 'Money', currency: string, value: number }, quickPick: { __typename: 'QuickPickConfiguration', plays: number, addOns: Array<{ __typename: 'AddOnOutput', name: string, value: string }> } | null };

export type MoneyFragment = { currency: string, value: number };

export type PlayAddOnFragment = { name: string, value: string };

export type PlayFieldFragment = { name: string, numbers: Array<{ matching: boolean, value: number }> };

type Play_BasePlayMultipleLines_Fragment = { __typename: 'BasePlayMultipleLines', serialNumber: string, state: Types.PlaySlipStatus, addOns: Array<{ name: string, value: string }>, addOnValues: Array<{ name: string, value: string }>, fields: Array<{ name: string, numbers: Array<{ matching: boolean, value: number }> }>, winnings: { numberOfFreePlays: number | null, amount: { currency: string, value: number } | null } };

type Play_ExtraPlayMultipleLines_Fragment = { __typename: 'ExtraPlayMultipleLines', serialNumber: string, state: Types.PlaySlipStatus, plays: Array<{ addOns: Array<{ name: string, value: string }>, addOnValues: Array<{ name: string, value: string }>, fields: Array<{ name: string, numbers: Array<{ matching: boolean, value: number }> }>, winnings: { numberOfFreePlays: number | null, amount: { currency: string, value: number } | null } }>, addOns: Array<{ name: string, value: string }>, addOnValues: Array<{ name: string, value: string }>, fields: Array<{ name: string, numbers: Array<{ matching: boolean, value: number }> }>, winnings: { numberOfFreePlays: number | null, amount: { currency: string, value: number } | null } };

export type PlayFragment =
  | Play_BasePlayMultipleLines_Fragment
  | Play_ExtraPlayMultipleLines_Fragment
;

export type PlayWinningFragment = { numberOfFreePlays: number | null, amount: { currency: string, value: number } | null };

export type PlayerLimitFragment = { nextIncreaseFrom: string, nextPeriodStart: string, available: { currency: string, value: number }, value: { currency: string, value: number } };

export type PrizeTierCategoryFragment = { group: string, name: string, categoryRequirements: Array<
    | { type: Types.PrizeTierCategoryRequirementsPayloadType }
    | { __typename: 'ByAddOnSelected', addOnName: string, type: Types.PrizeTierCategoryRequirementsPayloadType }
    | { __typename: 'ByMultiplierDeselected', addOnName: string, type: Types.PrizeTierCategoryRequirementsPayloadType }
    | { __typename: 'ByMultiplierSelected', addOnName: string, reference: string, value: number, type: Types.PrizeTierCategoryRequirementsPayloadType }
    | { __typename: 'ByMultiplierValueMatched', addOnName: string, value: number, type: Types.PrizeTierCategoryRequirementsPayloadType }
    | { type: Types.PrizeTierCategoryRequirementsPayloadType }
  >, prizeTiers: Array<{ jackpot: boolean, payoutInterval: Types.PayoutInterval, tier: string, type: Types.PrizeTierType, amount: { currency: string, value: number } | null, requirements:
      | { type: Types.PrizeTierRequirementsPayloadType }
      | { type: Types.PrizeTierRequirementsPayloadType }
      | { type: Types.PrizeTierRequirementsPayloadType }
      | { type: Types.PrizeTierRequirementsPayloadType, numberRequirements: Array<{ amountOfCorrectNumbers: number, numbersReference: string }> }
      | { type: Types.PrizeTierRequirementsPayloadType, pickRequirements: Array<{ betType: string, ignoreFields: Array<string> }> }
     }> };

export type ScratchcardTeaserFragment = { __typename: 'ScratchcardTeaserPayload', name: string, slug: string, amount: { currency: string, value: number } | null, campaign:
    | { bonusCode: string | null, infoHeadline: string | null, infoText: string | null, title: string, type: Types.BadgeType }
    | { pattern: Types.HeroHighlightPattern, badge: { bonusCode: string | null, color: string, infoHeadline: string | null, infoText: string | null, placement: Types.HeroHighlightStyle, title: string, subtitle: string } }
   | null, price: { currency: string, value: number } | null, visualParameters: { primaryColor: string | null, secondaryColor: string | null, teaserImageUrl: string | null, titleColor: string } | null };

export type BuyWithBalanceMutationVariables = Exact<{
  licensedTerritory: string;
  locationProfilingId: string;
  locationSessionId?: string | null | undefined;
  productId: string;
  submitterIPAddress?: string | null | undefined;
}>;


export type BuyWithBalanceMutation = { purchase:
    | { firstPayIn: boolean, orderId: string, reference: string, status: Types.OrderStatus }
    | { firstPayIn: boolean, orderId: string, reference: string, status: Types.OrderStatus }
    | { firstPayIn: boolean, orderId: string, reference: string, status: Types.OrderStatus }
   };

export type BuyWithTopUpMutationVariables = Exact<{
  licensedTerritory: string;
  locationProfilingId: string;
  locationSessionId?: string | null | undefined;
  paymentData: Types.PaymentDataInput;
  productId: string;
  submitterIPAddress?: string | null | undefined;
}>;


export type BuyWithTopUpMutation = { purchase:
    | { __typename: 'CancelledOrder', firstPayIn: boolean, orderId: string, reference: string, status: Types.OrderStatus }
    | { __typename: 'CreatedOrder', firstPayIn: boolean, orderId: string, reference: string, status: Types.OrderStatus }
    | { __typename: 'PaidOrder', firstPayIn: boolean, orderId: string, reference: string, status: Types.OrderStatus }
   };

export type CheckoutQueryVariables = Exact<{
  licensedTerritory: string;
  productId: string;
}>;


export type CheckoutQuery = { checkout: { bonusCode: string | null, state: Types.CheckoutState, notification: Types.CheckoutNotification | null, accountBalance: { currency: string, value: number }, discount: { currency: string, value: number } | null, restrictions: { geoCheck: Types.GeoCheckStatus, playerCheck: Types.PlayerCheckStatus, depositLimit: { period: Types.LimitPeriod, type: Types.LimitType, available: { currency: string, value: number }, value: { currency: string, value: number } } | null, spendingLimit: { period: Types.LimitPeriod, type: Types.LimitType, available: { currency: string, value: number }, value: { currency: string, value: number } } | null } | null, payment:
      | { __typename: 'PayWithBalance', payWithBalance: boolean, accountBalance: { currency: string, value: number }, topUpAmount: { currency: string, value: number }, totalPrice: { currency: string, value: number } }
      | { __typename: 'PayWithTopUp', paymentId: string, payWithBalance: boolean, initial: Array<{ type: string, integrationType: string, methods: Array<string>, accountId: string, provider: string, providerUri: string | null, venmoProfileId: string | null, token: { expires: string, value: string } }>, stored: Array<{ type: string, integrationType: string, method: string, holderName: string | null, accountId: string, cardNumber: string | null, expiryMonth: number | null, expiryYear: number | null, provider: string, requiresCvvConfirmation: boolean, token: { expires: string, value: string } }>, accountBalance: { currency: string, value: number }, topUpAmount: { currency: string, value: number }, totalPrice: { currency: string, value: number } }
     | null, product:
      | { __typename: 'HighFrequencyProduct', expiresAt: string, gameId: Types.GameId, name: string, price: { currency: string, value: number }, priceBreakdown: { __typename: 'HighFrequencyPriceBreakdown', numberOfDraws: number, numberOfSpots: number, discountPercentage: number, addOns: Array<{ name: string, charge: { currency: string, value: number } }>, chargeTotal: { currency: string, value: number }, salesTax: { currency: string, value: number }, feeTotal: { currency: string, value: number }, grossTotal: { currency: string, value: number }, netTotal: { currency: string, value: number }, wager: { currency: string, value: number }, wagerCharge: { currency: string, value: number } } }
      | { __typename: 'LotteryProduct', name: string, numberOfDraws: number, numberOfPlays: number, subscription: boolean, price: { currency: string, value: number }, priceBreakdown: { __typename: 'PriceBreakdown', libraryVersion: string, lotteryConfigVersion: string, numberOfDraws: number, numberOfPlays: number, priceListVersion: string, addOnChargePerPlaySlip: { currency: string, value: number }, addOnFeePerPlaySlip: { currency: string, value: number }, chargePerPlaySlip: { currency: string, value: number }, chargeTotal: { currency: string, value: number }, chargesForPlaySlipAddOns: Array<{ name: string, baseCharge: { currency: string, value: number }, fee: { currency: string, value: number }, total: { currency: string, value: number } }>, chargesPerPlay: Array<{ extraInfo: string | null, name: string, addOns: Array<{ name: string, baseCharge: { currency: string, value: number }, fee: { currency: string, value: number }, total: { currency: string, value: number } }>, baseCharge: { currency: string, value: number }, fee: { currency: string, value: number } }>, feePerPlaySlip: { currency: string, value: number }, feeTotal: { currency: string, value: number }, grossTotal: { currency: string, value: number }, groupedPlays: Array<{ betType: string | null, name: string | null, plays: number, virtualPlays: number | null, addOns: Array<{ name: string, price: { perUnit: { currency: string, value: number }, sum: { currency: string, value: number } } }>, price: { perUnit: { currency: string, value: number }, sum: { currency: string, value: number } }, wagerAmount: { currency: string, value: number } | null }>, netTotal: { currency: string, value: number }, playChargePerPlaySlip: { currency: string, value: number }, playFeePerPlaySlip: { currency: string, value: number }, salesTax: { currency: string, value: number } }, subscriptionOptions: { drawsPerPurchase: number, type: Types.SubscriptionType } | null }
      | { __typename: 'ScratchcardProduct', expiresAt: string, name: string, quantity: number, reservationId: string, price: { currency: string, value: number }, priceBreakdown: { __typename: 'ScratchcardPriceBreakdown', quantity: number, chargeForOrder: { currency: string, value: number }, chargeTotal: { currency: string, value: number }, chargesForCards: { currency: string, value: number }, feeTotal: { currency: string, value: number }, feesForCards: { currency: string, value: number }, feeForOrder: { currency: string, value: number }, grossTotal: { currency: string, value: number }, netTotal: { currency: string, value: number }, salesTax: { currency: string, value: number } } }
     | null } };

export type HighFrequencyReplayPlaySlipMutationVariables = Exact<{
  input: Types.HighFrequencyReplayPlaySlipInput;
}>;


export type HighFrequencyReplayPlaySlipMutation = { highFrequencyReplayPlaySlip:
    | { id: string }
    | { errors: Array<
        | { __typename: 'HighFrequency_ReplayError_GameNotActiveError', message: string }
        | { __typename: 'HighFrequency_ReplayError_InvalidLicensedTerritoryError', message: string }
        | { __typename: 'HighFrequency_ReplayError_InvalidOrderIdError', message: string }
        | { __typename: 'HighFrequency_ReplayError_NotReplayableError', message: string }
        | { __typename: 'HighFrequency_ReplayError_PlaySlipNotFoundError', message: string }
        | { __typename: 'HighFrequency_ReplayError_PlayerCannotPlayError', message: string }
        | { __typename: 'HighFrequency_ReplayError_UnexpectedError', message: string }
      > }
   };

export type OrderPollQueryVariables = Exact<{
  orderId: string;
}>;


export type OrderPollQuery = { order:
    | { status: Types.OrderStatus, cancelReasonType: Types.CancelReasonType }
    | { status: Types.OrderStatus }
    | { status: Types.OrderStatus }
   };

export type OrderedTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type OrderedTypeQuery = { orderedType: { highFrequency: boolean, lottery: boolean, scratchcard: boolean, subscription: boolean } };

export type AddFundsStatusQueryVariables = Exact<{
  id: string;
}>;


export type AddFundsStatusQuery = { addFundsStatus: { id: string, status: Types.AddFundsState } };

export type AddFundsMutationVariables = Exact<{
  input: Types.AddFundsMutationInput;
}>;


export type AddFundsMutation = { addFunds: { id: string, isFirstPurchase: boolean, status: Types.AddFundsState } };

export type AddFundsConfigQueryVariables = Exact<{
  licensedTerritory: string;
  input?: Types.AddFundsInput | null | undefined;
}>;


export type AddFundsConfigQuery = { addFundsConfig: { productId: string | null, withCustomAmount: boolean, fees: { dynamicFee: number, staticFee: { currency: string, value: number } }, limits: { maxPayInAmount: { currency: string, value: number }, minPayInAmount: { currency: string, value: number } }, payment: { paymentId: string, initial: Array<{ accountId: string, integrationType: string, methods: Array<string>, provider: string, providerUri: string | null, type: string, venmoProfileId: string | null, token: { expires: string, value: string } }>, stored: Array<{ accountId: string, cardNumber: string | null, expiryMonth: number | null, expiryYear: number | null, holderName: string | null, integrationType: string, lastUsed: string, method: string, provider: string, requiresCvvConfirmation: boolean, type: string, token: { expires: string, value: string } }> }, pricePoints: Array<{ isMostPopular: boolean, withinFundingLimit: boolean, amount: { currency: string, value: number }, fees: { currency: string, value: number }, totalAmount: { currency: string, value: number } }> } };

export type ApplePayMerchantValidationQueryVariables = Exact<{
  input: Types.ApplePayMerchantValidationInput;
}>;


export type ApplePayMerchantValidationQuery = { applePayMerchantValidation: { encodedPaymentSession: string } };

export type CheckRoutingNumberQueryVariables = Exact<{
  routingNumber: string;
}>;


export type CheckRoutingNumberQuery = { checkRoutingNumber: { __typename: 'CheckRoutingNumberPayload', bankName: string | null, isKnown: boolean } };

export type PayOutAccountsQueryVariables = Exact<{
  licensedTerritory: string;
  useManualAccountsOnly?: boolean | null | undefined;
}>;


export type PayOutAccountsQuery = { payOutAccounts: { holderName: string, accounts: Array<
      | { accountNumber: string, bankAccountName: string, bankName: string, holderName: string, id: string, type: Types.PayOutAccountType }
      | { routingNumber: string, accountNumber: string, holderName: string, id: string, type: Types.PayOutAccountType }
      | { payPalPayerEmail: string, holderName: string, id: string, type: Types.PayOutAccountType }
    >, initialAccounts: Array<{ id: string, type: Types.PayOutAccountType, token: { expires: string, value: string } }>, minPayableBalance: { currency: string, value: number }, maxPayableBalance: { currency: string, value: number } } };

export type PayOutToSavedAccountMutationVariables = Exact<{
  input: Types.SavedPayOutInput;
}>;


export type PayOutToSavedAccountMutation = { payOutToSavedAccount: { id: string, state: Types.PayOutState, amount: { currency: string, value: number } } };

export type PaymentMethodsQueryVariables = Exact<{
  licensedTerritory: string;
}>;


export type PaymentMethodsQuery = { paymentMethods: Array<{ allowsSubscriptionPurchase: boolean, name: string, type: string }> };

export type AddPayOutInstrumentMutationVariables = Exact<{
  input: Types.AddPayOutAccountInput;
}>;


export type AddPayOutInstrumentMutation = { addPayOutAccount: { __typename: 'AddPayOutAccountPayload', id: string } };

export type ConfirmAeropayMfaMutationVariables = Exact<{
  input: Types.AeropayConfirmMfaInput;
}>;


export type ConfirmAeropayMfaMutation = { confirmMfa: { preferredPayOutAccountId: string | null } };

export type RegisterAeropayUserMutationVariables = Exact<{
  input: Types.AeropayRegisterUserInput;
}>;


export type RegisterAeropayUserMutation = { registerUser:
    | { __typename: 'AeropayExistingUser', userId: string, displayMessage: string, email: string }
    | { __typename: 'AeropayNewUser', aggregatorToken: string, userId: string }
    | { __typename: 'AeropayReturningUser', userId: string }
   };

export type ChangePreferencesMutationVariables = Exact<{
  input: Types.PreferencesInput;
}>;


export type ChangePreferencesMutation = { setPreferences: Array<{ notification: Types.Notification, channels: Array<{ channel: Types.NotificationChannel, selected: boolean }> }> };

export type CheckPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckPreferencesQuery = { preferences: Array<{ notification: Types.Notification, channels: Array<{ channel: Types.NotificationChannel, selected: boolean }> }> };

export type AccountQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountQuery = { account: { balance: { __typename: 'Money', currency: string, value: number } } };

export type AcknowledgeTermsAndConditionsMutationVariables = Exact<{ [key: string]: never; }>;


export type AcknowledgeTermsAndConditionsMutation = { acknowledgeTermsAndConditions: { timestamp: string } };

export type ActiveAnnouncementQueryVariables = Exact<{
  licensedTerritory: string;
}>;


export type ActiveAnnouncementQuery = { activeAnnouncement: { id: string, title: string, description: string, changeDate: string, active: boolean } | null };

export type AddPaymentInstrumentMutationVariables = Exact<{
  input: Types.AddPaymentInstrumentInput;
}>;


export type AddPaymentInstrumentMutation = { addPaymentInstrument: { success: boolean } };

export type ChangeLimitsMutationVariables = Exact<{
  limits: Types.LimitsInput;
  type: Types.LimitType;
}>;


export type ChangeLimitsMutation = { changeLimitValue: Array<
    | { __typename: 'MaxLimit', period: Types.LimitPeriod, type: Types.LimitType }
    | { __typename: 'PlayerLimit', period: Types.LimitPeriod, type: Types.LimitType }
    | { __typename: 'Unlimited', period: Types.LimitPeriod, type: Types.LimitType }
  > };

export type ChangePlayerDataMutationVariables = Exact<{
  input: Types.ChangePlayerDataInput;
}>;


export type ChangePlayerDataMutation = { changePlayerData: { locale: string } };

export type CheckActivePendingQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckActivePendingQuery = { playSlipHistory: { active: Array<{ id: string }>, pending: Array<{ id: string }> } };

export type ClosePlayerMutationVariables = Exact<{
  input: Types.ClosePlayerInput;
}>;


export type ClosePlayerMutation = { closePlayer: { status: Types.Status } };

export type DeactivateStoredPaymentInstrumentMutationVariables = Exact<{
  input: Types.DeactivateStoredPaymentInstrumentInput;
}>;


export type DeactivateStoredPaymentInstrumentMutation = { deactivateStoredPaymentInstrument: { success: boolean } };

export type InitialPaymentInstrumentsQueryVariables = Exact<{
  input: Types.InitialPaymentInstrumentsInput;
}>;


export type InitialPaymentInstrumentsQuery = { initialPaymentInstruments: Array<{ accountId: string, integrationType: string, methods: Array<string>, provider: string, providerUri: string | null, type: string, venmoProfileId: string | null, token: { expires: string, value: string } }> };

export type LimitsQueryVariables = Exact<{
  withDeposit?: boolean | null | undefined;
  withSpending?: boolean | null | undefined;
}>;


export type LimitsQuery = { limits: { deposit?: Array<
      | { __typename: 'MaxLimit', type: Types.LimitType, period: Types.LimitPeriod }
      | { __typename: 'PlayerLimit', type: Types.LimitType, period: Types.LimitPeriod, nextIncreaseFrom: string, nextPeriodStart: string, available: { currency: string, value: number }, value: { currency: string, value: number } }
      | { __typename: 'Unlimited', type: Types.LimitType, period: Types.LimitPeriod }
    >, maxDeposit?: Array<
      | { __typename: 'MaxLimit', type: Types.LimitType, period: Types.LimitPeriod, value: { currency: string, value: number } }
      | { __typename: 'PlayerLimit', type: Types.LimitType, period: Types.LimitPeriod }
      | { __typename: 'Unlimited', type: Types.LimitType, period: Types.LimitPeriod }
    >, spending?: Array<
      | { __typename: 'MaxLimit', type: Types.LimitType, period: Types.LimitPeriod }
      | { __typename: 'PlayerLimit', type: Types.LimitType, period: Types.LimitPeriod, nextIncreaseFrom: string, nextPeriodStart: string, available: { currency: string, value: number }, value: { currency: string, value: number } }
      | { __typename: 'Unlimited', type: Types.LimitType, period: Types.LimitPeriod }
    >, maxSpending?: Array<
      | { __typename: 'MaxLimit', type: Types.LimitType, period: Types.LimitPeriod, value: { currency: string, value: number } }
      | { __typename: 'PlayerLimit', type: Types.LimitType, period: Types.LimitPeriod }
      | { __typename: 'Unlimited', type: Types.LimitType, period: Types.LimitPeriod }
    > } };

export type LoudlyVerifyEmailMutationVariables = Exact<{
  input: Types.LoudlyVerifyEmailInput;
}>;


export type LoudlyVerifyEmailMutation = { loudlyVerifyEmail:
    | { errors: Array<
        | { __typename: 'LoudlyVerifyEmailError_EmailExists' }
        | { __typename: 'LoudlyVerifyEmailError_InvalidPlayerStatus' }
        | { __typename: 'LoudlyVerifyEmailError_TokenExpired' }
        | { __typename: 'LoudlyVerifyEmailError_UnknownToken' }
      > }
    | { success: boolean }
   };

export type MarketingPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type MarketingPreferencesQuery = { marketingPreferences: { channels: Array<{ channel: Types.MarketingChannel, activated: boolean, verified: boolean }> } };

export type RequestEmailVerificationMutationVariables = Exact<{
  input: Types.RequestEmailVerificationInput;
}>;


export type RequestEmailVerificationMutation = { requestEmailVerification:
    | { errors: Array<
        | { __typename: 'RequestEmailVerificationError_AlreadyVerified' }
        | { __typename: 'RequestEmailVerificationError_EmailExists' }
        | { __typename: 'RequestEmailVerificationError_InvalidEmail' }
        | { __typename: 'RequestEmailVerificationError_InvalidPlayerStatus' }
        | { __typename: 'RequestEmailVerificationError_RequestRateLimit' }
      > }
    | { success: boolean }
   };

export type RequestVerificationCodeMutationVariables = Exact<{
  input: Types.ResendCodeMutationInput;
}>;


export type RequestVerificationCodeMutation = { requestVerificationCode: { countryCode: string, nationalNumber: string } };

export type ResendEmailVerificationMutationVariables = Exact<{
  input: Types.ResendEmailVerificationInput;
}>;


export type ResendEmailVerificationMutation = { resendEmailVerification:
    | { errors: Array<
        | { __typename: 'ResendEmailVerificationError_RequestRateLimit' }
        | { __typename: 'ResendEmailVerificationError_UnknownToken' }
      > }
    | { success: boolean }
   };

export type SelfExclusionMutationVariables = Exact<{
  input: Types.SelfExclusionInput;
}>;


export type SelfExclusionMutation = { selfExclusion: { expires: string, type: Types.SelfExclusionType, status: Types.Status } };

export type SetMarketingChannelPreferencesMutationVariables = Exact<{
  input: Types.MarketingChannelPreferenceMutationInput;
}>;


export type SetMarketingChannelPreferencesMutation = { setMarketingChannelPreferences: { activated: boolean, channel: Types.MarketingChannel } };

export type SetScanVerifyUploadStatusMutationVariables = Exact<{
  input: Types.SetScanVerifyUploadStatusInput;
}>;


export type SetScanVerifyUploadStatusMutation = { setScanVerifyUploadStatus: { manualVerificationUrl: string | null, name: Types.VerificationPayloadName, status: Types.VerificationPayloadStatus } };

export type SilentlyVerifyEmailMutationVariables = Exact<{
  input: Types.SilentlyVerifyEmailInput;
}>;


export type SilentlyVerifyEmailMutation = { silentlyVerifyEmail: { success: boolean } };

export type StoredPaymentInstrumentsQueryVariables = Exact<{
  input: Types.StoredPaymentInstrumentsInput;
}>;


export type StoredPaymentInstrumentsQuery = { storedPaymentInstruments: { activePayInInstruments: Array<
      | { internalId: string, paymentMethod: string, type: string }
      | { cardholderName: string, expirationDate: string, expiryMonth: number | null, expiryYear: number | null, maskedCardNumber: string, internalId: string, paymentMethod: string, type: string }
      | { internalId: string, paymentMethod: string, type: string }
      | { holderName: string, email: string, internalId: string, paymentMethod: string, type: string }
      | { venmoUserName: string, internalId: string, paymentMethod: string, type: string }
    > } };

export type TransactionsQueryVariables = Exact<{
  filter?: Types.ShopTransactionsFilterInput | null | undefined;
  limit: number;
  offset: number;
}>;


export type TransactionsQuery = { transactionHistory: { total: number, transactions: Array<{ bookingDate: string, comment: string, id: string, orderId: string | null, payOutId: string | null, paymentIdentifier: string | null, paymentMethod: string | null, paymentProvider: string | null, type: string, amount: { currency: string, value: number }, serviceFees: { currency: string, value: number } | null, totalCharged: { currency: string, value: number } | null }> } };

export type UploadIdentityDocumentMutationVariables = Exact<{
  input: Types.UploadIdentityDocumentInput;
}>;


export type UploadIdentityDocumentMutation = { uploadIdentityDocument: { receivedAt: string } };

export type UserDataQueryVariables = Exact<{ [key: string]: never; }>;


export type UserDataQuery = { player: { locale: string, address: any, customerId: string, dateOfBirth: string, email: string, familyName: string, givenName: string, id: string, lastAcknowledgedTermsAndConditions: string, registrationDate: string, status: Types.Status, phone: { countryCode: string, number: string, status: Types.VerificationPayloadStatus }, selfExclusion: { expires: string, type: Types.SelfExclusionType } | null, verifications: Array<{ dependsOn: Types.VerificationPayloadName | null, manualVerificationUrl: string | null, name: Types.VerificationPayloadName, status: Types.VerificationPayloadStatus }> } };

export type UserSecurityPhoneQueryVariables = Exact<{ [key: string]: never; }>;


export type UserSecurityPhoneQuery = { player: { id: string, status: Types.Status, phone: { countryCode: string, number: string, status: Types.VerificationPayloadStatus } } };

export type UserStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type UserStatusQuery = { player: { id: string, status: Types.Status, selfExclusion: { expires: string, type: Types.SelfExclusionType } | null } };

export type UserVerificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserVerificationsQuery = { player: { __typename: 'PlayerPayload', email: string, id: string, verifications: Array<{ __typename: 'VerificationPayload', dependsOn: Types.VerificationPayloadName | null, manualVerificationUrl: string | null, name: Types.VerificationPayloadName, status: Types.VerificationPayloadStatus }> } };

export type VerifyPhoneMutationVariables = Exact<{
  input: Types.VerifyPhoneInput;
}>;


export type VerifyPhoneMutation = { verifyPhone: { verified: boolean } };

export type PlayerSignupFinishedQueryVariables = Exact<{ [key: string]: never; }>;


export type PlayerSignupFinishedQuery = { playerSignupFinished: { exists: boolean } };

export type VerificationDataQueryVariables = Exact<{
  includePersonalData?: boolean;
}>;


export type VerificationDataQuery = { player: { id: string, customerId: string, email: string, familyName?: string, givenName?: string, status: Types.Status, phone: { countryCode: string, number: string, status: Types.VerificationPayloadStatus }, verifications: Array<{ dependsOn: Types.VerificationPayloadName | null, manualVerificationUrl: string | null, name: Types.VerificationPayloadName, status: Types.VerificationPayloadStatus }> } };

export type ApplyBonusCodeMutationVariables = Exact<{
  bonusCode: string;
  productId: string;
}>;


export type ApplyBonusCodeMutation = { applyBonusCode: { fulfillable: boolean, fulfilled: boolean, unfulfilledConditions: Array<string>, info: { code: string, description: string, title: string, value: { amount: number, type: Types.BonusValueEnum } }, minTotalCharge: { currency: string, value: number } | null } };

export type BonusCodeInfoQueryVariables = Exact<{
  bonusCode: string;
}>;


export type BonusCodeInfoQuery = { bonusCodeInfo: { code: string, description: string, title: string, value: { amount: number, type: Types.BonusValueEnum } } };

export type CancelSubscriptionMutationVariables = Exact<{
  code: string;
}>;


export type CancelSubscriptionMutation = { cancelSubscription: { status: Types.SubscriptionStatus } };

export type CheckBonusCodeForPlaySlipQueryVariables = Exact<{
  input: Types.BonusCodeValidationInput;
}>;


export type CheckBonusCodeForPlaySlipQuery = { checkBonusCodeForPlaySlip: { fulfillable: boolean, fulfilled: boolean, unfulfilledConditions: Array<string>, info: { code: string, description: string, title: string, value: { amount: number, type: Types.BonusValueEnum } }, minTotalCharge: { currency: string, value: number } | null } };

export type CheckScratchcardOrderQueryVariables = Exact<{
  orderId: string;
}>;


export type CheckScratchcardOrderQuery = { scratchcardOrder: { orderId: string } };

export type DefaultTeasersQueryVariables = Exact<{
  licensedTerritory: string;
  productType: Types.KnownProductType;
}>;


export type DefaultTeasersQuery = { defaultTeasers: { id: string, productType: Types.KnownProductType, teasers: Array<
      | { __typename: 'FreeToPlayTeaserPayload', id: string }
      | { __typename: 'HighFrequencyTeaserPayload', id: string, jackpotType: Types.JackpotType, operating: boolean, jackpotSize: { currency: string, value: number }, campaign:
          | { bonusCode: string | null, infoHeadline: string | null, infoText: string | null, title: string, type: Types.BadgeType }
          | { pattern: Types.HeroHighlightPattern, badge: { bonusCode: string | null, color: string, infoHeadline: string | null, infoText: string | null, placement: Types.HeroHighlightStyle, title: string, subtitle: string } }
         | null, operatingHours: { nextStart: string, nextEndInclusive: string } }
      | { __typename: 'LotteryTeaserPayload', closingDate: string, comingSoon: boolean, drawDate: string, id: string, jackpotType: Types.JackpotType, lotteryType: Types.LotteryType, campaign:
          | { bonusCode: string | null, infoHeadline: string | null, infoText: string | null, title: string, type: Types.BadgeType }
          | { pattern: Types.HeroHighlightPattern, badge: { bonusCode: string | null, color: string, infoHeadline: string | null, infoText: string | null, placement: Types.HeroHighlightStyle, title: string, subtitle: string } }
         | null, jackpotSize: { __typename: 'Money', currency: string, value: number }, quickPick: { __typename: 'QuickPickConfiguration', plays: number, addOns: Array<{ __typename: 'AddOnOutput', name: string, value: string }> } | null }
      | { __typename: 'ScratchcardTeaserPayload', name: string, slug: string, amount: { currency: string, value: number } | null, campaign:
          | { bonusCode: string | null, infoHeadline: string | null, infoText: string | null, title: string, type: Types.BadgeType }
          | { pattern: Types.HeroHighlightPattern, badge: { bonusCode: string | null, color: string, infoHeadline: string | null, infoText: string | null, placement: Types.HeroHighlightStyle, title: string, subtitle: string } }
         | null, price: { currency: string, value: number } | null, visualParameters: { primaryColor: string | null, secondaryColor: string | null, teaserImageUrl: string | null, titleColor: string } | null }
    > } };

export type DrawResultsQueryVariables = Exact<{
  filter?: Types.DrawResultsFilterInput | null | undefined;
  licensedTerritory: string;
  limit: number;
  offset: number;
}>;


export type DrawResultsQuery = { drawListByDay: { count: number, timeZone: string, days: Array<{ date: string, draws: Array<{ drawDate: string, hasMultipleDrawsOnDay: boolean, id: string, label: Types.DrawLabel, lotteryId: Types.LotteryId, drawnNumbers: Array<{ name: string, numbers: Array<{ modifies: string | null, name: string, values: Array<number> }> }>, lotteryConfig: { licensedTerritory: string, currentConfig: { addOns: Array<{ name: string, perPlay: boolean }> } } }> }> } };

export type FreeToPlayIframeUrlQueryVariables = Exact<{ [key: string]: never; }>;


export type FreeToPlayIframeUrlQuery = { freeToPlayIframeUrl: { iframeUrl: string } };

export type HighFrequencyDrawParticipationQueryVariables = Exact<{
  orderId: string;
  drawNumber: number;
}>;


export type HighFrequencyDrawParticipationQuery = { highFrequencyDrawParticipation:
    | { gameId: Types.HighFrequency_GameId, orderId: string, orderedIn: string, addOns: Array<{ name: string, value: string }>, draw: { id: string, orderId: string, participationId: string, number: number, results: Array<{ name: string, values: Array<{ matching: boolean | null, value: number }> }>, status:
          | { status: Types.HighFrequency_DrawStatusEnum }
          | { resumesAt: string, status: Types.HighFrequency_DrawStatusEnum }
          | { drawsAt: string, status: Types.HighFrequency_DrawStatusEnum }
          | { status: Types.HighFrequency_DrawStatusEnum }
        , winnings: { isBigWin: boolean, amount: { currency: string, value: number } } | null }, numbers: Array<{ name: string, values: Array<{ matching: boolean | null, value: number }> }> }
    | { errors: Array<{ message: string }> }
   };

export type HighFrequencyGameConfigQueryVariables = Exact<{
  gameId: Types.HighFrequency_GameId;
  licensedTerritory: string;
}>;


export type HighFrequencyGameConfigQuery = { highFrequencyGameConfig:
    | { disclaimerAccepted: boolean, gameId: Types.HighFrequency_GameId, version: string, status: Types.HighFrequency_GameConfigStatus, addOns: Array<{ maximumMultiplier: number | null, mandatory: boolean, name: string, options: Array<string>, type: Types.HighFrequency_AddOnType, fee:
          | { amount: { currency: string, value: number } }
          | { multiplier: number }
        , price:
          | { amount: { currency: string, value: number } }
          | { multiplier: number }
        , restrictions: Array<{ numbers: string, selected: Array<number>, type: Types.HighFrequency_AddOnRestrictionType }> }>, allowedNumberOfDraws: { numbers: Array<{ discount: number, values: Array<{ recommended: boolean, value: number }> }> }, jackpot: { type: Types.HighFrequency_JackpotType, value: { currency: string, value: number } }, numbers: Array<{ __typename: 'HighFrequency_NumbersConfig', max: number, min: number, name: string, selectableMax: number, selectableMin: number }>, prizeTierCategories: Array<{ name: string, prizeTiersByNumberOfSpots: Array<{ overallOdds: number, spots: number, prizeTiers: Array<
            | { __typename: 'HighFrequency_FixedPrizeTier', multipliedBy: string | null, tier: string, matchCount: number, amount: { currency: string, value: number } }
            | { __typename: 'HighFrequency_JackpotPrizeTier', matchCount: number, tier: string }
          > }> }>, wagers: Array<{ multiplier: number, name: string, fee: { amount: { currency: string, value: number } }, price: { amount: { currency: string, value: number } } }> }
    | { errors: Array<
        | { __typename: 'HighFrequency_GamesError_GameNotFoundError' }
        | { __typename: 'HighFrequency_GamesError_UnexpectedError' }
        | { __typename: 'HighFrequency_GamesError_UnknownLicensedTerritory' }
      > }
   };

export type HighFrequencyOrderDetailQueryVariables = Exact<{
  licensedTerritory: string;
  orderId: string;
}>;


export type HighFrequencyOrderDetailQuery = { highFrequencyOrderDetail:
    | { errors: Array<
        | { message: string }
        | Record<PropertyKey, never>
      > }
    | { gameId: Types.HighFrequency_GameId, orderId: string, orderedIn: string, status: Types.HighFrequency_OrderStatus, replayable: boolean, numberOfDraws: number, numberOfSpots: number, addOns: Array<{ name: string, value: string }>, price: { currency: string, value: number }, wager: { currency: string, value: number }, numbers: Array<{ name: string, values: Array<{ value: number, matching: boolean | null }> }>, ticketScans: { expirationDate: string, front: { blurHash: string, height: number, width: number, url: string }, back: { blurHash: string, height: number, width: number, url: string } } | null, draws: Array<{ id: string, orderId: string, participationId: string, number: number, results: Array<{ name: string, values: Array<{ value: number, matching: boolean | null }> }>, status:
          | { status: Types.HighFrequency_DrawStatusEnum }
          | { resumesAt: string, status: Types.HighFrequency_DrawStatusEnum }
          | { drawsAt: string, status: Types.HighFrequency_DrawStatusEnum }
          | { status: Types.HighFrequency_DrawStatusEnum }
        , winnings: { isBigWin: boolean, pariMutuel: boolean, amount: { currency: string, value: number } } | null }>, nextDraw: { id: string, orderId: string, participationId: string, number: number, status:
          | { status: Types.HighFrequency_DrawStatusEnum }
          | { resumesAt: string, status: Types.HighFrequency_DrawStatusEnum }
          | { drawsAt: string, status: Types.HighFrequency_DrawStatusEnum }
          | { status: Types.HighFrequency_DrawStatusEnum }
         } | null, totalWinnings: { isBigWin: boolean, pariMutuel: boolean, amount: { currency: string, value: number } } | null }
   };

export type HighFrequencyOrdersQueryVariables = Exact<{
  filter: Types.HighFrequency_OrdersFilterInput;
  limit: number;
  offset: number;
}>;


export type HighFrequencyOrdersQuery = { highFrequencyOrders:
    | { errors: Array<{ message: string }> }
    | { count: number, highFrequencyOrders: Array<{ __typename: 'HighFrequency_Order', hasWinnings: boolean, replayable: boolean, spots: number, gameId: Types.HighFrequency_GameId, orderId: string, readyDraws: number, totalDraws: number, revealedDraws: number, status: Types.HighFrequency_OrderStatus, addOns: Array<{ name: string, value: string }>, wager: { currency: string, value: number } }> }
   };

export type HighFrequencyRevealOrderMutationVariables = Exact<{
  licensedTerritory: string;
  orderId: string;
}>;


export type HighFrequencyRevealOrderMutation = { highFrequencyRevealOrder:
    | { gameId: Types.HighFrequency_GameId, orderId: string, orderedIn: string, status: Types.HighFrequency_OrderStatus, replayable: boolean, numberOfDraws: number, numberOfSpots: number, addOns: Array<{ name: string, value: string }>, price: { currency: string, value: number }, wager: { currency: string, value: number }, numbers: Array<{ name: string, values: Array<{ value: number, matching: boolean | null }> }>, ticketScans: { expirationDate: string, front: { blurHash: string, height: number, width: number, url: string }, back: { blurHash: string, height: number, width: number, url: string } } | null, draws: Array<{ id: string, orderId: string, participationId: string, number: number, results: Array<{ name: string, values: Array<{ value: number, matching: boolean | null }> }>, status:
          | { status: Types.HighFrequency_DrawStatusEnum }
          | { resumesAt: string, status: Types.HighFrequency_DrawStatusEnum }
          | { drawsAt: string, status: Types.HighFrequency_DrawStatusEnum }
          | { status: Types.HighFrequency_DrawStatusEnum }
        , winnings: { isBigWin: boolean, pariMutuel: boolean, amount: { currency: string, value: number } } | null }>, nextDraw: { id: string, orderId: string, participationId: string, number: number, status:
          | { status: Types.HighFrequency_DrawStatusEnum }
          | { resumesAt: string, status: Types.HighFrequency_DrawStatusEnum }
          | { drawsAt: string, status: Types.HighFrequency_DrawStatusEnum }
          | { status: Types.HighFrequency_DrawStatusEnum }
         } | null, totalWinnings: { isBigWin: boolean, pariMutuel: boolean, amount: { currency: string, value: number } } | null }
    | { errors: Array<{ message: string }> }
   };

export type LotteryQueryVariables = Exact<{
  licensedTerritory: string;
  lotteryId: Types.LotteryId;
}>;


export type LotteryQuery = { lottery: { id: Types.LotteryId, properties: Array<Types.LotteryProperty>, currentConfig: { allowedPlays: Array<number>, isLockoutLottery: boolean, numberOfDraws: Array<number>, subscriptionsAllowed: boolean, type: Types.LotteryType, version: string, addOns: Array<{ mandatory: boolean, name: string, options: Array<string>, perPlay: boolean }>, afterPurchaseAddOns: Array<{ mandatory: boolean, name: string, options: Array<string>, perPlay: boolean }>, prepaidSubscription: { customDrawsMax: number, customDrawsMin: number, selectableDrawsOptions: Array<number> } | null, numbers: Array<{ max: number, min: number, name: string, selectableMax: number, ignoredForAddOns: Array<{ name: string, value: string }> }>, prizeTierCategories: Array<{ group: string, name: string, categoryRequirements: Array<
          | { type: Types.PrizeTierCategoryRequirementsPayloadType }
          | { __typename: 'ByAddOnSelected', addOnName: string, type: Types.PrizeTierCategoryRequirementsPayloadType }
          | { __typename: 'ByMultiplierDeselected', addOnName: string, type: Types.PrizeTierCategoryRequirementsPayloadType }
          | { __typename: 'ByMultiplierSelected', addOnName: string, reference: string, value: number, type: Types.PrizeTierCategoryRequirementsPayloadType }
          | { __typename: 'ByMultiplierValueMatched', addOnName: string, value: number, type: Types.PrizeTierCategoryRequirementsPayloadType }
          | { type: Types.PrizeTierCategoryRequirementsPayloadType }
        >, prizeTiers: Array<{ jackpot: boolean, payoutInterval: Types.PayoutInterval, tier: string, type: Types.PrizeTierType, amount: { currency: string, value: number } | null, requirements:
            | { type: Types.PrizeTierRequirementsPayloadType }
            | { type: Types.PrizeTierRequirementsPayloadType }
            | { type: Types.PrizeTierRequirementsPayloadType }
            | { type: Types.PrizeTierRequirementsPayloadType, numberRequirements: Array<{ amountOfCorrectNumbers: number, numbersReference: string }> }
            | { type: Types.PrizeTierRequirementsPayloadType, pickRequirements: Array<{ betType: string, ignoreFields: Array<string> }> }
           }> }>, quickPick: { plays: number, validQuickPickPlays: Array<number>, addOns: Array<{ name: string, value: string }> } | null, stakes: Array<{ price: string }> }, priceList: { lotteryId: Types.LotteryId, salesTaxStrategy: Types.SalesTaxStrategy, version: string, charges: Array<
        | { id: string, perPlay: boolean, type: Types.PriceType, value: { currency: string, value: number } }
        | { id: string, perPlay: boolean, type: Types.PriceType, multiplier: number }
      >, fees: Array<
        | { id: string, perPlay: boolean, type: Types.PriceType, value: { currency: string, value: number } }
        | { id: string, perPlay: boolean, type: Types.PriceType, multiplier: number }
      > } } };

export type NextDrawQueryVariables = Exact<{
  licensedTerritory: string;
  lotteryId: Types.LotteryId;
}>;


export type NextDrawQuery = { nextDraw: { drawDate: string, jackpots: Array<{ value: { currency: string, value: number } }> } | null };

export type OrderTypeQueryVariables = Exact<{
  orderId: string;
}>;


export type OrderTypeQuery = { orderType: { type: Types.PlaySlipType } };

export type PlaySlipOrdersQueryVariables = Exact<{
  filter: Types.PlaySlipOrdersFilterInput;
  limit: number;
  offset: number;
}>;


export type PlaySlipOrdersQuery = { playSlipOrders: { count: number, playSlipOrders: Array<
      | { hasWinnings: boolean, id: string, orderId: string, lastDrawDate: string, licensedTerritory: string, lotteryId: Types.LotteryId, nextDrawDate: string, numberOfExtraHitPlays: number, numberOfPlays: number, selectedAddOns: Array<string>, status: Types.PlaySlipOrderStatus, totalWinAmount: { currency: string, value: number }, subscriptionInfo: { status: Types.SubscriptionStatus } | null }
      | { hasWinnings: boolean, id: string, orderId: string, lastDrawDate: string, licensedTerritory: string, lotteryId: Types.LotteryId, nextDrawDate: string, numberOfExtraHitPlays: number, numberOfPlays: number, selectedAddOns: Array<string>, status: Types.PlaySlipOrderStatus, totalWinAmount: { currency: string, value: number }, subscriptionInfo: { status: Types.SubscriptionStatus } | null }
      | { id: string, orderId: string, lastDrawDate: string, licensedTerritory: string, lotteryId: Types.LotteryId, nextDrawDate: string, numberOfExtraHitPlays: number, numberOfPlays: number, selectedAddOns: Array<string>, status: Types.PlaySlipOrderStatus, subscriptionInfo: { status: Types.SubscriptionStatus } | null }
    > } };

export type ProductCatalogQueryVariables = Exact<{
  licensedTerritory: string;
  productType: Types.KnownProductType;
}>;


export type ProductCatalogQuery = { productCatalog:
    | { errors: Array<{ __typename: 'ProductCatalogError_Failed', message: string }> }
    | { elements: Array<
        | { __typename: 'FreeToPlayTeaserPayload', id: string }
        | { __typename: 'HighFrequencyTeaserPayload', id: string, jackpotType: Types.JackpotType, operating: boolean, jackpotSize: { currency: string, value: number }, campaign:
            | { bonusCode: string | null, infoHeadline: string | null, infoText: string | null, title: string, type: Types.BadgeType }
            | { pattern: Types.HeroHighlightPattern, badge: { bonusCode: string | null, color: string, infoHeadline: string | null, infoText: string | null, placement: Types.HeroHighlightStyle, title: string, subtitle: string } }
           | null, operatingHours: { nextStart: string, nextEndInclusive: string } }
        | { __typename: 'LotteryTeaserPayload', closingDate: string, comingSoon: boolean, drawDate: string, id: string, jackpotType: Types.JackpotType, lotteryType: Types.LotteryType, campaign:
            | { bonusCode: string | null, infoHeadline: string | null, infoText: string | null, title: string, type: Types.BadgeType }
            | { pattern: Types.HeroHighlightPattern, badge: { bonusCode: string | null, color: string, infoHeadline: string | null, infoText: string | null, placement: Types.HeroHighlightStyle, title: string, subtitle: string } }
           | null, jackpotSize: { __typename: 'Money', currency: string, value: number }, quickPick: { __typename: 'QuickPickConfiguration', plays: number, addOns: Array<{ __typename: 'AddOnOutput', name: string, value: string }> } | null }
        | { __typename: 'ScratchcardTeaserPayload', name: string, slug: string, amount: { currency: string, value: number } | null, campaign:
            | { bonusCode: string | null, infoHeadline: string | null, infoText: string | null, title: string, type: Types.BadgeType }
            | { pattern: Types.HeroHighlightPattern, badge: { bonusCode: string | null, color: string, infoHeadline: string | null, infoText: string | null, placement: Types.HeroHighlightStyle, title: string, subtitle: string } }
           | null, price: { currency: string, value: number } | null, visualParameters: { primaryColor: string | null, secondaryColor: string | null, teaserImageUrl: string | null, titleColor: string } | null }
      > }
   };

export type RecommendationElementsQueryVariables = Exact<{
  licensedTerritory: string;
}>;


export type RecommendationElementsQuery = { recommendationElements:
    | { errors: Array<{ message: string }> }
    | { elements: Array<
        | { __typename: 'FreeToPlayTeaserPayload', id: string }
        | { __typename: 'HighFrequencyTeaserPayload', id: string, jackpotType: Types.JackpotType, operating: boolean, jackpotSize: { currency: string, value: number }, campaign:
            | { bonusCode: string | null, infoHeadline: string | null, infoText: string | null, title: string, type: Types.BadgeType }
            | { pattern: Types.HeroHighlightPattern, badge: { bonusCode: string | null, color: string, infoHeadline: string | null, infoText: string | null, placement: Types.HeroHighlightStyle, title: string, subtitle: string } }
           | null, operatingHours: { nextStart: string, nextEndInclusive: string } }
        | { __typename: 'LotteryTeaserPayload', closingDate: string, comingSoon: boolean, drawDate: string, id: string, jackpotType: Types.JackpotType, lotteryType: Types.LotteryType, campaign:
            | { bonusCode: string | null, infoHeadline: string | null, infoText: string | null, title: string, type: Types.BadgeType }
            | { pattern: Types.HeroHighlightPattern, badge: { bonusCode: string | null, color: string, infoHeadline: string | null, infoText: string | null, placement: Types.HeroHighlightStyle, title: string, subtitle: string } }
           | null, jackpotSize: { __typename: 'Money', currency: string, value: number }, quickPick: { __typename: 'QuickPickConfiguration', plays: number, addOns: Array<{ __typename: 'AddOnOutput', name: string, value: string }> } | null }
        | { __typename: 'ReviewElement', id: string }
        | { __typename: 'ScratchcardTeaserPayload', name: string, slug: string, amount: { currency: string, value: number } | null, campaign:
            | { bonusCode: string | null, infoHeadline: string | null, infoText: string | null, title: string, type: Types.BadgeType }
            | { pattern: Types.HeroHighlightPattern, badge: { bonusCode: string | null, color: string, infoHeadline: string | null, infoText: string | null, placement: Types.HeroHighlightStyle, title: string, subtitle: string } }
           | null, price: { currency: string, value: number } | null, visualParameters: { primaryColor: string | null, secondaryColor: string | null, teaserImageUrl: string | null, titleColor: string } | null }
        | { __typename: 'WelcomeToWineverElement', id: string }
        | { __typename: 'WinnerTrustElement', id: string }
        | Record<PropertyKey, never>
      > }
   };

export type RecommendationsQueryVariables = Exact<{
  licensedTerritory: string;
  purchasedProductType: Types.KnownProductType;
  purchasedProductSubtype: string;
}>;


export type RecommendationsQuery = { recommendations: { id: string, teasers: Array<
      | { __typename: 'FreeToPlayTeaserPayload', id: string }
      | { __typename: 'HighFrequencyTeaserPayload', id: string, jackpotType: Types.JackpotType, operating: boolean, jackpotSize: { currency: string, value: number }, campaign:
          | { bonusCode: string | null, infoHeadline: string | null, infoText: string | null, title: string, type: Types.BadgeType }
          | { pattern: Types.HeroHighlightPattern, badge: { bonusCode: string | null, color: string, infoHeadline: string | null, infoText: string | null, placement: Types.HeroHighlightStyle, title: string, subtitle: string } }
         | null, operatingHours: { nextStart: string, nextEndInclusive: string } }
      | { __typename: 'LotteryTeaserPayload', closingDate: string, comingSoon: boolean, drawDate: string, id: string, jackpotType: Types.JackpotType, lotteryType: Types.LotteryType, campaign:
          | { bonusCode: string | null, infoHeadline: string | null, infoText: string | null, title: string, type: Types.BadgeType }
          | { pattern: Types.HeroHighlightPattern, badge: { bonusCode: string | null, color: string, infoHeadline: string | null, infoText: string | null, placement: Types.HeroHighlightStyle, title: string, subtitle: string } }
         | null, jackpotSize: { __typename: 'Money', currency: string, value: number }, quickPick: { __typename: 'QuickPickConfiguration', plays: number, addOns: Array<{ __typename: 'AddOnOutput', name: string, value: string }> } | null }
      | { __typename: 'ScratchcardTeaserPayload', name: string, slug: string, amount: { currency: string, value: number } | null, campaign:
          | { bonusCode: string | null, infoHeadline: string | null, infoText: string | null, title: string, type: Types.BadgeType }
          | { pattern: Types.HeroHighlightPattern, badge: { bonusCode: string | null, color: string, infoHeadline: string | null, infoText: string | null, placement: Types.HeroHighlightStyle, title: string, subtitle: string } }
         | null, price: { currency: string, value: number } | null, visualParameters: { primaryColor: string | null, secondaryColor: string | null, teaserImageUrl: string | null, titleColor: string } | null }
    > } };

export type RedeemMoneyMutationVariables = Exact<{
  input: Types.MoneyBackInput;
}>;


export type RedeemMoneyMutation = { requestMoneyBack: { code: string, id: string, productId: string, status: Types.MoneyBackStatus, price: { currency: string, value: number } } };

export type RemoveBonusCodeMutationVariables = Exact<{
  bonusCode: string;
  productId: string;
}>;


export type RemoveBonusCodeMutation = { removeBonusCode: { bonusCode: string } };

export type ReplayPlaySlipMutationVariables = Exact<{
  licensedTerritory: string;
  playSlipOrderId?: string | null | undefined;
}>;


export type ReplayPlaySlipMutation = { replayPlaySlip: { id: string } };

export type ReserveScratchcardsMutationVariables = Exact<{
  input: Types.ReserveScratchcardsInput;
}>;


export type ReserveScratchcardsMutation = { reserveScratchcards: { reservationId: string | null, quantity: number | null, restrictions: { geoCheck: Types.GeoCheckStatus, playerCheck: Types.PlayerCheckStatus, depositLimit: { period: Types.LimitPeriod, type: Types.LimitType, available: { currency: string, value: number }, value: { currency: string, value: number } } | null, spendingLimit: { period: Types.LimitPeriod, type: Types.LimitType, available: { currency: string, value: number }, value: { currency: string, value: number } } | null } | null } };

export type RevealScratchcardMutationVariables = Exact<{
  input: Types.RevealScratchcardInput;
}>;


export type RevealScratchcardMutation = { revealScratchcard: { freeTickets: number, isBigWin: boolean, prizeTier: number | null, amount: { currency: string, value: number } | null } };

export type RevealScratchcardOrderMutationVariables = Exact<{
  input: Types.RevealOrderInput;
}>;


export type RevealScratchcardOrderMutation = { revealOrder: { gameName: string, orderId: string, quantity: number, quantityActive: number, state: Types.ScratchcardState, winnings: { currency: string, value: number } | null, scratchcards: Array<{ image: string | null, serialNumber: string, status: Types.ScratchcardState, winningsPayload: { freeTickets: number, isBigWin: boolean, amount: { currency: string, value: number } | null } | null }> } };

export type ScheduledDrawsQueryVariables = Exact<{
  licensedTerritory: string;
  limit: number;
  lotteryId: Types.LotteryId;
}>;


export type ScheduledDrawsQuery = { scheduledDraws: Array<{ closingDate: string, drawDate: string, lotteryConfig: { currentConfig: { type: Types.LotteryType } }, jackpots: Array<{ value: { currency: string, value: number } }> }> };

export type ScratchcardOrderQueryVariables = Exact<{
  orderId: string;
}>;


export type ScratchcardOrderQuery = { scratchcardOrder: { gameName: string, licensedTerritory: string, orderedDate: string, orderId: string, quantity: number, quantityActive: number, quantityRevealed: number, state: Types.ScratchcardState, price: { currency: string, value: number }, scratchcards: Array<{ image: string | null, processedDate: string | null, serialNumber: string, status: Types.ScratchcardState, images: { back: string, backCreationDate: string, linkExpiresAt: string, scratched: string, scratchedCreationDate: string, unscratched: string, unscratchedCreationDate: string, backImageProperties: { blurHash: string, height: number, width: number }, scratchedImageProperties: { blurHash: string, height: number, width: number }, unscratchedImageProperties: { blurHash: string, height: number, width: number } } | null, winningsPayload: { freeTickets: number, isBigWin: boolean, amount: { currency: string, value: number } | null } | null }>, visualParameters: { autoReveal: boolean, autoRevealPercentage: number | null, primaryColor: string | null, scratchArea: Types.ScratchArea | null, secondaryColor: string | null, titleColor: string, scratchAreas: Array<{ height: number, width: number, x: number, y: number }> | null }, winningsPayload: { freeTickets: number, isBigWin: boolean, amount: { currency: string, value: number } | null } | null } };

export type ScratchcardTeasersQueryVariables = Exact<{
  licensedTerritory: string;
}>;


export type ScratchcardTeasersQuery = { scratchcardTeasers: Array<{ name: string, slug: string, pricePerCard: { currency: string, value: number }, value: { currency: string, value: number }, visualParameters: { primaryColor: string | null, secondaryColor: string | null, teaserImage: string | null, titleColor: string } }> };

export type SingleOrderMultipleLinesQueryVariables = Exact<{
  orderId: string;
  limitPlays?: number | null | undefined;
  offsetPlays?: number | null | undefined;
  groupOfPlays?: string | null | undefined;
}>;


export type SingleOrderMultipleLinesQuery = { singleOrderMultipleLines: { id: string, nextDrawDate: string | null, numberOfExtraHitPlays: number, numberOfPlays: number, orderedIn: string, orderId: string, state: string, type: Types.PlaySlipType, lottery: { active: boolean, id: Types.LotteryId, licensedTerritory: string, currentConfig: { type: Types.LotteryType, addOns: Array<{ name: string, perPlay: boolean }>, afterPurchaseAddOns: Array<{ name: string, perPlay: boolean }>, numbers: Array<{ name: string, selectableMax: number }> } }, price: { currency: string, value: number }, results: Array<{ drawDate: string, hasWinnings: boolean, hasMultipleDrawsOnDay: boolean, label: Types.DrawLabel, ticketScanUrlsExpirationDate: string, totalNumberOfFreePlays: number | null, lotteryResults: Array<{ countOfPlays: number, group: string, drawnNumbers: { numbers: Array<{ modifies: string | null, name: string, values: Array<number> }> } | null, plays: Array<
          | { __typename: 'BasePlayMultipleLines', serialNumber: string, state: Types.PlaySlipStatus, addOns: Array<{ name: string, value: string }>, addOnValues: Array<{ name: string, value: string }>, fields: Array<{ name: string, numbers: Array<{ matching: boolean, value: number }> }>, winnings: { numberOfFreePlays: number | null, amount: { currency: string, value: number } | null } }
          | { __typename: 'ExtraPlayMultipleLines', serialNumber: string, state: Types.PlaySlipStatus, plays: Array<{ addOns: Array<{ name: string, value: string }>, addOnValues: Array<{ name: string, value: string }>, fields: Array<{ name: string, numbers: Array<{ matching: boolean, value: number }> }>, winnings: { numberOfFreePlays: number | null, amount: { currency: string, value: number } | null } }>, addOns: Array<{ name: string, value: string }>, addOnValues: Array<{ name: string, value: string }>, fields: Array<{ name: string, numbers: Array<{ matching: boolean, value: number }> }>, winnings: { numberOfFreePlays: number | null, amount: { currency: string, value: number } | null } }
        > }>, ticketScans: Array<{ serialNumber: string, scans: Array<{ url: string, imageProperties: { blurHash: string, height: number, width: number } }> }>, totalWinnings: { currency: string, value: number } | null }> } };

export type StorePlaySlipMutationVariables = Exact<{
  input: Types.PlaySlipInput;
}>;


export type StorePlaySlipMutation = { storePlaySlip: { id: string } };

export type SubscriptionOrderMultipleLinesQueryVariables = Exact<{
  orderId: string;
  limitPlays?: number | null | undefined;
  offsetPlays?: number | null | undefined;
  limitDrawResults?: number | null | undefined;
  offsetDrawResults?: number | null | undefined;
  drawDateOfPlays?: string | null | undefined;
  groupOfPlays?: string | null | undefined;
}>;


export type SubscriptionOrderMultipleLinesQuery = { subscriptionOrderMultipleLines: { id: string, lastDrawDate: string, latestPlaySlipOrderId: string, nextDrawDate: string | null, numberOfExtraHitPlays: number, numberOfPlays: number, orderedIn: string, status: Types.SubscriptionStatus, subscriptionCode: string, totalDrawResults: number, type: Types.PlaySlipType, lottery: { active: boolean, id: Types.LotteryId, licensedTerritory: string, currentConfig: { type: Types.LotteryType, addOns: Array<{ name: string, perPlay: boolean }>, afterPurchaseAddOns: Array<{ name: string, perPlay: boolean }>, numbers: Array<{ name: string, selectableMax: number }> } }, price: { currency: string, value: number }, results: Array<{ drawDate: string, hasWinnings: boolean, hasMultipleDrawsOnDay: boolean, label: Types.DrawLabel, ticketScanUrlsExpirationDate: string, totalNumberOfFreePlays: number | null, lotteryResults: Array<{ countOfPlays: number, group: string, drawnNumbers: { numbers: Array<{ modifies: string | null, name: string, values: Array<number> }> } | null, plays: Array<
          | { __typename: 'BasePlayMultipleLines', serialNumber: string, state: Types.PlaySlipStatus, addOns: Array<{ name: string, value: string }>, addOnValues: Array<{ name: string, value: string }>, fields: Array<{ name: string, numbers: Array<{ matching: boolean, value: number }> }>, winnings: { numberOfFreePlays: number | null, amount: { currency: string, value: number } | null } }
          | { __typename: 'ExtraPlayMultipleLines', serialNumber: string, state: Types.PlaySlipStatus, plays: Array<{ addOns: Array<{ name: string, value: string }>, addOnValues: Array<{ name: string, value: string }>, fields: Array<{ name: string, numbers: Array<{ matching: boolean, value: number }> }>, winnings: { numberOfFreePlays: number | null, amount: { currency: string, value: number } | null } }>, addOns: Array<{ name: string, value: string }>, addOnValues: Array<{ name: string, value: string }>, fields: Array<{ name: string, numbers: Array<{ matching: boolean, value: number }> }>, winnings: { numberOfFreePlays: number | null, amount: { currency: string, value: number } | null } }
        > }>, ticketScans: Array<{ serialNumber: string, scans: Array<{ url: string, imageProperties: { blurHash: string, height: number, width: number } }> }>, totalWinnings: { currency: string, value: number } | null }>, prepaidOptions: { participatedDraws: number, remainingDraws: number, totalDraws: number } | null } };

export type SubscriptionsMultipleLinesQueryVariables = Exact<{
  filter: Types.SubscriptionsFilterInput;
  limit: number;
  offset: number;
}>;


export type SubscriptionsMultipleLinesQuery = { subscriptionsMultipleLines: { count: number, subscriptions: Array<{ code: string, id: string, lastDrawDate: string, latestOrderId: string, latestPlaySlipOrderId: string | null, licensedTerritory: string, lotteryId: Types.LotteryId, nextDrawDate: string | null, numberOfExtraHitPlays: number, numberOfPlays: number, selectedAddOns: Array<string>, status: Types.SubscriptionStatus, prepaidOptions: { participatedDraws: number, remainingDraws: number, totalDraws: number } | null }> } };

export type TeasersQueryVariables = Exact<{
  licensedTerritory: string;
}>;


export type TeasersQuery = { teasers: { id: string, teasers: Array<
      | { __typename: 'FreeToPlayTeaserPayload', id: string }
      | { __typename: 'HighFrequencyTeaserPayload', id: string, jackpotType: Types.JackpotType, operating: boolean, jackpotSize: { currency: string, value: number }, campaign:
          | { bonusCode: string | null, infoHeadline: string | null, infoText: string | null, title: string, type: Types.BadgeType }
          | { pattern: Types.HeroHighlightPattern, badge: { bonusCode: string | null, color: string, infoHeadline: string | null, infoText: string | null, placement: Types.HeroHighlightStyle, title: string, subtitle: string } }
         | null, operatingHours: { nextStart: string, nextEndInclusive: string } }
      | { __typename: 'LotteryTeaserPayload', closingDate: string, comingSoon: boolean, drawDate: string, id: string, jackpotType: Types.JackpotType, lotteryType: Types.LotteryType, campaign:
          | { bonusCode: string | null, infoHeadline: string | null, infoText: string | null, title: string, type: Types.BadgeType }
          | { pattern: Types.HeroHighlightPattern, badge: { bonusCode: string | null, color: string, infoHeadline: string | null, infoText: string | null, placement: Types.HeroHighlightStyle, title: string, subtitle: string } }
         | null, jackpotSize: { __typename: 'Money', currency: string, value: number }, quickPick: { __typename: 'QuickPickConfiguration', plays: number, addOns: Array<{ __typename: 'AddOnOutput', name: string, value: string }> } | null }
      | { __typename: 'ScratchcardTeaserPayload', name: string, slug: string, amount: { currency: string, value: number } | null, campaign:
          | { bonusCode: string | null, infoHeadline: string | null, infoText: string | null, title: string, type: Types.BadgeType }
          | { pattern: Types.HeroHighlightPattern, badge: { bonusCode: string | null, color: string, infoHeadline: string | null, infoText: string | null, placement: Types.HeroHighlightStyle, title: string, subtitle: string } }
         | null, price: { currency: string, value: number } | null, visualParameters: { primaryColor: string | null, secondaryColor: string | null, teaserImageUrl: string | null, titleColor: string } | null }
    > } };

export type HighFrequencyResultsAndWinnersQueryVariables = Exact<{
  input: Types.HighFrequency_ResultsAndWinnersInput;
}>;


export type HighFrequencyResultsAndWinnersQuery = { highFrequencyResultsAndWinners:
    | { errors: Array<{ message: string }> }
    | { winnersCount: number, draws: Array<{ drawNumber: number, results: Array<{ name: string, values: Array<{ matching: boolean | null, value: number }> }> }>, gameConfig: { addOns: Array<{ maximumMultiplier: number | null, name: string }>, numbers: Array<{ selectableMax: number }> } | null }
   };

export type HighFrequencyRevealDrawParticipationMutationVariables = Exact<{
  input: Types.HighFrequencyRevealDrawParticipationInput;
}>;


export type HighFrequencyRevealDrawParticipationMutation = { highFrequencyRevealDrawParticipation:
    | { gameId: Types.HighFrequency_GameId, orderedIn: string, orderId: string, addOns: Array<{ name: string, value: string }>, draw: { id: string, orderId: string, participationId: string, number: number, results: Array<{ name: string, values: Array<{ matching: boolean | null, value: number }> }>, status:
          | { status: Types.HighFrequency_DrawStatusEnum }
          | { resumesAt: string, status: Types.HighFrequency_DrawStatusEnum }
          | { status: Types.HighFrequency_DrawStatusEnum, drawsAt: string }
          | { status: Types.HighFrequency_DrawStatusEnum }
        , winnings: { isBigWin: boolean, pariMutuel: boolean, amount: { currency: string, value: number } } | null }, nextDraw: { id: string, orderId: string, participationId: string, number: number, status:
          | { status: Types.HighFrequency_DrawStatusEnum }
          | { resumesAt: string, status: Types.HighFrequency_DrawStatusEnum }
          | { status: Types.HighFrequency_DrawStatusEnum, drawsAt: string }
          | { status: Types.HighFrequency_DrawStatusEnum }
         } | null, numbers: Array<{ name: string, values: Array<{ matching: boolean | null, value: number }> }> }
    | { errors: Array<{ __typename: 'HighFrequency_RevealError', message: string }> }
   };

export type HighFrequencyStorePlaySlipMutationVariables = Exact<{
  input: Types.HighFrequency_PlaySlipInput;
}>;


export type HighFrequencyStorePlaySlipMutation = { highFrequencyStorePlaySlip:
    | { __typename: 'HighFrequency_PlaySlipStored', id: string }
    | { __typename: 'HighFrequency_PlaySlipStoredErrors', errors: Array<
        | { __typename: 'HighFrequency_PlaySlipStoredError_DisclaimerNotAccepted' }
        | { __typename: 'HighFrequency_PlaySlipStoredError_InvalidPlaySlip' }
        | { __typename: 'HighFrequency_PlaySlipStoredError_MaxPlaySlipPriceExceeded', maxPlaySlipPrice: { currency: string, value: number } }
        | { __typename: 'HighFrequency_PlaySlipStoredError_PlayerCannotPlay' }
        | { __typename: 'HighFrequency_PlaySlipStoredError_PlayerRestricted', accountBalance: { currency: string, value: number }, grossTotal: { currency: string, value: number }, restrictions: { geoCheck: Types.GeoCheckStatus, playerCheck: Types.PlayerCheckStatus, depositLimit: { period: Types.LimitPeriod, type: Types.LimitType, available: { currency: string, value: number }, value: { currency: string, value: number } } | null, spendingLimit: { period: Types.LimitPeriod, type: Types.LimitType, available: { currency: string, value: number }, value: { currency: string, value: number } } | null } }
        | { __typename: 'HighFrequency_PlaySlipStoredError_UnexpectedError' }
      > }
   };

export type HighFrequencyWatchDrawQueryVariables = Exact<{
  gameId: Types.HighFrequency_GameId;
}>;


export type HighFrequencyWatchDrawQuery = { highFrequencyWatchDraw:
    | { errors: Array<{ message: string }> }
    | { id: string, number: number, nextDraw: { id: string, number: number, status:
          | { status: Types.HighFrequency_DrawStatusEnum }
          | { resumesAt: string, status: Types.HighFrequency_DrawStatusEnum }
          | { drawsAt: string, status: Types.HighFrequency_DrawStatusEnum }
          | { status: Types.HighFrequency_DrawStatusEnum }
         }, results: Array<{ name: string, values: Array<{ value: number }> }>, status:
        | { status: Types.HighFrequency_DrawStatusEnum }
        | { resumesAt: string, status: Types.HighFrequency_DrawStatusEnum }
        | { drawsAt: string, status: Types.HighFrequency_DrawStatusEnum }
        | { status: Types.HighFrequency_DrawStatusEnum }
       }
   };

export type LotteriesQueryVariables = Exact<{
  licensedTerritory: string;
}>;


export type LotteriesQuery = { lotteries: Array<{ __typename: 'LotteryPayload', id: Types.LotteryId, currentConfig: { __typename: 'VersionedConfig', jackpotType: Types.JackpotType } }> };

export type ResultDetailsQueryVariables = Exact<{
  id: string;
}>;


export type ResultDetailsQuery = { drawDetail: { addOns: Array<string>, drawDate: string, hasMultipleDrawsOnDay: boolean, label: Types.DrawLabel, lotteryId: Types.LotteryId, drawnNumbers: Array<{ group: string, numbers: Array<{ modifies: string | null, name: string, values: Array<number> }> }>, lotteryConfig: { timeZone: string, currentConfig: { combinedTierTable: boolean, hasNumberOfWinners: boolean, type: Types.LotteryType, addOns: Array<{ mandatory: boolean, name: string, options: Array<string>, perPlay: boolean }>, afterPurchaseAddOns: Array<{ mandatory: boolean, name: string, options: Array<string>, perPlay: boolean }>, prizeTierCategories: Array<{ group: string, name: string, categoryRequirements: Array<
            | { type: Types.PrizeTierCategoryRequirementsPayloadType }
            | { __typename: 'ByAddOnSelected', addOnName: string, type: Types.PrizeTierCategoryRequirementsPayloadType }
            | { __typename: 'ByMultiplierDeselected', addOnName: string, type: Types.PrizeTierCategoryRequirementsPayloadType }
            | { __typename: 'ByMultiplierSelected', addOnName: string, reference: string, value: number, type: Types.PrizeTierCategoryRequirementsPayloadType }
            | { __typename: 'ByMultiplierValueMatched', addOnName: string, value: number, type: Types.PrizeTierCategoryRequirementsPayloadType }
            | { type: Types.PrizeTierCategoryRequirementsPayloadType }
          >, prizeTiers: Array<{ jackpot: boolean, payoutInterval: Types.PayoutInterval, tier: string, type: Types.PrizeTierType, amount: { currency: string, value: number } | null, requirements:
              | { type: Types.PrizeTierRequirementsPayloadType }
              | { type: Types.PrizeTierRequirementsPayloadType }
              | { type: Types.PrizeTierRequirementsPayloadType }
              | { type: Types.PrizeTierRequirementsPayloadType, numberRequirements: Array<{ amountOfCorrectNumbers: number, numbersReference: string }> }
              | { type: Types.PrizeTierRequirementsPayloadType, pickRequirements: Array<{ betType: string, ignoreFields: Array<string> }> }
             }> }> } }, prizeCategories: Array<{ group: string, name: string, prizes: Array<
        | { tier: string, type: Types.PrizeTierType, winners: number, prize: { currency: string, value: number } | null }
        | { tier: string, type: Types.PrizeTierType, winners: number, prize: { currency: string, value: number } }
      > }> } };

export type ScratchcardGameQueryVariables = Exact<{
  licensedTerritory: string;
  slug: string;
}>;


export type ScratchcardGameQuery = { scratchcardGame: { available: number, enabled: boolean, name: string, slug: string, priceList: { currency: string, salesTaxStrategy: string, chargePerCard: { currency: string, value: number }, chargePerOrder: { currency: string, value: number }, feePerCard: { currency: string, value: number }, feePerOrder: { currency: string, value: number } }, prizeTiers: Array<{ tier: number, prize: { currency: string, value: number } }>, visualParameters: { primaryColor: string | null, secondaryColor: string | null, teaserImage: string | null, titleColor: string } } };

export type ScratchcardOrdersQueryVariables = Exact<{
  filter: Types.ScratchcardsFilterInput;
  limit: number;
  offset: number;
}>;


export type ScratchcardOrdersQuery = { scratchcardOrders: { count: number, scratchcardOrders: Array<{ gameName: string, gameSlug: string, orderId: string, quantity: number, quantityActive: number, quantityPast: number, state: Types.ScratchcardState, titleColor: string, winningsPayload: { freeTickets: number, amount: { currency: string, value: number } | null } | null }> } };
